const ruRu = {
  "menu.overview": "Обзор",
  "menu.sales": "Продажи",
  "menu.inventory-management": "Склад и товары",
  "menu.crm": "Клиенты и партнеры",
  "menu.finance": "Финансы и налоги",
  "menu.utilities": "Утилиты",
  "product.tax-rate": "Ставка налога",
  "table.import.tax-rate": "Ставка налога (%)",
  /* 00.General */
  "general.copyright": "Управление кофейней © 2019 Все права защищены.",
  "general.refresh": "Обновить списки",
  "general.btn-update": "Обновить",
  "general.btn-update-count": "Обновить счетчик",
  "general.btn-add": "Добавить",
  "general.btn-order": "Заказать сейчас!",
  "general.btn-order-preview": "Просмотр товара",
  "general.product-unit": "товаров",
  "general.btn-create-make-product": "Создать карту тех. процесса",
  "general.btn-update-make-product": "Обновить карту тех. процесса",
  "general.btn-cancel": "Отмена",
  "role.default.cashier": "Кассир",
  "role.default.kitchen": "Бар / Кухня",
  "role.default.table-pending-payment": "Официант",
  "general.info": "ИНФОРМАЦИЯ",
  "general.setting": "НАСТРОЙКИ",
  "general.function": "ФУНКЦИИ",
  timeCreated: "Время создания",
  "print.cashier": "Кассир",
  "print.invoice": "Счет",
  "print.name-product": "Название",
  "print.quantity": "Кол-во",
  "print.price": "Цена",
  "print.total-price": "Итого",
  "print.discount": "Скидка",
  "print.tax": "Налог",
  "print.fee-other": "Сбор",
  "print.shipping": "Доставка",
  "print.amount-to-pay": "К оплате",
  "print.info-bill": "Информация о счете",
  "print.thank-you": "Большое спасибо!",
  "print.copy-right": "Авторское право vmass.vn.",

  /* 01.Order */
  "order.to-pending": "На кухню",
  "order.to-done": "К оплате",
  "order.done": "Готово",
  "order.to-refund": "Возврат",
  "order.to-change": "Изменить",
  "order.to-bill-draft": "Печать предв. счета",
  "order.to-bill": "Печать счета",
  "order.to-end": "Завершено",
  "order.print-bill": "Печать счета",
  "order.to-excel": "Скачать Excel",
  "order.to-destroy": "Уничтожить",
  "order.transfer-table": "Перенос стола",
  "order.to-bill-now": "Печать",
  "order.to-bill-all": "Печать всего",
  "order.open-menu": "Добавить товар",
  "order.search": "Поиск счетов",
  "order.list-product-in-table": "Список товаров на столе",

  /* 02. Profile */
  "company-uuid": "Код магазина",
  "company-name": "Название магазина",
  "profile.fullname": "ФИО",
  "profile.username": "Имя пользователя",
  "profile.email": "Email",
  "profile.address": "Адрес",
  "profile.description": "Описание",
  "profile.avatar": "Аватар",
  "profile.company-address": "Адрес компании",
  "profile.company-website": "Веб-сайт",
  "profile.company-logo": "Логотип магазина",
  "profile.company-image": "Обложка магазина",
  "profile.company-start-time": "Время открытия",
  "profile.company-end-time": "Время закрытия",
  "profile.company-menu-hash": "Код меню магазина",
  "profile.company-menu-hash-create": "Добавить новый",
  "profile.phone": "Телефон",
  "profile.birth-day": "День рождения",
  "profile.btn-update": "Обновить",
  "pages.responsibilities": "Специализация",
  "menu.contact": "Соцсети",
  "profile.update-personal": "Обновить личную инфо",
  "profile.update-company": "Обновить инфо о компании",
  "profile.companyName": "Название магазина",
  "profile.bankPay": "Название банка",
  "profile.namePay": "Имя владельца счета",
  "profile.numberPay": "Номер счета",

  /* 03.User Login, Logout, Register */
  "user.login-title": "Вход",
  "user.register": "Регистрация",
  "user.forgot-password": "Забыли пароль",
  "user.username": "Имя пользователя",
  "user.email": "Email",
  "user.phone": "Телефон",
  "user.password": "Пароль",
  "user.re-password": "Повт. пароль",
  "user.forgot-password-question": "Забыли пароль?",
  "user.reset-password-button": "Получить новый код",
  "user.reset-password-button-submit": "Изменить пароль",
  "user.fullname": "ФИО",
  "user.login-button": "Войти",
  "user.register-button": "Регистрация",
  "user.no-account": "Нет аккаунта? ",
  "user.register-link": "Зарегистрироваться",
  "user.code": "Код",

  /* 04.Menu */
  "menu.partner": "Личный",
  "menu.money": "Финансы",
  "menu.m": "Товар",
  "menu.warehouse": "Инвентарь",
  "menu.invoice": "Счет",
  "menu.sales-invoice": "Счета продаж",
  "menu.einvoice": "Электронные счета",
  "menu.order": "Счет",
  "menu.app": "Главная",
  "menu.affiliates": "Партнеры",
  "menu.affiliate-list": "Список партнеров",
  "menu.affiliate-payouts": "Выплаты партнерам",
  "menu.affiliate-commission": "Конфиг. комиссии",
  "menu.affiliate-reports": "Отчеты партнеров",
  "menu.affiliate-fraud": "Контроль мошенничества",
  "menu.calendars": "Календарь",
  "menu.analytics": "Аналитика",
  "menu.faq": "FAQ",
  "menu.view": "Вопросы и ответы",
  "menu.default": "Общий",
  "menu.content": "Контент",
  "menu.product": "Продукт",
  "menu.menu": "Продукт",
  "menu.pages": "Менеджер",
  "menu.thumb-list": "Управление товарами",
  // 'menu.order': 'Order',
  "menu.search": "Поиск",
  "menu.login": "Вход",
  "menu.register": "Регистрация",
  "menu.company": "Информация о магазине",
  "menu.profile": "Информация",
  "menu.forgot-password": "Смена пароля",
  "menu.applications": "Аккаунт",
  "menu.promotion": "Акция",
  "menu.todo": "Событие",
  "menu.category": "Тип товара",
  "menu.ui": "Интерфейс",
  "menu.table-setting": "Столы и стулья",
  "menu.stock": "Склад",
  "menu.warehouse-import": "Поступление",
  "menu.warehouse-export": "Выдача",
  "menu.warehouse-transfer": "Накладная на перемещение",
  "menu.make-product": "Количественный",
  "menu.payment": "Ожидание оплаты",
  "menu.table-pending-payment": "Ожидание оплаты",
  "menu.message": "Сообщение",
  "menu.ref": "Партнерская программа",
  "menu.upgrade": "Обновить",
  "menu.setting": "Настройка",
  "menu.root": "VMASS",
  "menu.user-staff": "Персонал",
  "menu.customer": "Клиент",
  "menu.company-provider": "Поставщик",
  "menu.treasury": "Казначейство",
  "menu.income": "Доход",
  "menu.outcome": "Расход",
  "menu.cash-flow": "Денежный поток",
  "menu.role": "Создать разрешение",
  "menu.form-dynamic": "Настроить форму",
  "menu.user-role": "Создать аккаунт",
  "menu.qrcode": "Qr код",
  "menu.companies": "Связать магазины",
  "menu.shipping": "Доставка",
  "menu.facebook-settings": "Facebook Fanpage",
  "menu.zalo-settings": "Zalo OA",
  "menu.dashboards": "Дашборды",
  "menu.calendars": "Календари",
  "menu.booking": "Бронирование",
  "menu.analytics": "Аналитика",
  "menu.pages": "Управление",
  "menu.todo": "Задачи",
  "menu.invoice": "Счет",
  "menu.promotion": "Акция",
  "menu.partner": "Партнер",
  "menu.money": "Кассовая книга",
  "menu.m": "Управление складом",
  "menu.thumb-list": "Список товаров",
  "menu.warehouse": "Склад",
  "menu.stock": "Запас",
  "menu.inventory-audit": "Аудит инвентаря",
  "menu.stock-return": "Возврат запаса",
  "menu.stock-disposal": "Списание запаса",
  "menu.stock-out": "Расход со склада",
  "stock-out.subtitle": "Управление внутренним расходом, возвратом поставщику и списанием с согласованием.",
  "stock-out.create": "Создать расход",
  "menu.table-setting": "Настройка столов",
  "menu.message": "Сообщение",
  "menu.facebook-ads": "Facebook Ads",
  "menu.fb-ads-dashboard": "Dashboard",
  "menu.fb-ads-campaigns": "Campaigns",
  "menu.applications": "Приложения",
  "menu.profile": "Профиль",
  "menu.upgrade": "Обновить",
  "menu.setting": "Настройка",
  "warehouse.export": "Экспорт запаса",
  "warehouse.transfer": "Перемещение запаса",

  /* Shift Session */
  "menu.shift-session": "Закрытие смены",
  "menu.tax-accounting": "Бухгалтерия & Налоги",
  "menu.ai-copilot": "AI Помощник",
  "shift.title": "Управление сменами",
  "shift.open": "Открыть смену",
  "shift.close": "Закрыть смену",
  "shift.current": "Текущая смена",
  "shift.history": "История смен",
  "shift.no-open": "В данный момент нет открытой смены",
  "shift.open-hint": 'Нажмите "Открыть смену" чтобы начать новую смену',
  "shift.open-modal-title": "Открыть рабочую смену",
  "shift.close-modal-title": "Закрытие смены и сверка кассы",
  "shift.detail-modal-title": "Детали смены",
  "shift.shift-name": "Название смены",
  "shift.shift-name-placeholder": "Напр.: Утренняя смена, Вечерняя смена...",
  "shift.staff-name": "Сотрудник",
  "shift.opened-at": "Время открытия",
  "shift.closed-at": "Время закрытия",
  "shift.opening-cash": "Наличные на начало смены",
  "shift.opening-cash-hint": "Сумма наличных в кассе на начало смены",
  "shift.actual-cash": "Фактические наличные на конец смены",
  "shift.actual-cash-placeholder": "Введите фактически подсчитанные наличные",
  "shift.expected-cash": "Ожидаемые наличные",
  "shift.cash-difference": "Разница",
  "shift.total-revenue": "Общая выручка",
  "shift.total-cash": "Наличные",
  "shift.total-transfer": "Банковский перевод",
  "shift.total-card": "Кредитная карта",
  "shift.total-credit": "В долг",
  "shift.total-orders": "Всего заказов",
  "shift.total-products": "Всего товаров",
  "shift.note": "Примечание",
  "shift.note-optional": "Примечание (необязательно)",
  "shift.note-explain": "Объяснение разницы",
  "shift.note-explain-required":
    "Обязательно - Укажите причину разницы в наличных",
  "shift.status": "Статус",
  "shift.status-open": "Открыта",
  "shift.status-closed": "Закрыта",
  "shift.confirm-open": "Подтвердить открытие смены",
  "shift.confirm-close": "Подтвердить закрытие смены",
  "shift.require-open": "Пожалуйста, откройте смену перед продажей",
  "shift.print": "Печать отчёта смены",
  "shift.print-title": "ОТЧЁТ О ЗАКРЫТИИ СМЕНЫ",
  "shift.revenue-in-shift": "Выручка за смену",
  "shift.cash-reconciliation": "Сверка кассы",
  "shift.cash-revenue-add": "+ Выручка наличными",
  "shift.expected-cash-equals": "= Ожидаемые наличные",
  "shift.no-data": "Данные о сменах отсутствуют",
  "shift.detail": "Подробности",
  "shift.page-prev": "← Назад",
  "shift.page-next": "Далее →",
  "shift.page-of": "Страница {current} / {total}",
  "shift.open-success": "Смена успешно открыта",
  "shift.close-success": "Смена успешно закрыта",
  "shift.open-error": "Ошибка открытия смены",
  "shift.close-error": "Ошибка закрытия смены",
  "shift.close-warn-difference":
    "Обнаружена разница в наличных. Пожалуйста, укажите объяснение перед закрытием смены.",
  "shift.store-name": "Магазин",
  "shift.copyright": "Авторские права vmass.vn",
  "shift.cancel": "Отмена",

  /* 05.Dashboards */
  "dashboards.pending-orders": "Принять заказы",
  "dashboards.completed-orders": "Завершенные заказы",
  "dashboards.refund-requests": "Возврат заказов",
  "dashboards.sales": "Принято",
  "dashboards.sales-chart": "График продаж",
  "dashboards.orders": "доставлено",
  "dashboards.refunds": "Нет в наличии",
  "dashboards.calendar": "Календарь",
  "dashboards.best-sellers": "Список проданных товаров",
  "dashboards.this-week": "Неделя",
  "dashboards.this-month": "Месяц",
  "dashboards.this-all-sales": "Вся выручка",
  "dashboards.recent-orders": "Недавние заказы",
  "dashboards.stock-status": "Статус склада",
  "dashboards.logs": "Логи",
  "dashboards.message": "Сообщение",
  "dashboards.area": "Зона",
  "dashboards.status-order": "Сводка статусов заказов",
  "dashboards.pending-order": "Список неполученных товаров",
  "dashboards.order-undelivery": "Список недоставленных товаров",
  "dashboards.order-pending-payment": "Список неоплаченных столов",
  "dashboards.total-order": "Общее количество заказанных товаров",
  "dashboards.product-not-receive": "товаров не получено",
  "dashboards.product-not-delivery": "товаров не доставлено",
  "dashboards.table-notyet-pay": "столов не оплачено",
  "dashboards.product-received-full": "Все товары получены",
  "dashboards.total-product-received": "Всего получено товаров",
  "dashboards.product-delivery-full": "Все товары доставлены",
  "dashboards.total-table-has-customer": "Всего столов с гостями за день",
  "dashboards.table-payment-full": "Оплаченные столы",
  "dashboards.list-empty": "Список пуст",
  "dashboards.total": "Итого",
  "dashboards.counter": "Стойка",
  "dashboards.table": "Стол",
  "dashboards.ice": "Лед",
  "dashboards.sugar": "Сладость",
  "dashboards.all": "ВСЕ",
  "dashboards.completed": "ЗАВЕРШЕНО",
  "dashboards.destroy": "УНИЧТОЖЕНО",
  "dashboards-empty-product": "В списке пока нет товаров",

  /** Analytics */
  "analytics.dashboards": "Обзор",
  "analytics.user-staff": "Персонал",
  "analytics.customer": "Клиент",
  "analytics.company-provider": "Поставщик",
  "analytics.treasury": "Казначейство",
  "analytics.income": "Доход",
  "analytics.outcome": "Расход",
  "analytics.cash-flow": "Денежный поток",
  "analytics.role": "Создать разрешение",
  "analytics.user-role": "Создать аккаунт",
  "analytics.form-dynamic": "Настроить форму",
  "analytics.companies": "Связать магазины",
  "analytics.dashboards.outcome": "СТАТИСТИКА РАСХОДОВ",
  "analytics.dashboards.income": "СТАТИСТИКА ДОХОДОВ",
  "analytics.dashboards.stock-log": "СТАТИСТИКА ПОСТУПЛЕНИЙ",
  "analytics.dashboards.order-payment": "СТАТИСТИКА ПРОДАННЫХ ТОВАРОВ",
  "analytics.dashboards.debt": "СТАТИСТИКА ДОЛГОВ",
  "analytics.dashboards.make-product": "СТАТИСТИКА ИСПОЛЬЗОВАННЫХ ЗАПАСОВ",
  "analytics.dashboards.order-table": "СТАТИСТИКА СТОЛОВ",
  "analytics.today": "Сегодня",
  "analytics.yesterday": "Вчера",
  "analytics.7-days-ago": "7 дней назад",
  "analytics.this-week": "Эта неделя",
  "analytics.last-week": "Прошлая неделя",
  "analytics.30-days-ago": "30 дней назад",
  "analytics.this-month": "Этот месяц",
  "analytics.last-month": "Прошлый месяц",
  "analytics.all": "Все",
  "analytics.compare": "Сравнить",
  // 'analytics.update': 'Update',
  "analytics.revenue": "Выручка",
  "analytics.costs": "Фиксированные расходы",
  "analytics.profit": "Прибыль",
  "analytics.invoice-quantity": "Количество счетов",
  "analytics.number-products-sold": "Количество проданных товаров",
  "analytics.average-selling-price": "Средняя цена продажи",
  "analytics.total-product": "Всего товаров",
  "analytics.product": "Продукт",
  "analytics.amount-of-inventory": "Количество инвентаря",
  "analytics.items": "Предметы",
  "analytics.inventory-value": "Стоимость инвентаря",

  /* product */
  "product.title": "Добавить продукт",
  "product.title.update": "Обновить продукт",
  "product.add-new": "Добавить 1 продукт",
  "product.tab.import-excel": "Импорт из Excel",
  "product.tab.import-image": "Импорт из изображения",
  "product.tooltip.category":
    "Это родительская категория для товаров. Эта категория создается перед созданием товаров. (Примечание: Если родительская категория будет удалена, все товары, принадлежащие ей, также будут удалены, пожалуйста, будьте осторожны!).",
  "product.tooltip.categories":
    "Это родительская категория для товаров. Эта категория создается перед созданием товаров. (Примечание: Если родительская категория будет удалена, все товары, принадлежащие ей, также будут удалены, пожалуйста, будьте осторожны!).",
  "product.tooltip.price":
    'Это цена продажи, если "Акционная цена" не выбрана.',
  "product.tooltip.topping":
    "Добавьте дополнительные предметы или дополнения и соответствующие дополнительные расходы.",
  "product.tooltip.ice":
    "Отметьте 5 полей, чтобы позволить клиентам выбирать количество льда.",
  "product.tooltip.sugar":
    "Отметьте 5 полей, чтобы позволить клиентам выбирать уровень сладости.",
  "product.notify.create-stock-success": "Новый склад успешно создан",
  "product.notify.create-stock-error": "Ошибка при создании склада",
  "product.notify.no-detail": "Не удалось загрузить детали продукта.",
  "product.import.result": "Результат импорта",
  "product.import.choose-file": "Выберите файл Excel для импорта",
  "product.import.support-format": "Поддерживаются форматы .xlsx и .xls",
  "product.import.download-template": "Скачать шаблон",
  "product.validation.barcode-min":
    "Требуется не менее 10 символов ({count}/10)",
  "product.placeholder.select-category": "Выберите или создайте категорию...",
  "product.image.change": "Изменить изображение",
  "product.image.select": "Выберите изображение",
  "product.confirm.delete": "Вы уверены, что хотите удалить выбранные товары?",
  "category.confirm.delete": "Вы уверены, что хотите удалить эту категорию?",
  "category.confirm.delete-all":
    "Вы уверены, что хотите удалить выбранные категории?",
  "product.confirm.delete-category":
    "Вы уверены, что хотите удалить эту категорию?",
  "product.confirm.apply-master":
    "Вы уверены, что хотите применить эти значения ко ВСЕМ вариантам? Это переопределит индивидуально введенные значения.",
  "product.error.invalid-data": "Неверные данные",
  "product.error.name-required": "Требуется название продукта",
  "product.error.category-required": "Требуется категория продукта",
  "product.error.price-required": "Требуется цена продажи",
  "product.error.variant-required":
    "Пожалуйста, введите цену и количество для всех вариантов",
  "product.error.select-size":
    "Пожалуйста, выберите хотя бы один размер перед созданием.",

  /* Backend API validation messages */
  "product.api.error.price-invalid": "Цена товара недействительна (должна быть >= 0)",
  "product.api.error.promo-price-invalid": "Акционная цена недействительна (должна быть >= 0)",
  "product.api.error.barcode-invalid": "Штрих-код недействителен (требуется 8-13 цифр)",
  "product.api.error.sku-duplicate": "Этот SKU уже существует в системе",
  "product.api.error.category-not-found": "Категория товара не существует",
  "product.api.error.duplicate": "Этот товар уже существует в системе",
  "product.api.error.limit-reached": "Достигнут лимит товаров. Обновите тариф для создания новых!",
  "product.api.error.not-found": "Товар не найден или доступ запрещён",
  "product.api.error.variant-price-invalid": "Цена варианта недействительна (должна быть >= 0)",
  "product.api.error.variant-promo-invalid": "Акционная цена варианта недействительна (должна быть >= 0)",
  "product.api.error.import-missing-fields": "У товара отсутствует название или категория",

  /* Product OCR */
  "product.ocr.title": "Извлечение товаров из изображения",
  "product.ocr.description": "Загрузите фото меню/прайс-листа, ИИ автоматически распознает товары.",
  "product.ocr.prompt-placeholder": "Оставьте пустым = автоопределение по типу бизнеса",
  "product.ocr.choose-images": "Выбрать изображения",
  "product.ocr.more-images": "ещё изображений",
  "product.ocr.show-prompt": "Настроить запрос ИИ",
  "product.ocr.hide-prompt": "Скрыть настройку запроса",
  "product.ocr.extract-btn": "Извлечь данные",
  "product.ocr.extracting": "Обработка...",
  "product.ocr.save-btn": "Сохранить",
  "product.ocr.saving": "Сохранение...",
  "product.ocr.save-success": "Импорт товаров выполнен успешно!",
  "product.ocr.items": "товаров",
  "product.ocr.col-name": "Название товара",
  "product.ocr.col-category": "Категория",
  "product.ocr.col-size": "Размер",
  "product.ocr.col-price": "Цена",
  "product.ocr.col-price-sale": "Цена со скидкой",
  "product.ocr.col-barcode": "Штрихкод",
  "product.ocr.step-upload": "Загрузка",
  "product.ocr.step-mapping": "Сопоставление",
  "product.ocr.step-preview": "Просмотр",
  "product.ocr.mapping-title": "Сопоставление столбцов",
  "product.ocr.mapping-desc": "ИИ определил столбцы слева. Сопоставьте их с полями товара справа.",
  "product.ocr.ai-column": "Столбец ИИ",
  "product.ocr.db-field": "Поле данных",
  "product.ocr.status": "Статус",
  "product.ocr.skip-column": "-- Пропустить --",
  "product.ocr.mapped": "Сопоставлено",
  "product.ocr.rows-found": "строк данных",
  "product.ocr.cols-mapped": "столбцов сопоставлено",
  "product.ocr.back": "Назад",
  "product.ocr.next": "Продолжить",
  "product.ocr.reset": "Сбросить",
  "product.ocr.preview-title": "Просмотр & Сохранение",
  "product.ocr.stat-products": "Товаров",
  "product.ocr.stat-categories": "Категорий",
  "product.ocr.stat-with-price": "С ценой",
  "product.ocr.import-done": "Готово!",
  "product.ocr.created": "Создано",
  "product.ocr.updated": "Обновлено",
  "product.ocr.skipped": "Пропущено",
  "product.ocr.raw-result": "Необработанный результат ИИ:",
  "product.ocr.error-no-image": "Выберите хотя бы одно изображение.",
  "product.ocr.error-no-data": "Не удалось извлечь данные из изображения. Попробуйте ещё раз.",
  "product.ocr.error-extract": "Произошла ошибка при анализе изображения.",
  "product.ocr.error-empty": "Нет данных для сохранения.",
  "product.ocr.error-save": "Произошла ошибка, попробуйте ещё раз.",
  "product.ocr.error-name-required": "Необходимо сопоставить столбец «Название товара» для продолжения.",

  "pages.add-new": "ДОБАВИТЬ НОВЫЙ",
  "pages.add-new-user-staff": "ДОБАВИТЬ ПЕРСОНАЛ",
  "pages.add-new-log": "ДОБАВИТЬ ЕЩЕ",
  "pages.order-new": "ЗАКАЗ",
  "pages.image": "Изображение продукта",
  "pages.add-new-modal-title": "Добавить продукт",
  "pages.order-new-modal-title": "Заказать новый продукт",
  "pages.update-modal-title": "Обновить продукт",
  "pages.display-options": "Показать опции",
  "pages.orderby": "Сортировка: ",
  "pages.product-name": "Название продукта",
  "pages.product-barcode": "Штрих-код",
  "pages.product-sku": "Код продукта",
  "pages.category": "Тип продукта",
  "pages.description": "Описание",
  "pages.status": "Статус",
  "pages.cancel": "Отмена",
  "pages.submit": "Отправить",
  "pages.delete": "Удалить",
  "pages.delete-forever": "Удалить навсегда",
  "pages.another-action": "Другое действие",
  "pages.update": "Обновить",
  "pages.price": "Цена",
  "pages.select-category": "Выберите 1 тип продукта",
  "pages.select-product": "Выберите 1 продукт",
  "pages.order-number": "Вес",
  "pages.no-selected": "Нет действий",
  "pages.order-more": "Добавить продукт",
  "pages.total-order-price": "Общая цена",
  "pages.current-order-price": "Текущая цена заказа",
  "pages.error-title": "Ой... какая-то ошибка!",
  "pages.error-code": "Ошибка",
  "pages.go-back-home": "Вернуться на главную",
  "pages.softhide": "Скрыть продукт",
  "pages.un-softhide": "Показать продукт",
  "pages.bestter": "Рекомендуем",
  "pages.un-bestter": "Выкл - Рекомендуем",
  "pages.print-tem": "Печать этикетки",
  "pages.expand": "Смотреть варианты",
  "pages.collapse": "Свернуть",

  "product.title": "Информация о продукте",
  "product.price.original": "Цена",
  "product.price.sale": "Акционная цена",
  "product.price.cost": "Себестоимость",
  "product.quantity": "Количество",
  "product.inventory": "Склад",
  "product.ice": "Количество льда",
  "product.sugar": "Сладость",
  "product.size": "Размер",
  "product.topping": "Топпинг",
  "product.color": "Цвет",
  "product.material": "Материал",
  "product.add.name": "Название",
  "product.add.value": "Доп. деньги",
  "product.add_price": "Доп. цена",
  "product.update_cost": "Обновить стоимость",
  "product.edit_cost": "Редактировать стоимость",
  "product.search": "Поиск по названию продукта",
  "product.variants": "Варианты",
  "product.variant-name": "Название варианта",
  "product.sku": "SKU",
  "product.price": "Цена продажи",
  "product.stock": "Запас",
  "product.promo-time": "Время акции",

  /* 07.Category */
  "category.add-new-modal-title": "Добавить тип продукта",
  "category.update-title": "Обновить категорию продукта",
  "category.title": "Название продукта",
  "category.thumb-list": "Тип продукта",
  "category.nav-tab": "КАТЕГОРИЯ",
  "category.add-new-category": "ДОБАВИТЬ КАТЕГОРИЮ",
  "category.btn-add": "Добавить категорию",

  /* 08.Todo */
  "todo.add-new": "Добавить",
  "todo.thumb-list": "Событие",
  "todo.add-new-modal-title": "Добавить новое событие",
  "todo.update-modal-title": "Обновить событие",
  "todo.title": "Название события",
  "todo.description": "Описание",
  "todo.date": "Дата",
  "todo.time": "Время",
  "todo.update-done": "Готово",
  "todo.update-pending": "В ожидании",
  "todo.delete": "Удалить",
  "todo.no-selected": "Нет действия",
  "todo.update": "Обновить",
  "todo.date-time": "Время",
  "todo.orderby": "Сортировка: ",
  "todo.btn-add": "Добавить событие",

  /*table setting */
  "table-setting.row": "Строка",
  "table-setting.col": "Столбец",
  "table-setting.floor": "Зона",
  "table-setting.btn-generate": "Создать столы",
  "table-setting.map": "Карта",
  "table-setting.btn-save": "Сохранить",
  "table-setting.title": "Настройка макета столов и стульев",

  /* stock */
  "stock.thumb-list": "Склады",
  "stock.add-new-modal-title": "Добавить склад",
  "stock.name": "Название склада",
  "stock.unit": "Единица",
  "stock.unit-price": "Цена покупки",
  "stock.unit-price-update": "Цена покупки",
  "stock.unit-price-new": "Новая цена покупки",
  "stock.price": "В деньгах",
  "stock.count": "Количество",
  "stock.count-new": "Количество",
  "stock.delete": "Удалить склад",
  "stock.reset": "Сбросить до 0",
  "stock.count-update": "Обновить запас",
  "stock.count-edit": "Редактировать запас",
  "stock.count-current": "Остаток",
  "stock.count-total": "Всего импортировано",
  "stock.update-title": "Обновить склад",
  "stock.search": "Поиск по названию склада",
  "stock.btn-add": "Добавить склад",

  /* warehouse */
  "warehouse.add-new-modal-title": "Добавить новый",
  "warehouse.phone": "Телефон",
  "warehouse.address": "Адрес",
  "warehouse.code": "Код склада",
  "warehouse.unit": "Единица",
  "warehouse.description": "Описание",
  "warehouse.btn-add": "Добавить",

  "warehouse.import-search": "Поиск по названию поступления",
  "warehouse.import": "Поступление",
  "warehouse.import-stock": "Импортированный товар",
  "warehouse.import-title": "Обновить поступление",
  "warehouse.import-name": "Имя кладовщика (прием)",
  "warehouse.import-quantity": "Количество",
  "warehouse.import-price": "Цена импорта",
  "warehouse.btn-add-import": "Создать",

  "warehouse.export-search": "Поиск по названию выдачи",
  "warehouse.export": "Выдача",
  "warehouse.export-stock": "Экспортированный товар",
  "warehouse.export-title": "Обновить выдачу",
  "warehouse.export-name": "Имя кладовщика (выдача)",
  "warehouse.export-quantity": "Количество",
  "warehouse.export-price": "Цена экспорта",
  "warehouse.btn-add-export": "Создать",

  "warehouse.transfer-search": "Поиск по названию перемещения",
  "warehouse.transfer": "Перемещение",
  "warehouse.transfer-stock": "Перемещаемый товар",
  "warehouse.transfer-title": "Обновить перемещение",
  "warehouse.transfer-name": "Имя ответственного за перемещение",
  "warehouse.transfer-quantity": "Количество",
  "warehouse.transfer-price": "Цена перемещения",
  "warehouse.transfer-name-carrier": "Имя перевозчика",
  "warehouse.transfer-phone-carrier": "Телефон перевозчика",
  "warehouse.transfer-receiving-warehouse": "Переместить на склад",
  "warehouse.transportation": "Транспортировка",
  "warehouse.cost-transfer": "Транспортный сбор",
  "warehouse.btn-add-transfer": "Создать",

  /* make product */
  "make-product.thumb-list": "Количественный",
  "make-product.add-new-modal-title": "Добавить новый количественный",
  "make-product.name": "Название",
  "make-product.unit": "Единица",
  "make-product.count": "Количество",
  "make-product.make-more": "Добавить",
  "make-product.product-name": "Название продукта",
  "make-product.stock-name": "Название склада",
  "make-product.select-stock": "Выберите 1 склад",
  "make-product.add-modal-title": "Добавить новый",
  "make-product.update-modal-title": "Редактировать",
  "make-product.number-product-used": "Количество использованных запасов",
  "make-product.price": "Цена",
  "make-product.cost": "Себестоимость",
  "make-product.percent-cost": "Процент от себестоимости/цены продажи",
  "make-product.btn-add": "Создать",

  /* FAQ */
  "faq.title": "Руководство",
  "faq.text-title": "Вопрос",
  "faq.text-content": "Ответ",
  "faq.modal-title": "Вопросы и ответы",

  /** Ref */
  "ref.name": "Имя владельца",
  "ref.companyName": "Название магазина",
  "ref.email": "Email",
  "ref.phone": "Телефон",
  "ref.address": "Адрес",
  "ref.content": "Сообщение",
  "ref.title": "Информация о реферале",
  "ref.sub-title":
    "Ваша реферальная комиссия в настоящее время составляет 30% от суммы контракта реферала, подписанного с VMASS. Ваша информация будет автоматически отправлена в VMASS на основе предоставленной вами личной информации.",
  "ref.btn-submit": "Отправить",

  /** Chat */
  "chat.messages": "Сообщение",
  "chat.messages-inbox": "Входящие",
  "chat.messages-new": "Телефонная книга",
  "chat.start-conversation": "Начать разговор!",

  /** Discount */
  "discount.add-new-modal-title": "Добавить скидку",
  "discount.note": "Примечание",
  "discount.type": "Тип скидки",
  "discount.value": "Значение скидки",
  "discount.user": "Персонал",
  "discount.products": "Продукт",
  "discount.select-all-products": "Все товары",
  "discount.select-one-type": "Выберите тип значения",
  "discount.select-one-product": "Выберите 1 продукт",
  "discount.select-one-type-product": "Выберите 1 тип продукта",
  "discount.to-bill": "Добавить еще",
  "discount.add-feetax": "Добавить скидку, налог, сбор",
  "discount.discount": "Скидка",
  "discount.tax": "Налог",
  "discount.fee-other": "Сбор-другое",
  "order.adjustment.add-products-first":
    "Добавьте товары перед вводом кода",
  "order.adjustment.invalid-code": "Недействительный промокод",
  "order.adjustment.apply": "Применить",
  "order.adjustment.note-optional": "Примечание (необязательно)",
  "order.adjustment.promo-code": "Промокод",
  "order.adjustment.promo-placeholder": "Введите промокод",
  "order.adjustment.coupon-help":
    "Введите код и нажмите «Применить», чтобы получить скидку.",
  "order.adjustment.remove-code": "Удалить промокод",
  "order.adjustment.discount-value": "Размер скидки",
  "order.adjustment.estimated-discount": "Расчетная скидка",
  "order.adjustment.discount-note-placeholder": "Например: Постоянный клиент",
  "order.adjustment.subtotal": "Промежуточный итог",
  "order.adjustment.total-after-discount": "Итого после скидки",
  "order.adjustment.tax-title": "Добавить налог",
  "order.adjustment.tax-rate": "Ставка налога",
  "order.adjustment.other": "Другое",
  "order.adjustment.tax-value": "Сумма налога",
  "order.adjustment.estimated-tax": "Расчетный налог",
  "order.adjustment.calculation": "Расчет",
  "order.adjustment.tax-added": "Добавить к заказу",
  "order.adjustment.tax-added-help":
    "Налог будет добавлен к итоговой сумме оплаты.",
  "order.adjustment.tax-included": "Включено в цену",
  "order.adjustment.tax-included-help":
    "Налог уже включен в цену товара или услуги.",
  "order.adjustment.tax-note-placeholder": "Например: НДС розничной продажи",
  "order.adjustment.total-payment": "Итого к оплате",
  "order.adjustment.fee-title": "Добавить сбор",
  "order.adjustment.fee-name": "Название сбора",
  "order.adjustment.shipping-fee": "Доставка",
  "order.adjustment.service-fee": "Сервисный сбор",
  "order.adjustment.packing-fee": "Упаковка",
  "order.adjustment.other-fee": "Другой сбор",
  "order.adjustment.fee-value": "Сумма сбора",
  "order.adjustment.estimated-fee": "Расчетный сбор",
  "order.adjustment.apply-on": "Применить к",
  "order.adjustment.calculation-base": "База расчета сбора",
  "order.adjustment.fixed-fee-base-help":
    "Фиксированный сбор в VND не зависит от базы расчета.",
  "order.adjustment.after-discount": "Итого после скидки",
  "order.adjustment.fee-note-placeholder": "Например: Доставка по городу",

  /** Customer */
  "customer.add-new-modal-title": "Добавить нового",
  "customer.title": "Информация",
  "customer.name": "Имя",
  "customer.phone": "Телефон",
  "customer.email": "Email",
  "customer.address": "Адрес",
  "customer.point": "Баллы",
  "customer.armorial": "Герб",
  "customer.used-item": "Количество использований",
  "customer.tags": "Теги",
  "customer.info": "ИНФО",
  "customer.used": "ИСПОЛЬЗОВАННЫЕ ПРОДУКТЫ",
  "customer.setting": "НАСТРОЙКИ",
  "customer.search": "Найти по телефону",
  "customer.btn-add": "Создать",
  "customer.amount-spent": "Потраченная сумма",
  "customer.debt": "Долг",

  /** Income, Outcome, Treasury */
  action: "Действие",
  name: "Имя",
  phone: "Телефон",
  email: "Email",
  address: "Адрес",
  price: "Цена",
  note: "Описание",
  time: "Статистика",
  "time-created": "Время создания",
  "user.created": "Пользователь создан",
  "select-one-time": "Выберите один тип",
  "select-one-time-discount": "Выберите 1 тип скидки",
  "select-one-time-gift": "Выберите 1 тип подарка",

  "income.title": "Доход",
  "income.sub_title": "Название",
  "income.add-new-modal-title": "Добавить новый доход",
  "income.name": "Имя отправителя",
  "income.search": "Поиск по названию дохода",
  "income.btn-add": "Создать",

  "outcome.title": "Расход",
  "outcome.sub_title": "Название",
  "outcome.add-new-modal-title": "Добавить новый расход",
  "outcome.name": "Имя получателя",
  "outcome.search": "Поиск по названию расхода",
  "outcome.btn-add": "Создать",

  "treasury.name": "Название казначейства",
  "treasury.title": "Казначейство",
  "treasury.add-new-modal-title": "Добавить новое казначейство",
  "treasury.timeCreated": "Время создания",
  "treasury.search": "Поиск по названию казначейства",
  "treasury.btn-add": "Создать",

  /** Break Event */
  "breakeven.title": "Точка безубыточности",

  /** Company Provider */
  "company-provider.info": "Информация",
  "company-provider.title": "Поставщик",
  "company-provider.title-log": "Add transaction",
  "company-provider.title-log-add": "Add transaction",
  "company-provider.title-log-add-more": "Дополнительный платеж",
  "company-provider.add-new-modal-title": "Добавить поставщика",
  "company-provider.name": "Имя",
  "company-provider.item_name": "Товары",
  "company-provider.total_price_income": "Всего введено сумму",
  "company-provider.total_price_outcome": "Оплачено",
  "company-provider.total_price_pending": "Осталось",
  "company-provider.item_product": "Поставляемые товары",
  "company-provider.price": "Цена",
  // 'company-provider.name': 'Name of supplier',
  "company-provider.search": "Поиск по имени поставщика",
  "company-provider.btn-add": "Создать",
  "company-provider.transaction": "Транзакция",
  "company-provider.sku": "SKU",
  "company-provider.price_new": "Цена",
  "company-provider.quantity": "Количество",
  "company-provider.debt": "Долг",
  "company-provider.total": "Итого",
  "company-provider.time": "Время",
  "company-provider.action": "Действие",

  /** User Staff */
  "user-staff.title": "Информация о персонале",
  "user-staff.add-new-modal-title": "Добавить нового",
  "user-staff.add-new-logs-modal-title": "Добавить еще",
  // 'user-staff.title': 'Staff',
  "user-staff.permission_name": "Должность",
  "user-staff.date_join": "Дата вступления",
  "user-staff.date_get_salary": "Дата выплаты зарплаты",
  "user-staff.hour_working_on_day": "Количество рабочих часов в день",
  "user-staff.status_working": "Статус работы",
  "user-staff.salary_by": "Расчет зарплаты по",
  "user-staff.salary_value": "Ставка",
  "user-staff.working_hours": "Рабочее время",
  "user-staff.current_commission": "Комиссия",
  "user-staff.current_bonus": "Бонус",
  "user-staff.current_overtime": "Оплата сверхурочных",
  "user-staff.current_advence": "Аванс",
  "user-staff.current_fined": "Штраф",
  "user-staff.current_dayoff": "Отпускные",
  "user-staff.current_day_working": "Рабочих дней в этом месяце",
  "user-staff.current_salary": "Зарплата за этот месяц",
  "user-staff.total_salary": "Итого зарплата",
  "user-staff.total_day_working": "Всего рабочих дней",
  "user-staff.working_hours_from": "* Работает с",
  "user-staff.working_hours_to": "* Работает до",
  "user-staff.logs_users_staff": "Имя",
  "user-staff.logs_type": "Тип",
  "user-staff.logs_value_salary": "Сумма денег",
  "user-staff.logs_value_hour": "Час",
  "user-staff.overtime_coefficient": "Коэффициент сверхурочных",
  "user-staff.select-all-users": "Выбрать персонал",
  "user-staff.select-one": "Выбрать 1 тип",
  "user-staff.name": "Имя",
  "user-staff.phone": "Телефон",
  "user-staff.address": "Адрес",
  "user-staff.email": "Email",
  "user-staff.search": "Поиск по имени сотрудника",
  "user-staff.btn-add": "Создать",
  "user-staff.add-log-title": "Добавить данные зарплаты сотрудника",
  "user-staff.kpi.total": "Всего сотрудников",
  "user-staff.kpi.active": "Работают",
  "user-staff.kpi.inactive": "Уволены",
  "user-staff.kpi.manager": "Менеджеры",
  "user-staff.kpi.revenue-today": "Выручка сегодня",
  "user-staff.kpi.current": "Текущие данные",
  "user-staff.kpi.current-page": "Текущая страница",
  "user-staff.kpi.today": "Сегодня",
  "user-staff.search-placeholder": "Поиск сотрудника...",
  "user-staff.filter.position-all": "Должность: Все",
  "user-staff.filter.status-all": "Статус: Все",
  "user-staff.filter.shift-all": "Смена: Все",
  "user-staff.filter.clear": "Фильтр",
  "user-staff.table.employee": "Сотрудник",
  "user-staff.table.position": "Должность",
  "user-staff.table.shift": "Смена",
  "user-staff.table.phone": "Телефон",
  "user-staff.table.revenue-today": "Выручка сегодня",
  "user-staff.table.bills": "Счета",
  "user-staff.table.status": "Статус",
  "user-staff.table.action": "Действие",
  "user-staff.action.call": "Позвонить",
  "user-staff.action.message": "Сообщение",
  "user-staff.action.edit": "Изменить",
  "user-staff.action.more": "Еще",
  "user-staff.action.delete": "Удалить",
  "user-staff.empty": "Нет данных сотрудников",
  "user-staff.detail.empty": "Выберите сотрудника для просмотра деталей",
  "user-staff.detail.tab.info": "Инфо",
  "user-staff.detail.tab.schedule": "График",
  "user-staff.detail.tab.performance": "Эффективность",
  "user-staff.detail.tab.salary": "Зарплата",
  "user-staff.detail.tab.permission": "Права",
  "user-staff.detail.basic": "Основная информация",
  "user-staff.detail.staff-code": "Код сотрудника",
  "user-staff.detail.birthday": "Дата рождения",
  "user-staff.detail.schedule": "График",
  "user-staff.detail.performance": "Эффективность сегодня",
  "user-staff.detail.salary": "Зарплата",
  "user-staff.detail.permission": "Права",
  "user-staff.detail.dynamic-fields": "Пользовательские поля",
  "user-staff.today.revenue": "Выручка",
  "user-staff.today.bills": "Счета",
  "user-staff.today.products": "Обслужено товаров",
  "user-staff.today.revenue-per-hour": "Выручка/час",
  "user-staff.total.revenue": "Общая выручка",

  /** Role */
  "role.name": "Название роли",
  "role.title": "Права доступа",
  "role.add-new-modal-title": "Добавить новую",
  "role.btn-add": "Создать",

  /** User Role */
  "user-role.title": "Редактировать права доступа",
  "user-role.name": "Имя сотрудника",
  "user-role.add-new-modal-title": "Добавить новую",
  "user-role.select-one": "Выбрать разрешение",
  "user-role.place-holder-password": "Оставьте пустым, если не меняется",
  "user-role.btn-add": "Создать",

  /** Form Dynamic */
  "form-dynamic.title": "Настроить форму",
  "form-dynamic.add-new-modal-title": "Добавить новую",
  "form-dynamic.label": "Заголовок",
  "form-dynamic.alias": "Тип формы",
  "form-dynamic.select-one-alias": "Выберите 1 форму",
  "form-dynamic.type": "Тип данных",
  "form-dynamic.select-one-type": "Выберите 1 тип",
  "form-dynamic.btn-add": "Создать",

  "url.placeholder": "http:// или https://",

  /** Compananies */
  "companies.find-company-uuid": "Найти код магазина",
  "companies.title": "Связать магазины вместе",
  "companies.add-new-modal-title": "Добавить новый",
  "companies.name": "Имя",
  "companies.type": "Тип",
  "companies.unset": "Без связи",
  "companies.btn-add": "Создать",

  /** Promotion */
  "promotion.thumb-list": "Акция",
  "promotion-add": "Добавить новую",
  "promotion-update": "Обновить",
  "promotion-name": "Название акции",
  "promotion-code": "Код",
  "promotion-quantity": "Применимое количество",
  "promotion-description": "Описание",
  "promotion-max-per-customer": "Макс. использование на клиента",
  "promotion-date_start": "Время начала",
  "promotion-date_end": "Время окончания",
  "promotion-isAutoUse": "Авто-включение",

  /** Calendar */
  "calendar.add-event": "Добавить событие",

  /** Booking */
  "menu.booking": "Бронирование",
  "booking.title": "Управление бронированием",
  "booking.add-new": "Добавить бронирование",
  "booking.today": "Сегодня",
  "booking.week": "Эта неделя",
  "booking.month": "Этот месяц",
  "booking.calendar": "Календарь",
  "booking.settings": "Настройки",
  "booking.customer-name": "Имя клиента",
  "booking.customer-phone": "Телефон",
  "booking.customer-email": "Email",
  "booking.date": "Дата бронирования",
  "booking.time": "Время прибытия",
  "booking.party-size": "Размер группы",
  "booking.table": "Стол",
  "booking.special-requests": "Особые запросы",
  "booking.notes": "Заметки",
  "booking.status": "Статус",
  "booking.status.pending": "В ожидании",
  "booking.status.confirmed": "Подтверждено",
  "booking.status.cancelled": "Отменено",
  "booking.status.completed": "Завершено",
  "booking.status.no_show": "Неявка",
  "booking.deposit": "Депозит",
  "booking.deposit-required": "Требуется депозит",
  "booking.deposit-amount": "Сумма депозита",
  "booking.confirm": "Подтвердить",
  "booking.cancel": "Отменить",
  "booking.complete": "Завершить",
  "booking.source": "Источник",
  "booking.no-bookings": "Бронирований пока нет",

  /** Wizard */
  "wizard.title": "Мастер настройки",
  "wizard.sub-title":
    "Мастер настройки проведет вас через несколько шагов, чтобы быстро запустить ваш магазин.",
  "wizard.next": "Далее",
  "wizard.prev": "Назад",
  "wizard.finish": "Готово",
  "wizard.skip": "Пропустить",
  "wizard.step-name-1": "Шаг 1",
  "wizard.step-desc-1": "Основная информация",
  "wizard.step-name-2": "Шаг 2",
  "wizard.step-desc-2": "Добавить товар",
  "wizard.step-name-3": "Шаг 3",
  "wizard.step-desc-3": "Информация о платеже",
  "wizard.content-thanks": "Спасибо!",
  "wizard.registered":
    "Ваша информация была записана, желаем вам приятного использования программного обеспечения!",

  /* Facebook Settings */
  "facebook.settings-title": "Facebook Fanpage",
  "facebook.config-guide": "Настройка Webhook (Для разработчиков):",
  "facebook.callback-url": "URL обратного вызова:",
  "facebook.verify-token": "Токен подтверждения:",
  "facebook.fields": "Поля:",
  "facebook.guide": "Руководство",
  "facebook.guide-step-1": "Нажмите 'Подключить новую Fanpage'",
  "facebook.guide-step-2": "Войдите в Facebook (если нужно)",
  "facebook.guide-step-3": "Выберите Fanpage для подключения",
  "facebook.guide-step-4": "Предоставьте разрешения приложению",
  "facebook.guide-step-5": "Готово!",
  "facebook.connect-new": "Подключить новую Fanpage",
  "facebook.description":
    "Подключите Fanpage, чтобы получать сообщения клиентов из Facebook Messenger и отвечать на них.",
  "facebook.how-to-connect": "Как подключить Fanpage:",
  "facebook.upgrade-warning":
    "Вам нужно обновиться до пакета Basic, чтобы подключить Fanpage.",
  "facebook.upgrade-now": "Обновить сейчас",
  "facebook.connect-new-locked":
    "Подключить новую Fanpage (требуется пакет Basic)",
  "facebook.loading": "Загрузка...",
  "facebook.no-pages": "Fanpages еще не подключены.",
  "facebook.page-name": "Название страницы",
  "facebook.page-id": "ID страницы",
  "facebook.connected-date": "Дата подключения",
  "facebook.action": "Действие",
  "facebook.disconnect": "Отключить",
  "facebook.go-to-messenger": "Перейти в чат",
  "facebook.manual.btn": "Ручной токен",
  "facebook.manual.title": "Подключение через Page Access Token",
  "facebook.manual.desc":
    "Вставьте ваш Page Access Token ниже. Его можно получить из Facebook Developer Tools или Business Suite.",
  "facebook.manual.guide": "Как получить токен",
  "facebook.manual.guide-title": "Как получить Page Access Token:",
  "facebook.manual.guide-step-1":
    "Перейдите в Facebook Graph API Explorer (developers.facebook.com/tools/explorer)",
  "facebook.manual.guide-step-2":
    "Выберите приложение и Fanpage для подключения",
  "facebook.manual.guide-step-3":
    "Предоставьте разрешения: pages_show_list, pages_messaging, pages_read_engagement",
  "facebook.manual.guide-step-4":
    "Нажмите 'Generate Access Token' и скопируйте токен",
  "facebook.manual.placeholder": "Вставьте Page Access Token сюда...",
  "facebook.manual.connect-btn": "Подключить",
  "facebook.manual.connecting": "Подключение...",
  "facebook.manual.error-empty": "Пожалуйста, введите Page Access Token",
  "facebook.manual.error-failed": "Подключение не удалось. Проверьте ваш токен.",
  "facebook.manual.error-no-selection": "Пожалуйста, выберите хотя бы 1 Fanpage для подключения",
  "facebook.manual.check-btn": "Проверить",
  "facebook.manual.checking": "Проверка...",
  "facebook.manual.select-pages": "Выберите Fanpages для подключения:",
  "facebook.manual.select-all": "Выбрать все",
  "facebook.manual.deselect-all": "Отменить все",
  "facebook.manual.pages-selected": "страниц выбрано",

  /* Settings - General */
  "settings.general": "Общие настройки",
  "settings.general.ui-title": "Внешний вид интерфейса",
  "settings.general.font-size-label": "Размер шрифта",
  "settings.general.font-size-small": "Мелкий",
  "settings.general.font-size-large": "Крупный",
  "settings.general.preview-text":
    "Preview: This is a sample text with font size {size}px",
  "settings.general.report-title": "Report Configuration",
  "settings.general.daily-report-time": "Daily Report Time",
  "settings.general.select-time-placeholder": "Выберите время...",
  "settings.general.report-note":
    "(Система будет отправлять отчет о доходах на почту в выбранное время)",

  /* Settings - Invoice */
  "settings.invoice.title": "Настройки счетов",
  "settings.invoice.section-1": "1. Настройки счета клиента",
  "settings.invoice.print-at-counter": "Печатать счет при заказе на кассе",
  "settings.invoice.section-2": "2. Настройки кухонного чека",
  "settings.invoice.print-kitchen":
    'Печатать кухонный чек, когда кассир нажимает "Отправить на кухню"',
  "settings.invoice.section-3": "3. Рабочий процесс заказа",
  "settings.invoice.process-1": "Заказать и завершить немедленно",
  "settings.invoice.process-2": "Заказ > Кухня > Завершить",
  "settings.invoice.process-3": "Заказ > Оплата > Завершено",
  "settings.invoice.process-4": "Заказ > Кассир > Бар/Кухня > Завершено",
  "settings.invoice.process-4-title": "4. Процесс заказа через QrCode",
  "settings.invoice.process-4-flow": "Заказ > На кухню > Оплата > Завершено",

  /* Settings - Email */
  "settings.email.title": "Конфигурация Email",
  "settings.email.guide-title": "Как создать пароль приложения Gmail:",
  "settings.email.guide-step-1": "Перейдите в аккаунт Google",
  "settings.email.guide-step-2":
    "Безопасность → Включить двухэтапную аутентификацию",
  "settings.email.guide-step-3":
    'Найдите "Пароли приложений" или нажмите здесь',
  "settings.email.guide-step-4":
    'Выберите приложение: Почта, Устройство: Другое, введите "VMASS"',
  "settings.email.guide-step-5": "Скопируйте 16-значный пароль",
  "settings.email.smtp-custom-title": "Пользовательский SMTP:",
  "settings.email.description":
    "Настройте пользовательский email для отправки уведомлений клиентам с адреса электронной почты вашего магазина вместо стандартного VMASS.",
  "settings.email.mode-default": "Использовать стандартный email VMASS",
  "settings.email.mode-custom": "Использовать пользовательский email",
  "settings.email.default-note":
    "Система будет отправлять письма с vmass.vn@gmail.com. Отключите, чтобы настроить пользовательский email.",
  "settings.email.type-label": "Тип Email",
  "settings.email.type-gmail": "Gmail (Пароль приложения)",
  "settings.email.type-smtp": "Пользовательский SMTP (Zoho, Office 365...)",
  "settings.email.address-label": "Адрес Email",
  "settings.email.password-label": "Пароль Email",
  "settings.email.app-password-label": "Пароль Приложения",
  "settings.email.create-app-password": "Создать пароль приложения здесь",
  "settings.email.smtp-server-config": "Конфигурация SMTP сервера",
  "settings.email.smtp-host": "Хост SMTP",
  "settings.email.smtp-port": "Порт",
  "settings.email.smtp-secure": "Безопасность",
  "settings.email.quick-config": "Быстрая настройка:",
  "settings.email.test-button": "Отправить тестовое письмо",
  "settings.email.save-button": "Сохранить конфигурацию",
  "settings.email.saving": "Сохранение...",
  "settings.email.success": "Конфигурация Email успешно сохранена!",
  "settings.email.guide-button": "Руководство",

  /* Settings - Shipping */
  "settings.shipping.title": "Настройки доставки",
  "settings.shipping.subtitle":
    "Подключитесь к службам доставки для автоматического создания заказов на доставку",
  "settings.shipping.upgrade-warn":
    "Вам нужно обновиться до пакета Basic, чтобы использовать функцию подключения доставки.",
  "settings.shipping.upgrade-btn": "Обновить сейчас",
  "settings.shipping.business-type-label": "Ваш тип бизнеса:",
  "settings.business.cafe": "Кафе",
  "settings.business.restaurant": "Ресторан",
  "settings.business.retail": "Розница",
  "settings.business.other": "Другое",
  "settings.shipping.business-fit":
    "Следующие службы доставки подходят для вашего бизнеса",
  "settings.shipping.connected-title": "Подключенные провайдеры",
  "settings.shipping.edit-btn": "Редактировать",
  "settings.shipping.disconnect-btn": "Отключить",
  "settings.shipping.available-title": "Доступные провайдеры",
  "settings.shipping.status-connected": "Подключено",
  "settings.shipping.connect-btn": "Подключить сейчас",
  "settings.shipping.guide-title": "Инструкции",
  "settings.shipping.modal.connect-title": "Подключить {name}",
  "settings.shipping.modal.token": "API Токен",
  "settings.shipping.modal.shop-id": "ID Магазина",
  "settings.shipping.modal.client-id": "Client ID",
  "settings.shipping.modal.secret-key": "Secret Key",
  "settings.shipping.modal.token-placeholder":
    "Введите API Токен от провайдера",
  "settings.shipping.modal.shop-id-placeholder":
    "Введите ID Магазина (если есть)",
  "settings.shipping.modal.client-id-placeholder": "Введите Client ID",
  "settings.shipping.modal.secret-key-placeholder": "Введите Secret Key",
  "settings.shipping.modal.current-token":
    "Текущий токен: {token} (оставьте пустым, чтобы не менять)",
  "settings.shipping.modal.sandbox-label":
    "Режим песочницы (тест) - Снимите галочку для продакшена",
  "settings.shipping.modal.origin-title": "Адрес отправки магазина",
  "settings.shipping.modal.origin-desc":
    "Эта информация используется для точного расчета стоимости доставки",
  "settings.shipping.modal.province": "Область/Город",
  "settings.shipping.modal.district": "Район",
  "settings.shipping.modal.ward": "Округ",
  "settings.shipping.modal.select-province": "Выберите Область/Город",
  "settings.shipping.modal.select-district": "Выберите Район",
  "settings.shipping.modal.select-ward": "Выберите Округ",
  "settings.shipping.modal.cancel": "Отмена",
  "settings.shipping.modal.connect": "Подключить",
  "settings.shipping.modal.connecting": "Подключение...",
  "settings.shipping.alert.missing-token": "Пожалуйста, введите API Токен",
  "settings.shipping.alert.connect-success": "Успешно подключено",
  "settings.shipping.alert.connect-error": "Ошибка подключения",
  "settings.shipping.alert.disconnect-confirm":
    "Вы уверены, что хотите отключить этого провайдера доставки?",
  "settings.shipping.alert.disconnect-success": "Успешно отключено",
  "settings.shipping.alert.disconnect-error": "Ошибка отключения",
  "settings.shipping.guide.ghn.step1": "Перейдите на api.ghn.vn",
  "settings.shipping.guide.ghn.step2": "Зарегистрируйтесь/Войдите в аккаунт",
  "settings.shipping.guide.ghn.step3":
    'Перейдите в "Документы", чтобы получить Токен',
  "settings.shipping.guide.ghn.step4": "Введите Токен и ID Магазина в форму",
  "settings.shipping.guide.ghtk.step1":
    "Войдите на khachhang.giaohangtietkiem.vn",
  "settings.shipping.guide.ghtk.step2":
    'Перейдите в "Информация о магазине" или "Управление API"',
  "settings.shipping.guide.ghtk.step3": "Скопируйте API Токен",
  "settings.shipping.guide.viettel.step1": "Войдите на partner.viettelpost.vn",
  "settings.shipping.guide.viettel.step2":
    'Перейдите в "Конфигурация аккаунта"',
  "settings.shipping.guide.viettel.step3": "Скопируйте API Токен",
  "settings.shipping.guide.jt.step1": "Свяжитесь с J&T для регистрации",
  "settings.shipping.guide.jt.step2": "Получите Client ID и Secret Key",
  "settings.shipping.modal.token-guide.ghn":
    "Получить токен: api.ghn.vn → Документы",
  "settings.shipping.modal.token-guide.ghtk":
    "Получить токен: khachhang.giaohangtietkiem.vn → Информация о магазине",
  "settings.shipping.modal.token-guide.viettel":
    "Получить токен: partner.viettelpost.vn → Конфигурация аккаунта",
  "settings.shipping.modal.token-guide.jt":
    "Свяжитесь с J&T для получения доступа к API",

  /* Settings - Customer */
  "settings.customer.tier.bronze": "Бронза",
  "settings.customer.tier.silver": "Серебро",
  "settings.customer.tier.gold": "Золото",
  "settings.customer.tier.diamond": "Бриллиант",
  "settings.customer.alert.success": "Настройки успешно сохранены!",
  "settings.customer.alert.error": "Ошибка сохранения настроек",
  "settings.customer.alert.missing-info":
    "Пожалуйста, заполните всю информацию",
  "settings.customer.alert.min-tiers": "Должен быть хотя бы 1 уровень клиента",
  "settings.customer.loading": "Загрузка...",
  "settings.customer.saving": "Сохранение...",
  "settings.customer.point-rule": "Правила накопления баллов",
  "settings.customer.point-value": "1 балл =",
  "settings.customer.currency": "VND",
  "settings.customer.tier-title": "Этапы накопления баллов и уровни клиентов",
  "settings.customer.add-tier": "Добавить уровень",
  "settings.customer.new-tier": "Новый уровень",
  "settings.customer.table.color": "Цвет",
  "settings.customer.table.name": "Название уровня",
  "settings.customer.table.points": "Мин. баллы",
  "settings.customer.table.actions": "Действия",
  "settings.customer.placeholder.name": "Название уровня",
  "settings.customer.placeholder.points": "Баллы",
  "settings.customer.points-suffix": "баллов",
  "settings.customer.note-title": "Примечание:",
  "settings.customer.note-content":
    "Уровни клиентов будут автоматически обновляться на основе общего количества накопленных баллов. Уровни отсортированы по минимальным баллам от низкого к высокому.",
  "settings.customer.save-btn": "Сохранить изменения",

  /* Settings - Staff */
  "settings.staff.alert.load-error": "Не удалось загрузить настройки",
  "settings.staff.alert.save-success": "Настройки успешно сохранены!",
  "settings.staff.alert.save-error": "Не удалось сохранить настройки",
  "settings.staff.alert.position-exists": "Эта должность уже существует",
  "settings.staff.shift-title": "Конфигурация рабочих смен",
  "settings.staff.shift-desc":
    'Установите рабочие смены по умолчанию. Нажмите "Сохранить настройки", чтобы сохранить в системе.',
  "settings.staff.add-shift": "Добавить смену",
  "settings.staff.from": "С",
  "settings.staff.to": "По",
  "settings.staff.delete": "Удалить",
  "settings.staff.position-title": "Должности",
  "settings.staff.position-desc":
    "Список должностей. Нажмите ×, чтобы удалить должность.",
  "settings.staff.add-position": "Добавить новую должность",
  "settings.staff.position-placeholder": "Введите название должности...",
  "settings.staff.save-btn": "Сохранить настройки",
  "settings.staff.saving": "Сохранение...",

  /* Settings - Partner & API */
  "settings.partner.title": "API Key",
  "settings.partner.doc-btn": "Документация интеграции",
  "settings.partner.create-btn": "+ Создать API Key",
  "settings.partner.alert.empty":
    'API Keys не найдены. Нажмите "+ Создать API Key", чтобы начать.',
  "settings.partner.alert.create-error": "Пожалуйста, введите имя API Key",
  "settings.partner.alert.create-success": "API Key успешно создан!",
  "settings.partner.alert.create-fail": "Ошибка создания API Key",
  "settings.partner.alert.revoke-title": "Удалить API Key",
  "settings.partner.alert.revoke-confirm":
    "Вы уверены, что хотите удалить этот API Key? Это действие нельзя отменить!",
  "settings.partner.alert.revoke-success": "API Key отозван",
  "settings.partner.alert.revoke-fail": "Ошибка отзыва API Key: ",
  "settings.partner.alert.regenerate-title": "Пересоздать API Key",
  "settings.partner.alert.regenerate-confirm":
    "Вы уверены, что хотите пересоздать этот API Key? Старый ключ будет немедленно отключен!",
  "settings.partner.alert.regenerate-success": "API Key успешно пересоздан!",
  "settings.partner.alert.regenerate-fail": "Ошибка пересоздания API Key",
  "settings.partner.alert.update-fail": "Ошибка обновления API Key",
  "settings.partner.analytics.total": "Всего запросов",
  "settings.partner.analytics.today": "Сегодня",
  "settings.partner.analytics.success-rate": "Успешность",
  "settings.partner.analytics.avg-time": "Ср. время",
  "settings.partner.table.name": "Имя",
  "settings.partner.table.keys": "API Keys",
  "settings.partner.table.permissions": "Разрешения",
  "settings.partner.table.note": "Примечание",
  "settings.partner.table.action": "Действия",
  "settings.partner.modal.create.title": "Создать новый API Key",
  "settings.partner.modal.create.name": "Имя API Key *",
  "settings.partner.modal.create.name-placeholder":
    "Пример: Автоматизация n8n, Мобильное приложение...",
  "settings.partner.modal.create.permissions": "Разрешения",
  "settings.partner.modal.create.permissions-desc":
    "Выберите разрешения и нажмите × для удаления",
  "settings.partner.modal.create.permissions-placeholder":
    "Выберите разрешения...",
  "settings.partner.modal.create.env": "Среда API",
  "settings.partner.modal.create.env-test": "Тест (Песочница)",
  "settings.partner.modal.create.env-live": "Live (Продакшн)",
  "settings.partner.modal.create.desc": "Описание",
  "settings.partner.modal.create.desc-placeholder":
    "Опишите цель этого API Key...",
  "settings.partner.modal.create.cancel": "Отмена",
  "settings.partner.modal.create.submit": "Создать API Key",
  "settings.partner.modal.create.submitting": "Создание...",
  "settings.partner.modal.result.title": "API Key создан",
  "settings.partner.modal.result.important":
    "Важно! Сохраните этот API Key сейчас. Он будет показан только один раз!",
  "settings.partner.modal.result.copy": "Копировать",
  "settings.partner.modal.result.copied": "✓ Скопировано!",
  "settings.partner.modal.result.copy-alert":
    "API Key скопирован в буфер обмена!",
  "settings.partner.modal.result.expires": "Истекает:",
  "settings.partner.modal.result.close": "Сохранено",

  /* Partner Permissions */
  "settings.partner.perm.orders-read": "Чтение заказов",
  "settings.partner.perm.orders-write": "Запись заказов",
  "settings.partner.perm.products-read": "Чтение товаров",
  "settings.partner.perm.products-write": "Запись товаров",
  "settings.partner.perm.inventory-read": "Чтение инвентаря",
  "settings.partner.perm.inventory-write": "Запись инвентаря",
  "settings.partner.perm.recipes-read": "Чтение рецептов",
  "settings.partner.perm.recipes-write": "Запись рецептов",
  "settings.partner.perm.customers-read": "Чтение клиентов",
  "settings.partner.perm.customers-write": "Запись клиентов",
  "settings.partner.perm.user-read": "Чтение информации о пользователе",

  "settings.partner.env.test-desc":
    "Используется для тестирования API. Созданные данные будут помечены как is_test=true и не повлияют на отчеты о доходах.",
  "settings.partner.env.live-desc":
    "Используется для рабочей среды. Все данные будут записаны в реальную систему и повлияют на отчеты.",
  "settings.partner.env.live-label": "Live:",
  "settings.partner.create-btn-pro-auto": "+ Создать API Key (Pro Auto)",
  "settings.partner.list-title": "Список API Key",
  "settings.partner.pro-feature-tooltip":
    "Функция требует план Pro Auto или выше",
  "settings.partner.upgrade-alert.text": "Вам нужно обновиться до",
  "settings.partner.upgrade-alert.action":
    "плана, чтобы создавать и управлять API Keys.",
  "settings.partner.upgrade-alert.link": "Обновить сейчас",
  "settings.partner.modal.confirm.cancel": "Отмена",
  "settings.partner.modal.confirm.confirm": "Подтвердить",

  "settings.webhook.title": "Подписки на Webhook",
  "settings.webhook.doc-btn": "Документация API",
  "settings.webhook.create-btn": "+ Создать Webhook",
  "settings.webhook.create-btn-pro-auto": "+ Создать Webhook (Pro Auto)",
  "settings.webhook.pro-feature-tooltip":
    "Функция требует план Pro Auto или выше",
  "settings.webhook.upgrade-alert.text": "Вам нужно обновиться до",
  "settings.webhook.upgrade-alert.action":
    "плана, чтобы использовать Webhooks.",
  "settings.webhook.upgrade-alert.link": "Обновить сейчас",

  "settings.webhook.alert.empty":
    'Webhook не найдены. Нажмите "+ Создать Webhook", чтобы начать получать автоматические уведомления.',
  "settings.webhook.alert.create-success": "Webhook успешно создан!",
  "settings.webhook.alert.create-error":
    "Пожалуйста, проверьте вашу информацию.",
  "settings.webhook.alert.create-fail": "Ошибка создания webhook",
  "settings.webhook.alert.delete-success": "Webhook удален",
  "settings.webhook.alert.delete-fail": "Ошибка удаления webhook",
  "settings.webhook.alert.update-fail": "Ошибка обновления webhook",
  "settings.webhook.alert.rotate-confirm":
    "Вы уверены, что хотите пересоздать Secret Key? Старый ключ будет немедленно аннулирован!",
  "settings.webhook.alert.rotate-success": "Secret Key успешно пересоздан!",
  "settings.webhook.alert.rotate-fail": "Ошибка пересоздания Secret Key",
  "settings.webhook.alert.delete-confirm":
    "Вы уверены, что хотите удалить этот webhook? Это действие нельзя отменить!",

  "settings.webhook.table.url": "URL",
  "settings.webhook.table.events": "События",
  "settings.webhook.table.status": "Статус",
  "settings.webhook.table.last-triggered": "Последний запуск",
  "settings.webhook.table.action": "Действие",
  "settings.webhook.status.active": "Активен",
  "settings.webhook.status.inactive": "Неактивен",

  "settings.webhook.modal.create.title": "Создать новый Webhook",
  "settings.webhook.modal.create.desc":
    "Webhooks позволяют VMASS отправлять автоматические уведомления на ваш URL при возникновении событий (новый заказ, оплата и т.д.).",
  "settings.webhook.modal.create.url-label": "URL Webhook *",
  "settings.webhook.modal.create.url-placeholder":
    "https://your-server.com/webhook",
  "settings.webhook.modal.create.url-help":
    "URL должен быть HTTPS и принимать POST запросы",
  "settings.webhook.modal.create.events-label": "Выберите события *",
  "settings.webhook.modal.create.events-placeholder": "Выберите события...",
  "settings.webhook.modal.create.events-help":
    "Нажмите ×, чтобы удалить выбранные события",
  "settings.webhook.modal.create.cancel": "Отмена",
  "settings.webhook.modal.create.submit": "Создать Webhook",
  "settings.webhook.modal.create.submitting": "Создание...",

  "settings.webhook.modal.secret.title": "Secret Key Webhook",
  "settings.webhook.modal.secret.important":
    "Важно! Сохраните этот Secret Key сейчас. Он будет показан только один раз!",
  "settings.webhook.modal.secret.label": "Secret Key (для проверки подписи)",
  "settings.webhook.modal.secret.copy": "Копировать",
  "settings.webhook.modal.secret.copied": "✓ Скопировано!",
  "settings.webhook.modal.secret.verify-guide": "Как проверить подпись:",
  "settings.webhook.modal.secret.close": "Secret Key сохранен",

  "settings.webhook.modal.logs.title": "История доставки Webhook",
  "settings.webhook.modal.logs.empty": "Журналы не найдены",
  "settings.webhook.modal.logs.time": "Время",
  "settings.webhook.modal.logs.event": "Событие",
  "settings.webhook.modal.logs.status": "Статус",
  "settings.webhook.modal.logs.response-time": "Время ответа",
  "settings.webhook.modal.logs.close": "Закрыть",

  "settings.webhook.modal.confirm.title": "Подтверждение",
  "settings.webhook.modal.confirm.cancel": "Отмена",
  "settings.webhook.modal.confirm.confirm": "Подтвердить",

  "settings.webhook.event.order.created": "Новый заказ создан",
  "settings.webhook.event.order.paid": "Заказ оплачен",
  "settings.webhook.event.order.shipped": "Заказ отправлен",
  "settings.webhook.event.order.completed": "Заказ завершен",
  "settings.webhook.event.order.cancelled": "Заказ отменен",
  "settings.webhook.event.product.updated": "Товар обновлен",
  "settings.webhook.event.inventory.low_stock": "Низкий запас",
  "settings.webhook.event.inventory.expiring": "Истекающий срок годности",
  "settings.webhook.event.customer.created": "Новый клиент",
  "settings.webhook.event.payment.received": "Платеж получен",

  "settings.ai.title": "AI Ассистент (Мульти-Агент)",
  "settings.ai.switch.on": "Включено",
  "settings.ai.switch.off": "Отключено",
  "settings.ai.switch.desc":
    "Когда включено, AI будет автоматически отвечать на сообщения вместо стандартного автоответчика.",
  "settings.ai.provider.label": "Основной провайдер",
  "settings.ai.provider.gemini":
    "Google Gemini (Рекомендуется - Бесплатно/Дешево)",
  "settings.ai.provider.openai": "OpenAI (GPT-4o - Умнее/Платный)",
  "settings.ai.failover.label": "Автоматическое переключение",
  "settings.ai.failover.desc":
    "Если основной провайдер недоступен (превышена квота, ошибка сервера), система автоматически переключится на резервного провайдера.",
  "settings.ai.gemini.label": "API Key Gemini",
  "settings.ai.gemini.placeholder": "Введите Google Gemini API Key...",
  "settings.ai.gemini.help.text": "Получить ключ в ",
  "settings.ai.gemini.help.link": "Google AI Studio",
  "settings.ai.openai.label": "API Key OpenAI",
  "settings.ai.openai.placeholder": "Введите OpenAI API Key (sk-...)...",
  "settings.ai.openai.help.text": "Получить ключ в ",
  "settings.ai.openai.help.link": "OpenAI Dashboard",
  "settings.ai.persona.label": "Персона",
  "settings.ai.persona.desc":
    'Определите личность AI. Например: "Вы полезный агент поддержки, который использует эмодзи."',
  "settings.ai.knowledge.label": "База знаний",
  "settings.ai.knowledge.placeholder":
    "Пример:\n- Wifi: CoffeeHouse / пароль: 12345678\n- Часы работы: 7:00 - 22:00\n- Адрес: ул. Ленина, 123...",
  "settings.ai.knowledge.desc":
    "AI будет использовать эту информацию для ответа на общие вопросы клиентов.",
  "settings.ai.save": "Сохранить конфигурацию",

  /* Shipping Providers */
  "settings.shipping.provider.ghn.name": "Giao Hang Nhanh (GHN)",
  "settings.shipping.provider.ghn.desc":
    "Быстрая доставка в городских районах и по всей стране",
  "settings.shipping.provider.ghtk.name": "Giao Hang Tiet Kiem (GHTK)",
  "settings.shipping.provider.ghtk.desc": "Экономичная доставка по всей стране",
  "settings.shipping.provider.viettelpost.name": "Viettel Post",
  "settings.shipping.provider.viettelpost.desc":
    "Почтовая служба Viettel по всей стране",
  "settings.shipping.provider.jt.name": "J&T Express",
  "settings.shipping.provider.jt.desc": "Доставка J&T Express",

  /* Quick Reply Settings */
  "settings.quickreply.title": "Шаблоны быстрых ответов",
  "settings.quickreply.add": "Добавить шаблон",
  "settings.quickreply.empty.title": "Шаблоны не найдены",
  "settings.quickreply.create-first": "Создать первый шаблон",
  "settings.quickreply.col.title": "Заголовок",
  "settings.quickreply.col.content": "Содержание",
  "settings.quickreply.col.shortcut": "Сокращение",
  "settings.quickreply.col.category": "Категория",
  "settings.quickreply.col.action": "Действие",
  "settings.quickreply.modal.title-add": "Добавить быстрый ответ",
  "settings.quickreply.modal.title-edit": "Редактировать быстрый ответ",
  "settings.quickreply.modal.label.title": "Заголовок *",
  "settings.quickreply.modal.placeholder.title": "Например: Спасибо",
  "settings.quickreply.modal.label.content": "Содержание *",
  "settings.quickreply.modal.placeholder.content":
    "Содержание сообщения для отправки...",
  "settings.quickreply.modal.label.shortcut": "Сокращение",
  "settings.quickreply.modal.placeholder.shortcut": "Например: /thanks",
  "settings.quickreply.modal.help.shortcut":
    "Введите сокращение для быстрого поиска",
  "settings.quickreply.modal.label.category": "Категория",
  "settings.quickreply.cat.general": "Общее",
  "settings.quickreply.cat.greeting": "Приветствие",
  "settings.quickreply.cat.thanks": "Благодарность",
  "settings.quickreply.cat.faq": "FAQ",
  "settings.quickreply.cat.promotion": "Акция",
  "settings.quickreply.modal.cancel": "Отмена",
  "settings.quickreply.modal.save": "Создать",
  "settings.quickreply.modal.update": "Обновить",
  "settings.quickreply.notify.load-error": "Не удалось загрузить шаблоны",
  "settings.quickreply.notify.input-error":
    "Пожалуйста, введите заголовок и содержание",
  "settings.quickreply.notify.update-success": "Шаблон обновлен",
  "settings.quickreply.notify.create-success": "Шаблон создан",
  "settings.quickreply.notify.save-error": "Не удалось сохранить шаблон",
  "settings.quickreply.notify.delete-confirm":
    "Вы уверены, что хотите удалить этот шаблон?",
  "settings.quickreply.notify.delete-success": "Шаблон удален",
  "settings.quickreply.notify.delete-error": "Не удалось удалить шаблон",

  /* Auto Reply Settings */
  "settings.autoreply.title": "Правила автоответа",
  "settings.autoreply.add": "Добавить правило",
  "settings.autoreply.empty.title": "Правила автоответа не найдены",
  "settings.autoreply.create-first": "Создать первое правило",
  "settings.autoreply.col.enable": "Включить",
  "settings.autoreply.col.name": "Название правила",
  "settings.autoreply.col.keyword": "Ключевые слова",
  "settings.autoreply.col.response": "Ответ",
  "settings.autoreply.col.page": "Fanpage",
  "settings.autoreply.col.match": "Совпадений",
  "settings.autoreply.col.action": "Действие",
  "settings.autoreply.modal.title-add": "Добавить правило автоответа",
  "settings.autoreply.modal.title-edit": "Редактировать правило автоответа",
  "settings.autoreply.modal.label.name": "Название правила *",
  "settings.autoreply.modal.placeholder.name":
    "Например: Приветствие нового клиента",
  "settings.autoreply.modal.label.page": "Применить к Fanpage",
  "settings.autoreply.modal.option.all-pages": "Все Fanpages",
  "settings.autoreply.modal.label.trigger": "Ключевые слова триггеры",
  "settings.autoreply.modal.placeholder.trigger":
    "привет, здравствуйте, добро пожаловать (через запятую)",
  "settings.autoreply.modal.help.trigger":
    "Бот отвечает, когда сообщение содержит любое ключевое слово",
  "settings.autoreply.modal.label.response": "Содержание ответа *",
  "settings.autoreply.modal.placeholder.response":
    "Здравствуйте! Спасибо за обращение...",
  "settings.autoreply.modal.label.priority": "Приоритет",
  "settings.autoreply.modal.help.priority":
    "Больше число = Выше приоритет (когда совпадают несколько правил)",
  "settings.autoreply.modal.cancel": "Отмена",
  "settings.autoreply.modal.save": "Создать",
  "settings.autoreply.modal.update": "Обновить",
  "settings.autoreply.test.placeholder":
    "Введите сообщение для проверки автоответа...",
  "settings.autoreply.test.button": "Тест",
  "settings.autoreply.test.matched": "Совпало!",
  "settings.autoreply.test.no-match": "Нет совпадений",
  "settings.autoreply.test.rule": "Правило:",
  "settings.autoreply.test.response": "Ответ:",
  "settings.autoreply.notify.load-error": "Не удалось загрузить правила",
  "settings.autoreply.notify.input-error":
    "Пожалуйста, введите название и ответ",
  "settings.autoreply.notify.update-success": "Правило обновлено",
  "settings.autoreply.notify.create-success": "Правило создано",
  "settings.autoreply.notify.save-error": "Не удалось сохранить правило",
  "settings.autoreply.notify.delete-confirm":
    "Вы уверены, что хотите удалить это правило?",
  "settings.autoreply.notify.delete-success": "Правило удалено",
  "settings.autoreply.notify.delete-error": "Не удалось удалить правило",
  "settings.autoreply.notify.toggle-error":
    "Не удалось переключить статус правила",

  /* Upgrade Page */
  "upgrade.title": "Обновить аккаунт",
  "upgrade.subtitle": "Выберите план, который подходит вашему бизнесу",
  "upgrade.current-package": "Текущий план",
  "upgrade.expired": "Истек",
  "upgrade.remaining-days": "Осталось {days} дней",
  "upgrade.lifetime": "Пожизненно",
  "upgrade.activated": "АКТИВИРОВАНО",
  "upgrade.renew": "ПРОДЛИТЬ",
  "upgrade.downgrade": "ПОНИЗИТЬ",
  "upgrade.upgrade": "ОБНОВИТЬ",
  "upgrade.contact": "КОНТАКТ",
  "upgrade.using": "ИСПОЛЬЗУЕТСЯ",
  "upgrade.best-value": "Лучшее предложение",

  "upgrade.feature.billing": "Расчет и оплата",
  "upgrade.feature.print_invoice": "Печать счетов",
  "upgrade.feature.accounts": "Аккаунты кассира, кухни и официанта",
  "upgrade.feature.sales": "Полный набор управления продажами",
  "upgrade.feature.products": "Управление товарами",
  "upgrade.feature.materials": "Управление материалами",
  "upgrade.feature.staff": "Управление персоналом и табель",
  "upgrade.feature.chain": "Управление сетью филиалов",
  "upgrade.feature.reports": "Отчеты о доходах и прибыли",
  "upgrade.feature.social": "Подключение соцсетей",
  "upgrade.feature.shipping": "Подключение доставки",
  "upgrade.feature.ecommerce": "Интеграция с TikTok Shop / Shopee",
  "upgrade.feature.einvoice": "Электронные счета-фактуры",
  "upgrade.feature.api": "Интеграция с Webhook / API",
  "upgrade.feature.api-limit": "Лимит запросов API",
  "upgrade.feature.automation": "Система автоматизации",
  "upgrade.feature.support": "Техническая поддержка и настройка",

  "upgrade.value.products.free": "30 товаров",
  "upgrade.value.products.basic": "Неограниченно",
  "upgrade.value.materials.free": "30 материалов",
  "upgrade.value.materials.basic": "Неограниченно",
  "upgrade.value.staff.free": "2 сотрудника",
  "upgrade.value.unlimited": "Неограниченно",
  "upgrade.value.reports.basic": "Отчеты за сегодня",
  "upgrade.value.reports.detailed": "Отчеты о выручке в реальном времени",
  "upgrade.value.reports.advanced": "Подробные отчеты о прибыли",
  "upgrade.value.api.limit": "30,000 / месяц",
  "upgrade.value.api.custom": "Индивидуально",
  "upgrade.value.support.docs": "Документация",
  "upgrade.value.support.online": "Онлайн 24/7",
  "upgrade.value.support.priority": "Приоритет 1-1",

  "upgrade.package.free.title": "FREE PLAN",
  "upgrade.package.basic.title": "BASIC PLAN",
  "upgrade.package.pro.title": "PRO PLAN",
  "upgrade.package.pro-auto.title": "PRO + AUTOMATION",
  "upgrade.package.enterprise.title": "ENTERPRISE",

  "upgrade.time.1m": "1 месяц",
  "upgrade.time.6m": "6 месяцев",
  "upgrade.time.1y": "1 год",
  "upgrade.time.2y": "2 года",
  "upgrade.time.5y": "5 лет",

  "upgrade.modal.payment.title": "Информация о платеже",
  "upgrade.modal.payment.instant-title": "Доступна мгновенная активация",
  "upgrade.modal.payment.deduct-intro":
    "Общая сумма списания ({amount} VND) достаточно для оплаты этого пакета.",
  "upgrade.modal.payment.deduct-note":
    "Вам не нужно доплачивать. Система активирует пакет немедленно.",
  "upgrade.modal.payment.instruction":
    "Выберите срок, на который вы хотите обновиться, затем переведите на счет ниже соответствующую сумму и содержание. После перевода программное обеспечение обновится автоматически!",
  "upgrade.modal.payment.term": "Срок:",
  "upgrade.modal.payment.scan-note": "Сканируйте для оплаты",
  "upgrade.modal.payment.owner": "Владелец счета:",
  "upgrade.modal.payment.account": "Номер счета:",
  "upgrade.modal.payment.bank": "Банк:",
  "upgrade.modal.payment.amount": "Сумма:",
  "upgrade.modal.payment.content": "Содержание:",
  "upgrade.modal.payment.remaining": "(Остаток)",
  "upgrade.modal.payment.wallet": "(Кошелек)",
  "upgrade.modal.payment.original-price": "Исходная цена:",
  "upgrade.modal.payment.total": "К оплате:",
  "upgrade.modal.payment.btn-instant": "Подтвердить и активировать",
  "upgrade.modal.payment.btn-submit": "Подтвердить оплату и запросить обновление",
  "upgrade.modal.payment.surplus-refund": "Возврат излишка в кошелек:",
  "upgrade.promo.title": "Промокод",
  "upgrade.promo.placeholder": "Введите промокод",
  "upgrade.promo.apply": "Применить",
  "upgrade.promo.remove": "Удалить",
  "upgrade.promo.btn-create": "Создать код",
  "upgrade.promo.empty": "Промокодов пока нет",
  "upgrade.promo.modal-create": "Создать промокод",
  "upgrade.promo.modal-edit": "Редактировать промокод",
  "upgrade.promo.col-code": "Код",
  "upgrade.promo.col-desc": "Описание",
  "upgrade.promo.col-discount": "Скидка",
  "upgrade.promo.col-packages": "Пакеты",
  "upgrade.promo.col-usage": "Использовано / Макс.",
  "upgrade.promo.col-date": "Период",
  "upgrade.promo.col-status": "Статус",
  "upgrade.promo.discount-type": "Тип скидки",
  "upgrade.promo.discount-value": "Значение",
  "upgrade.promo.max-discount": "Макс. скидка",
  "upgrade.promo.max-uses": "Макс. использований",
  "upgrade.promo.start-date": "Дата начала",
  "upgrade.promo.end-date": "Дата окончания",
  "menu.upgrade-promo": "Промокоды обновления",
  "upgrade.modal.payment.manual-note":
    "Просто сканируйте QR-код для оплаты. После успешной оплаты программное обеспечение автоматически обновится!",

  "upgrade.modal.downgrade.title": "Подтверждение понижения",
  "upgrade.modal.downgrade.intro":
    "Система конвертирует оставшуюся стоимость текущего пакета:",
  "upgrade.modal.downgrade.remaining-value": "Оставшаяся стоимость:",
  "upgrade.modal.downgrade.equivalent": "(Эквивалентно {days} дням)",
  "upgrade.modal.downgrade.exchange": "Конвертировать в новый пакет:",
  "upgrade.modal.downgrade.refund": "Вернуть сумму в кошелек:",
  "upgrade.modal.downgrade.warning":
    "Примечание: Это действие нельзя отменить. Новый пакет будет активирован немедленно.",
  "upgrade.modal.downgrade.calculating": "Вычисление...",
  "upgrade.modal.downgrade.cancel": "Отмена",
  "upgrade.modal.downgrade.confirm": "Подтвердить понижение",
  "upgrade.modal.downgrade.ineligible": "Недоступно (Менее 1 месяца)",

  "upgrade.modal.success.title": "Обновление успешно!",
  "upgrade.modal.success.msg": "Поздравляем с успешным обновлением!",
  "upgrade.modal.success.lifetime": "Ваш аккаунт обновлен пожизненно",
  "upgrade.modal.success.new-expiry": "Новая дата истечения:",
  "upgrade.modal.success.close": "Закрыть",

  "profile.fullname": "Полное имя",
  "profile.description": "Описание",
  "profile.address": "Адрес",
  "profile.phone": "Телефон",
  "profile.email": "Email",
  "profile.company-name": "Название магазина",
  "profile.company-address": "Адрес магазина",
  "profile.company-website": "Вебсайт",
  "profile.company-start-time": "Время открытия",
  "profile.company-end-time": "Время закрытия",
  "profile.company-menu-hash": "Онлайн меню",
  "profile.bankPay": "Банк",
  "profile.namePay": "Владелец счета",
  "profile.numberPay": "Номер счета",
  "profile.update-personal": "ОБНОВИТЬ ЛИЧНУЮ ИНФОРМАЦИЮ",
  "profile.update-company": "ОБНОВИТЬ ИНФОРМАЦИЮ О МАГАЗИНЕ",
  "profile.placeholder.fullname": "Например: Иван Иванов",
  "profile.placeholder.description": "Например: Энтузиаст, люблю кофе...",
  "profile.placeholder.address": "Например: ул. Пушкина, д. Колотушкина",
  "profile.placeholder.phone": "Например: 8 800 555 35 35",
  "profile.placeholder.email": "Например: johndoe@gmail.com",
  "profile.placeholder.hotline": "Например: 1900 1234",
  "profile.placeholder.website": "Например: vmass.vn",
  "profile.placeholder.bank": "Выберите банк",
  "profile.placeholder.account-name": "Например: ИВАН ИВАНОВ",
  "profile.placeholder.account-number": "Например: 0123456789",
  "profile.business-type.cafe": "Кофе, Чай",
  "profile.business-type.restaurant": "Ресторан, Кафе",
  "profile.business-type.retail": "Продукты, Розница",
  "profile.business-type.fashion": "Мода",
  "profile.business-type.cosmetics": "Косметика",
  "profile.business-type.unknown": "Неизвестно",
  "profile.business-type.label": "Тип бизнеса",
  "profile.payment-info.title": "ИНФОРМАЦИЯ О ПЛАТЕЖЕ",

  /* Affiliate List */
  "affiliate.col.name": "Имя",
  "affiliate.col.email": "Email",
  "affiliate.col.phone": "Телефон",
  "affiliate.col.bank": "Банк",
  "affiliate.col.status": "Статус",
  "affiliate.col.date": "Дата регистрации",
  "affiliate.col.action": "Действие",
  "affiliate.empty": "Нет доступных данных",
  "affiliate.status.approved": "Одобрено",
  "affiliate.status.pending": "Ожидает",
  "affiliate.status.deactivated": "Деактивировано",

  /* Guest View & Orders */
  "guest.cart": "Корзина",
  "guest.price": "Цена за ед.",
  "guest.quantity": "Количество",
  "guest.total": "Итого",
  "guest.product": "Товар",
  "guest.total-amount": "Общая сумма",
  "guest.payment": "Оплата",
  "guest.call-service": "Позвать официанта",
  "guest.call-service-cooldown": "Повторный вызов через {seconds}с",
  "guest.request-payment": "Запросить счет",
  "guest.invoice": "Счет",

  /* Order Summary */
  "order.summary.discount": "Скидка",
  "order.summary.tax": "Налог",
  "order.summary.fee": "Другие сборы",
  "order.summary.gift": "Подарок",
  "order.summary.total-payment": "К оплате",

  /* Product Management Tools */
  "product.tooltip.category":
    'Родительская категория товара. Например, "Кофе" - родительская для "Холодный кофе с молоком".',
  "product.tooltip.price":
    'Это цена продажи, если "Акционная цена" не выбрана.',
  "product.tooltip.topping": "Дополнительные товары или опции и их стоимость.",
  "product.tooltip.ice":
    "Отметьте 5 пунктов, чтобы позволить клиентам выбрать количество льда.",
  "product.tooltip.sugar":
    "Отметьте 5 пунктов, чтобы позволить клиентам выбрать уровень сладости.",
  /* Recipe Builder */
  "recipe.unit.default": "Шт, коробка, пачка...",
  "recipe.unit.cafe": "Чашка, стакан, тарелка...",
  "recipe.unit.fashion": "Шт, пара, комплект...",
  "recipe.unit.cosmetics": "Бутылка, тюбик, банка...",
  "recipe.unit.retail": "Шт, пачка, коробка, кг...",
  "recipe.unit.generic": "ед.",
  "recipe.title": "Рецепт / Ингредиенты",
  "recipe.count-badge": "ингредиентов",
  "recipe.empty-state":
    'Пока нет ингредиентов. Нажмите "Добавить ингредиент", чтобы начать.',
  "recipe.label.name": "Название ингредиента",
  "recipe.placeholder.select": "Выбрать или создать...",
  "recipe.create-label": 'Создать "{val}"',
  "recipe.label.usage": "Кол-во исп.",
  "recipe.label.total": "Подытог",
  "recipe.btn.delete": "Удалить строку",
  "recipe.btn.delete-tooltip": "Удалить ингредиент",
  "recipe.new-stock.title": "Импорт нового запаса:",
  "recipe.label.unit": "Ед. изм.",
  "recipe.label.import-qty": "Кол-во импорта",
  "recipe.label.cost-price": "Себестоимость",
  "recipe.unit.per-unit": " / ед.",
  "recipe.label.paid": "Оплачено",
  "recipe.label.provider": "Поставщик",
  "recipe.create-provider": 'Создать "{val}"',
  "recipe.label.debt": "Долг",
  "recipe.btn.add": "Добавить ингредиент",
  "recipe.footer.total-cost": "Общая стоимость:",
  "recipe.footer.expected-profit": "Ожид. прибыль:",

  "product.name": "Название товара",
  "product.price": "Цена",
  "product.promotion-price": "Акционная цена",
  "product.price.cost": "Себестоимость",
  "product.image": "Изображение",
  "label.enter-barcode": "Введите штрих-код",
  "label.enter-product-name": "Введите название товара",
  "stock.unit": "Ед. изм.",
  "label.select-or-create": "Выбрать или создать...",
  "label.create-new": "Создать новый",
  "label.select-create-provider": "Выбрать или создать поставщика...",
  "unit.placeholder.default": "Шт, коробка, пачка...",
  "unit.placeholder.cafe": "Чашка, стакан, тарелка...",
  "unit.placeholder.fashion": "Шт, пара, комплект...",
  "unit.placeholder.cosmetics": "Бутылка, тюбик, банка...",
  "unit.placeholder.retail": "Шт, пачка, коробка, кг...",
  "modal.stock.stt": "№",
  "modal.product.unit": "Рецепт",
  "modal.product.combo": "Комбо",
  "product.edit_cost": "Изм. состав",
  "tooltip.enable-combo": "Включить Комбо",
  "modal.product.variant": "Варианты",
  "tooltip.not-for-combo": "Не для Комбо",
  "modal.stock.supplier": "Поставщик",
  "modal.product.paid": "Оплачено",
  "modal.stock.remaining": "Долг",
  "modal.product.image": "Изображение",
  "tooltip.unit-hint": "Единица измерения товара",
  "warehouse.import-quantity": "Кол-во импорта",

  "product.add-title": "Добавить товар",
  "product.import-excel": "Импорт из Excel",
  "product.import-image": "Импорт из изображения",
  "product.notify.stock-success": "Новый запас успешно создан",
  "product.sku": "Код SKU",
  "product.barcode": "Штрих-код",
  "product.stock-count": "Запас",

  "breakeven.title": "Точка безубыточности",
  "breakeven.period.day": "День",
  "breakeven.period.month": "Месяц",
  "breakeven.period.quarter": "Квартал",
  "breakeven.period.year": "Год",
  "breakeven.fallback.active":
    "Используются оценочные данные из предыдущего периода или списка товаров",
  "breakeven.fallback.inactive":
    "Включите, чтобы использовать оценочные данные, когда нет заказов",
  "breakeven.fallback.has-data":
    "Доступны фактические данные за период, оценка не требуется",
  "breakeven.fixed-costs.title": "Постоянные расходы (VND)",
  "breakeven.fixed-costs.rent": "Аренда",
  "breakeven.fixed-costs.salary": "Фиксированная зарплата",
  "breakeven.fixed-costs.depreciation": "Амортизация оборудования",
  "breakeven.fixed-costs.management": "Управление и Маркетинг",
  "breakeven.fixed-costs.other": "Другие постоянные расходы",
  "breakeven.product.title": "Информация о товаре",
  "breakeven.product.price": "Ср. цена продажи/ед.",
  "breakeven.product.variable-cost": "Ср. себестоимость/ед.",
  "breakeven.product.profit-margin": "Маржа прибыли %",
  "breakeven.product.price.tooltip.no-data":
    "Нет заказов за период, невозможно рассчитать ср. цену продажи",
  "breakeven.product.variable-cost.tooltip.no-data":
    "Эта метрика рассчитывается на основе проданных товаров",
  "breakeven.product.profit-margin.tooltip.no-data":
    "Цена продажи и себестоимость необходимы для расчета маржи",
  "breakeven.product.profit-margin.tooltip.desc":
    "Маржа = (Цена - Себестоимость) / Цена × 100%",
  "breakeven.loading": "Загрузка данных...",
  "breakeven.empty.title": "Невозможно рассчитать точку безубыточности",
  "breakeven.empty.desc":
    "Необходим хотя бы 1 заказ за период для определения фактической маржи прибыли.",
  "breakeven.empty.sub": "Появится после первого заказа.",
  "breakeven.result.fixed-cost": "Всего постоянных расходов",
  "breakeven.result.revenue": "Текущая выручка",
  "breakeven.result.gross-profit": "Текущая валовая прибыль",
  "breakeven.result.sold-quantity": "Проданное количество",
  "breakeven.result.breakeven-units": "Точка безубыточности (ед.)",
  "breakeven.result.breakeven-revenue": "Точка безубыточности (выручка)",
  "breakeven.table.title": "Таблица анализа прибыли",
  "breakeven.table.volume": "Объем",
  "breakeven.table.revenue": "Выручка",
  "breakeven.table.variable-cost": "Переменные расходы",
  "breakeven.table.fixed-cost": "Постоянные расходы",
  "breakeven.table.total-cost": "Общие расходы",
  "breakeven.table.profit": "Прибыль",
  "breakeven.error.price-invalid": "Ср. цена продажи должна быть больше 0.",
  "breakeven.error.cost-invalid":
    "Переменные расходы не могут быть отрицательными.",
  "breakeven.error.margin-invalid":
    "Цена продажи должна быть больше удельных переменных расходов.",
  "breakeven.error.fetch-fail": "Не удалось получить данные",
  "breakeven.error.connect-fail": "Ошибка соединения: ",
  "breakeven.chart.title": "График анализа точки безубыточности",
  "breakeven.chart.revenue": "Выручка (TR)",
  "breakeven.chart.total-cost": "Общие расходы (TC)",
  "breakeven.chart.fixed-cost": "Постоянные расходы (FC)",
  "breakeven.chart.x-axis": "Единицы (Q)",
  "breakeven.chart.y-axis": "Значение (VND)",
  "profile.validate.required":
    "Пожалуйста, заполните всю информацию, отмеченную *, для лучшей работы!",
  "profile.success": "Успешно",
  "profile.error": "Произошла ошибка, пожалуйста, попробуйте снова.",
  "company-uuid": "UUID",

  "upgrade.notify.payment-received": "Получен платеж {amount} VND от {gateway}",
  "upgrade.notify.success":
    "Аккаунт успешно обновлен! Пожалуйста, проверьте дату истечения.",

  /* Navigation Tabs */
  "settings.nav.general": "Общие настройки",
  "settings.nav.invoice": "Настройки счетов",
  "settings.nav.social": "Подключение соцсетей",
  "settings.nav.shipping": "Подключение доставки",
  "settings.nav.staff": "Настройки персонала",
  "settings.nav.customer": "Настройки клиентов",
  "settings.nav.ecommerce": "Подключение E-commerce",
  "settings.nav.einvoice": "E-Invoice",
  "settings.nav.apikeys": "API Keys",
  "settings.nav.webhooks": "Webhooks",
  "settings.nav.email": "Конфигурация Email",
  "settings.nav.ai": "AI Ассистент",

  /* Notifications & Confirms */
  "settings.notification.no-data": "Нет доступных данных",
  "settings.notification.saved": "Конфигурация сохранена!",
  "settings.notification.error": "Произошла ошибка",
  "settings.social.fb.disconnect-success": "Страница отключена!",
  "settings.social.fb.disconnect-error": "Ошибка отключения страницы",
  "settings.social.fb.confirm-disconnect":
    "Вы уверены, что хотите отключить эту страницу?",
  "settings.social.zalo.disconnect-success": "Zalo OA отключен!",
  "settings.social.zalo.disconnect-error": "Ошибка отключения Zalo OA",
  "settings.social.zalo.confirm-disconnect":
    "Вы уверены, что хотите отключить этот Zalo OA?",
  "settings.ecommerce.shopee.connect-error": "Ошибка подключения Shopee",
  "settings.ecommerce.shop.disconnect-success": "Магазин отключен!",
  "settings.ecommerce.shop.disconnect-error": "Ошибка отключения магазина",
  "settings.ecommerce.shop.confirm-disconnect":
    "Вы уверены, что хотите отключить этот магазин?",
  "settings.ecommerce.tiktok.connect-error": "Ошибка подключения TikTok Shop",
  "settings.ecommerce.tiktok.disconnect-success": "TikTok Shop отключен!",
  "settings.ecommerce.tiktok.disconnect-error": "Ошибка отключения TikTok Shop",
  "settings.ecommerce.product-import-success": "Товары импортированы!",
  "settings.ecommerce.product-import-error": "Ошибка импорта товаров",
  "settings.ecommerce.order-sync-success": "Заказы синхронизированы!",
  "settings.ecommerce.order-sync-error": "Ошибка синхронизации заказов",
  "settings.einvoice.save-success": "Конфигурация E-Invoice сохранена!",
  "settings.einvoice.save-error": "Ошибка сохранения конфигурации E-Invoice",
  "settings.email.save-success": "Конфигурация Email сохранена!",
  "settings.email.save-error": "Ошибка сохранения конфигурации Email",
  "settings.email.test-success": "Тестовое письмо отправлено!",
  "settings.email.test-error": "Ошибка отправки тестового письма",

  /* Social Settings (Zalo) */
  "settings.zalo.title": "Zalo Official Account",
  "settings.zalo.guide": "Руководство",
  "settings.zalo.guide.title": "Как подключить Zalo OA:",
  "settings.zalo.guide.step1": "Нажмите 'Подключить новый Zalo OA'",
  "settings.zalo.guide.step2": "Войдите в Zalo (если нужно)",
  "settings.zalo.guide.step3": "Выберите OA для подключения",
  "settings.zalo.guide.step4": "Предоставьте разрешения",
  "settings.zalo.guide.step5": "Готово!",
  "settings.zalo.desc":
    "Подключите Zalo OA для получения и ответа на сообщения клиентов из Zalo.",
  "settings.zalo.upgrade-warning":
    "Вам нужно обновиться до пакета Basic, чтобы подключить Zalo OA.",
  "settings.zalo.upgrade-btn": "Обновить сейчас",
  "settings.zalo.connect-locked": "Подключить новый Zalo OA (Требуется Basic)",
  "settings.zalo.connect-btn": "Подключить новый Zalo OA",
  "settings.zalo.loading": "Загрузка...",
  "settings.zalo.no-oa": "Нет подключенных Zalo OA.",
  "settings.zalo.table.name": "Имя Zalo OA",
  "settings.zalo.table.id": "ID OA",
  "settings.zalo.table.date": "Дата подключения",
  "settings.zalo.table.action": "Действие",
  "settings.zalo.disconnect-btn": "Отключить",

  /* Ecommerce Settings (Shopee/TikTok) */
  "settings.ecommerce.shopee.guide": "Руководство",
  "settings.ecommerce.shopee.guide.title": "Как подключить Shopee:",
  "settings.ecommerce.shopee.guide.step1": "Нажмите 'Подключить новый магазин'",
  "settings.ecommerce.shopee.guide.step2": "Войдите в Shopee (если нужно)",
  "settings.ecommerce.shopee.guide.step3": "Выберите магазин для подключения",
  "settings.ecommerce.shopee.guide.step4": "Предоставьте разрешения",
  "settings.ecommerce.shopee.guide.step5": "Готово!",
  "settings.ecommerce.shopee.desc":
    "Подключите Shopee для синхронизации заказов, товаров и инвентаря.",
  "settings.ecommerce.upgrade-warning":
    "Вам нужно обновиться до пакета Basic, чтобы подключиться.",
  "settings.ecommerce.connect-locked":
    "Подключить новый магазин (Требуется Basic)",
  "settings.ecommerce.connect-btn": "Подключить новый магазин",
  "settings.ecommerce.loading": "Загрузка...",
  "settings.ecommerce.no-shop": "Нет подключенных магазинов.",
  "settings.ecommerce.table.name": "Название магазина",
  "settings.ecommerce.table.id": "ID магазина",
  "settings.ecommerce.table.region": "Регион",
  "settings.ecommerce.table.date": "Дата подключения",
  "settings.ecommerce.table.action": "Действие",
  "settings.ecommerce.action.syncing": "Синхронизация...",
  "settings.ecommerce.action.import-product": "Импорт товаров",
  "settings.ecommerce.action.sync-order": "Синхронизация заказов",
  "settings.ecommerce.action.disconnect": "Отключить",
  "settings.ecommerce.tiktok.guide": "Руководство",
  "settings.ecommerce.tiktok.guide.title": "Как подключить TikTok Shop:",
  "settings.ecommerce.tiktok.desc":
    "Подключите TikTok Shop для синхронизации заказов, товаров и инвентаря.",

  /* E-Invoice Settings */
  "settings.einvoice.title": "Конфигурация E-Invoice",
  "settings.einvoice.upgrade-warning":
    "Вам нужно обновиться до пакета Pro, чтобы использовать E-Invoice.",
  "settings.einvoice.provider": "Провайдер E-Invoice",
  "settings.einvoice.vat-rate": "Ставка НДС по умолчанию (%)",
  "settings.einvoice.api-info": "Учетные данные API",
  "settings.einvoice.username": "Имя пользователя",
  "settings.einvoice.password": "Пароль",
  "settings.einvoice.company-info": "Информация о компании",
  "settings.einvoice.tax-id": "ИНН",
  "settings.einvoice.company-name": "Название компании",
  "settings.einvoice.address": "Адрес",
  "settings.einvoice.phone": "Телефон",
  "settings.einvoice.email": "Email",
  "settings.einvoice.series": "Серия счета",
  "settings.einvoice.bank-info": "Банковская информация (Необязательно)",
  "settings.einvoice.bank-account": "Номер счета",
  "settings.einvoice.bank-name": "Название банка",
  "settings.einvoice.save-btn": "Сохранить конфигурацию",
  "settings.einvoice.saving": "Сохранение...",
  "settings.einvoice.api-url": "URL API",
  "settings.einvoice.api-url-help":
    "Тестовая среда для тестирования, Продакшн для реальных операций",
  "settings.einvoice.signing-method": "Метод подписи счетов",
  "settings.einvoice.sign-type": "Тип подписи",
  "settings.einvoice.sign-type-help":
    "USB-токен (ручной), HSM (авто сервер), eSign (удаленный CA)",
  "settings.einvoice.esign-config": "Расширенная настройка eSign",
  "settings.einvoice.esign-provider": "Провайдер CA",
  "settings.einvoice.esign-username": "Имя пользователя eSign",
  "settings.einvoice.esign-password": "Пароль eSign",
  "settings.einvoice.esign-serial": "Серийный номер сертификата",
  "settings.einvoice.test-connection": "Проверить подключение",
  "settings.einvoice.testing": "Проверка...",
  "settings.einvoice.test-success": "Подключение успешно!",
  "settings.einvoice.test-fail": "Не удалось подключиться к серверу",
  "settings.ai.saving-btn": "Сохранение...",
  "settings.ai.notification.success":
    "Конфигурация AI агента успешно сохранена!",
  "settings.ai.notification.error": "Ошибка сохранения конфигурации",
  "settings.ai.notification.success-title": "Успешно",
  "settings.ai.notification.error-title": "Ошибка",

  "facebook.go-to-messenger": "Перейти в чат",

  "settings.shipping.alert.connect-success": "Успешно подключено",
  "settings.shipping.alert.connect-error": "Ошибка подключения",
  "settings.shipping.alert.disconnect-confirm":
    "Вы уверены, что хотите отключить этого провайдера доставки?",
  "settings.shipping.alert.disconnect-success": "Успешно отключено",
  "settings.shipping.alert.disconnect-error": "Ошибка отключения",

  "warehouse.transfer-search": "Поиск по названию трансфера",
  "warehouse.transfer": "Накладная трансфера",
  "warehouse.transfer-stock": "Переданный товар",
  "warehouse.transfer-title": "Обновить накладную трансфера",
  "warehouse.transfer-name": "Имя отправителя",
  "warehouse.transfer-quantity": "Количество",
  "warehouse.transfer-price": "Цена трансфера",

  /* Inventory Audit */
  "audit.title": "Проверка инвентаря и корректировка запасов",
  "audit.button.create": "Создать проверку",
  "audit.modal.detail.title": "Детали проверки",
  "audit.date": "Дата",
  "audit.status": "Статус",
  "audit.note": "Примечание",
  "audit.table.stock": "Материал",
  "audit.table.system": "Система",
  "audit.table.actual": "Фактически",
  "audit.table.discrepancy": "Расхождение",
  "audit.table.reason": "Причина",
  "audit.total-discrepancy": "Общая стоимость расхождения",
  "audit.button.continue": "Продолжить проверку",
  "audit.status.completed": "Завершено",
  "audit.status.pending": "В процессе",

  /* Stock Return */
  "return.title": "Возврат поставщику",
  "return.button.create": "Создать возврат",
  "return.modal.detail.title": "Детали возврата",
  "return.date": "Дата",
  "return.status": "Статус",
  "return.reason": "Причина",
  "return.table.stock": "Материал",
  "return.table.quantity": "Количество",
  "return.table.price": "Цена",
  "return.table.provider": "Поставщик",
  "return.table.total": "Итого",
  "return.total-value": "Общая стоимость",
  "return.status.completed": "Завершено",
  "return.status.pending": "Обработка",

  /* Stock Disposal */
  "disposal.title": "Списание просроченных или поврежденных материалов",
  "disposal.button.create": "Создать списание",
  "disposal.modal.detail.title": "Детали списания",
  "disposal.date": "Дата",
  "disposal.type": "Тип",
  "disposal.status": "Статус",
  "disposal.type.expired": "Просрочен",
  "disposal.type.damaged": "Поврежден",
  "disposal.type.other": "Другое",
  "disposal.status.completed": "Завершено",
  "disposal.status.pending": "Ожидает",
  "disposal.status.rejected": "Отклонено",
  "disposal.table.stock": "Материал",
  "disposal.table.quantity": "Количество",
  "disposal.table.unit": "Ед. изм.",
  "disposal.table.provider": "Поставщик",
  "disposal.table.refundable": "Возмещаемый",
  "disposal.table.price": "Цена",
  "disposal.table.total": "Итого",
  "disposal.table.reason": "Причина",
  "disposal.total": "Итого",
  "disposal.button.close": "Закрыть",
  "disposal.refundable.yes": "Да",
  "disposal.refundable.no": "Нет",

  /* Invoice (Order) */
  "invoice.title": "Счет",
  "invoice.tab.info": "Общая информация",
  "invoice.tab.deleted": "УДАЛЕННЫЕ СЧЕТА",
  "invoice.empty": "Нет доступных данных...",
  "invoice.menu.restore": "Восстановить счет",
  "invoice.menu.destroy": "Удалить навсегда",
  "invoice.badge.id": "ID Счета",
  "invoice.badge.no-print": "Не напечатан",
  "invoice.discount": "Скидка",
  "invoice.tax": "Налог",
  "invoice.fee": "Сбор",
  "invoice.no-permission": "У вас нет прав для использования этой функции!",
  "invoice.confirm.destroy":
    "Вы уверены, что хотите навсегда удалить этот счет?",
  "invoice.success.restore": "Счет успешно восстановлен",
  "invoice.error.unknown": "Произошла неизвестная ошибка.",

  /* Home Page (Dashboard) */
  "home.wizard.title": "Начальная настройка",
  "home.warning.add-product": "Пожалуйста, добавьте ваш первый товар",
  "home.warning.update-info": "Пожалуйста, обновите информацию о магазине",
  "home.warning.update-payment": "Пожалуйста, обновите информацию о платеже",
  "home.warning.dismiss-template": "Вы просматриваете демонстрационные данные. Пожалуйста, скройте или удалите их перед реальной работой",
  "home.warning.dismiss-btn": "Скрыть демо-данные",
  "home.warning.dismiss-confirm": "Вы уверены, что хотите скрыть все демонстрационные данные?",
  "home.warning.dismiss-success": "Демонстрационные данные успешно скрыты!",
  "home.warning.here": "здесь",
  "home.status-order": "Статус заказа",
  "home.btn.order-preview": "Предпросмотр заказа",
  "home.table.title-orders": "ТОВАРЫ ЗАКАЗА",
  "home.table.title-adjust": "ИЗМЕНИТЬ ЗАКАЗ",
  "home.btn.save-provisional": "Сохранить временно",
  "home.btn.provisional-invoice": "Черновики счетов",
  "home.btn.return-order": "Возврат заказа",

  "home.header.product": "Название товара",
  "home.header.quantity": "Кол-во",
  "home.header.price": "Цена",
  "home.header.total": "Итого",
  "home.header.delete": "Удалить",
  "home.empty": "Товары еще не заказаны!",
  "home.summary.total": "Подытог",
  "home.summary.discount": "Скидка",
  "home.summary.tax": "Налог/Сбор",
  "home.summary.fee-other": "Другой сбор",
  "home.summary.shipping": "Стоимость доставки",
  "home.summary.payment-total": "Итого к оплате",
  "home.shipping.ghn": "Giao Hang Nhanh (GHN)",
  "home.shipping.ghtk": "Giao Hang Tiet Kiem (GHTK)",
  "home.shipping.viettelpost": "Viettel Post",
  "home.shipping.vnpost": "VN Post",
  "home.shipping.ahamove": "Ahamove",
  "home.shipping.lalamove": "Lalamove",
  "home.shipping.grabexpress": "GrabExpress",
  "home.shipping.shopeexpress": "Shopee Xpress",
  "home.shipping.jtexpress": "J&T Express",
  "home.shipping.ninjavan": "Ninja Van",
  "home.shipping.bestexpress": "BEST Express",
  "home.shipping.kerryexpress": "Kerry Express",
  "home.summary.customer-pay": "Клиент заплатил",
  "home.summary.refund": "Сдача",
  "home.summary.missing": "Не хватает",
  "home.order.ice": "Лед",
  "home.order.sugar": "Сахар",

  "home.placeholder.customer-name": "Имя клиента",
  "home.placeholder.phone": "Номер телефона",
  "home.btn.complete-adjust": "Завершить изменение",
  "home.tooltip.missing-amount":
    'Недостающая сумма будет записана как "Долг клиента". Пожалуйста, введите имя и телефон клиента ниже.',
  "home.tooltip.done-pay":
    'При выборе этого пункта, вся сумма счета будет записана как "Долг клиента". Пожалуйста, введите имя и телефон клиента ниже.',
  "home.tooltip.discount": "Эта сумма будет вычтена из Общей суммы.",
  "home.tooltip.tax-fee": "Эта сумма будет добавлена к Общей сумме.",
  "home.tooltip.fee-other": "Эта сумма будет добавлена к Общей сумме.",
  "home.notify.no-products": "Товары не выбраны. Добавьте хотя бы 1 товар.",
  "general.loading": "Загрузка...",
  "general.done": "Готово",
  "general.not-yet": "Еще нет",
  "general.error.title": "Ошибка!",
  "home.btn.close": "Закрыть",
  "home.btn.order": "Заказать (F9)",
  "home.btn.payment": "Оплатить (F9)",
  "home.btn.print-provisional": "Печать черновика (F8)",
  "home.btn.calculating": "Вычисление...",

  "home.alert.call-payment": "Гость просит счет!",
  "home.alert.call-service": "Гость зовет официанта!",
  "home.alert.stock-warning": "Предупреждение о низком запасе",
  "home.notify.no-order-discount": "Нет заказа для применения скидки",
  "home.notify.open-menu-print":
    'Пожалуйста, откройте меню "Другое" для печати черновика',
  "home.notify.no-order-print": "Нет заказа для печати",
  "home.notify.no-payment-btn": "Кнопка оплаты не найдена",
  "home.notify.no-order-pay": "Нет заказа для оплаты",
  "home.notify.save-not-supported":
    "Временное сохранение пока не поддерживается",
  "home.notify.no-order-save": "Нет заказа для временного сохранения",
  "home.notify.scan-success": "Сканирование успешно",
  "home.notify.updated": "Обновлено",
  "home.notify.success": "Успешно",
  "home.notify.update-failed": "Ошибка обновления",
  "home.notify.error": "Ошибка",
  "home.notify.no-permission": "У вас нет прав для использования этой функции!",
  "general.setting": "Настройки",
  "general.error.invalid-data": "Неверные данные",
  "home.summary.no-info": "Нет информации",
  "home.summary.no-setup": "Не настроено",
  "home.summary.no-data": "Нет доступных данных...",
  "home.btn.save-all": "Сохранить все изменения",
  "home.notify.transfer-success": "Перенос стола успешен",
  "home.notify.transfer-failed": "Перенос стола не удался",
  "home.notify.save-error":
    "Произошла ошибка при сохранении скидки/налога/сбора",
  "home.notify.status-error": "Произошла ошибка при обновлении статуса заказа.",

  /* Shortcuts */
  "home.shortcut.f1": "Открыть руководство",
  "home.shortcut.f2": "Поиск товара",
  "home.shortcut.f3": "Управление товарами",
  "home.shortcut.f4": "Скидка / Налог / Сбор",
  "home.shortcut.f8": "Печать черновика",
  "home.shortcut.f9": "Заказ / Оплата",
  "home.shortcut.f10": "Сохранить черновик",
  "home.shortcut.title": "Горячие клавиши",
  "home.shortcut.close": "Нажмите ESC для закрытия",

  /* Provisional Invoice (Drafts) */
  "home.provisional.title": "Черновики счетов",
  "home.provisional.empty": "Нет сохраненных черновиков!",
  "home.provisional.btn-reorder": "ПОВТОРИТЬ",
  "home.provisional.btn-cancel": "ОТМЕНА",
  "home.provisional.counter": "Касса",

  /* Order History & Return */
  "home.history.title": "История заказов",
  "home.history.search": "Поиск",
  "home.history.empty": "Заказы не найдены за выбранный период.",
  "home.history.loading": "Загрузка данных...",
  "home.history.error": "Ошибка загрузки данных. Попробуйте снова.",
  "home.history.invoice": "Счет",
  "home.history.sku": "SKU",
  "home.history.btn-return": "Возврат",
  "home.history.confirm-return": "Вы уверены, что хотите вернуть этот товар?",
  "home.history.return-success": "Возврат и восстановление запасов успешны.",

  /* Common Labels & Options */
  "home.label.product-name": "Название товара",
  "home.label.quantity": "Количество",
  "home.label.price": "Цена",
  "home.label.total": "Итого",
  "home.label.delete": "Удалить",
  "home.label.customer-name": "Имя клиента",
  "home.label.phone": "Номер телефона",
  "home.btn.order-now": "Заказать сейчас !",
  "home.msg.preview-detail": "Предпросмотр деталей",

  "home.option.payment.cash": "Наличные",
  "home.option.payment.transfer": "Перевод",
  "home.option.payment.card": "Карта",
  "home.option.payment.credit": "Долг",
  "home.option.shipping.select": "Выберите перевозчика",
  "home.placeholder.staff": "Продавец",
  "home.placeholder.shipping": "Перевозчик",
  "home.placeholder.payment": "Способ оплаты",

  /* Analytics */
  "analytics.tabs.overview": "Обзор",
  "analytics.tabs.products": "Товары",
  "analytics.tabs.materials": "Материалы",
  "analytics.tabs.customers": "Клиенты",
  "analytics.tabs.staff": "Персонал",
  "analytics.tabs.debt": "Поставщики",
  "analytics.tabs.payment": "Оплата",
  "analytics.tabs.other": "Другое",

  "analytics.summary.total_products": "Всего товаров",
  "analytics.summary.products_with_variants": "Товары с вариантами",
  "analytics.summary.products_on_sale": "В продаже",
  "analytics.summary.products_without_recipe": "Без рецепта",
  "analytics.summary.unsold_products_count": "Непроданные товары",
  "analytics.summary.avg_profit_margin": "Ср. маржа прибыли",
  "analytics.summary.total_materials": "Всего материалов",
  "analytics.summary.low_stock": "Низкий запас (<20% | <10%)",
  "analytics.summary.unassigned_materials": "Назначить материалы",
  "analytics.summary.total_inventory_value": "Общая стоимость запасов",
  "analytics.summary.import_value": "Стоимость импорта",
  "analytics.summary.import_count": "Количество импортов",
  "analytics.summary.total_new_customers": "Новые клиенты",
  "analytics.summary.total_returning_customers": "Вернувшиеся клиенты",
  "analytics.summary.total_spent": "Всего потрачено",
  "analytics.summary.avg_spent_per_customer": "Ср. чек клиента",
  "analytics.summary.customer_debt": "Долг клиентов",
  "analytics.summary.return_rate": "Коэффициент возвратов",
  "analytics.summary.total_sales": "Всего продаж",
  "analytics.summary.total_bills": "Всего чеков",
  "analytics.summary.total_items": "Всего товаров",
  "analytics.summary.avg_revenue_per_hour": "Ср. выручка/час",
  "analytics.summary.active_staff": "Активный персонал",

  "analytics.table.top_selling": "ТОП ПРОДАВАЕМЫХ ТОВАРОВ",
  "analytics.table.top_slow": "МЕДЛЕННО ПРОДАВАЕМЫЕ ТОВАРЫ",
  "analytics.table.payment_method": "СПОСОБЫ ОПЛАТЫ",

  "analytics.error.agency": "Ошибка получения данных АГЕНТСТВА",
  "analytics.error.activity": "Ошибка получения данных АКТИВНОСТИ",
  "analytics.error.outcome": "Ошибка получения данных РАСХОДОВ",
  "analytics.error.income": "Ошибка получения данных ДОХОДОВ",
  "analytics.error.sold_products": "Ошибка получения данных ПРОДАННЫХ ТОВАРОВ",
  "analytics.error.material_import":
    "Ошибка получения данных ИМПОРТА МАТЕРИАЛОВ",
  "analytics.error.debt": "Ошибка получения данных ДОЛГОВ",
  "analytics.error.material_usage":
    "Ошибка получения данных ИСПОЛЬЗОВАНИЯ МАТЕРИАЛОВ",
  "analytics.error.table": "Ошибка получения данных СТОЛОВ",
  "analytics.error.payment_method": "Ошибка получения данных СПОСОБОВ ОПЛАТЫ",
  "analytics.error.top_products": "Ошибка получения данных ТОП ТОВАРОВ",
  "analytics.error.best_selling": "Ошибка получения данных ЛУЧШИХ ПРОДАЖ",
  "analytics.error.customer": "Ошибка получения данных КЛИЕНТОВ",
  "analytics.error.staff": "Ошибка получения данных ПЕРСОНАЛА",
  "analytics.error.booking": "Ошибка получения данных БРОНИРОВАНИЯ",
  "analytics.error.materials": "Ошибка получения данных МАТЕРИАЛОВ",
  "analytics.dashboards.outcome": "РАСХОДЫ",
  "analytics.dashboards.income": "ДОХОДЫ",
  "analytics.dashboards.stock-log": "ЖУРНАЛ СКЛАДА",
  "analytics.dashboards.make-product": "ПРОИЗВОДСТВО",
  "analytics.dashboards.order-table": "Статистика столов",
  "analytics.dashboards.debt": "ДОЛГ",
  "analytics.chart.income": "Доходы",
  "analytics.chart.outcome": "Расходы",
  "analytics.filter.my_store": "Мой магазин",
  "analytics.filter.all": "Все",
  "analytics.filter.today": "Сегодня",
  "analytics.upgrade.notification":
    "Ваш текущий план позволяет просматривать отчет только за сегодня. Пожалуйста, обновитесь для просмотра истории!",
  "analytics.upgrade.title": "Лимит плана",
  "analytics.profit": "Прибыль",
  "analytics.imported-stock-quantity": "Импортировано запасов",
  "analytics.total-stock-value": "Общая стоимость запасов",
  "analytics.pnl.title": "Подробный отчет P&L",
  "analytics.pnl.revenue-header": "💰 ВЫРУЧКА",
  "analytics.pnl.sales-revenue": "Выручка от продаж",
  "analytics.pnl.gross-revenue": "Валовая выручка",
  "analytics.pnl.discount": "(-) Скидка",
  "analytics.pnl.tax": "(+) Налог",
  "analytics.pnl.other-fees": "(+) Другие сборы",
  "analytics.pnl.other-income": "Другие доходы",
  "analytics.pnl.total-revenue": "ИТОГО ВЫРУЧКА",
  "analytics.pnl.cost-header": "📉 РАСХОДЫ",
  "analytics.pnl.cogs": "Себестоимость продаж (COGS)",
  "analytics.pnl.material-cost": "Стоимость материалов",
  "analytics.pnl.gross-profit": "Валовая прибыль",
  "analytics.pnl.operating-expenses": "Операционные расходы",
  "analytics.pnl.fixed-costs": "Постоянные расходы (Свет, Вода, Персонал...)",
  "analytics.pnl.gift-cost": "🎁 Стоимость подарков",
  "analytics.pnl.total-expenses": "ИТОГО РАСХОДЫ",
  "analytics.pnl.net-profit": "💰 ЧИСТАЯ ПРИБЫЛЬ",
  "analytics.pnl.net-loss": "📉 ЧИСТЫЙ УБЫТОК",

  "analytics.table.stt": "№",
  "analytics.table.name": "Название",
  "analytics.table.quantity": "Количество",
  "analytics.table.total": "Итого",
  "analytics.table.price": "Цена",
  "analytics.table.product": "Товар",
  "analytics.table.sold_quantity": "Продано",
  "analytics.table.revenue": "Выручка",
  "analytics.table.cogs": "Себестоимость",
  "analytics.table.profit": "Прибыль",
  "analytics.table.ratio": "Доля",
  "analytics.table.material": "Материал",
  "analytics.table.stock": "Склад",
  "analytics.table.total_import": "Всего импорт",
  "analytics.table.value": "Стоимость",
  "analytics.table.remaining": "Остаток",
  "analytics.table.gift": "Подарок",
  "analytics.table.discount": "Скидка",
  "analytics.table.method": "Метод",
  "analytics.table.order_count": "Заказы",
  "analytics.table.product_count": "Товары",
  "analytics.table.total_amount": "Общая сумма",
  "analytics.table.stock_status.critical": "Критично",
  "analytics.table.stock_status.warning": "Предупреждение",
  "analytics.table.stock_status.normal": "Норма",
  "analytics.table.unit_price": "Цена за ед.",

  "analytics.staff.rank": "Ранг",
  "analytics.staff.name": "Сотрудник",
  "analytics.staff.position": "Должность",
  "analytics.staff.sales": "Продажи",
  "analytics.staff.bill_count": "Заказы",
  "analytics.staff.product_count": "Товары",
  "analytics.staff.revenue_per_hour": "Выр/ч",
  "analytics.staff.commission": "Комиссия",
  "analytics.staff.bonus": "Бонус",
  "analytics.staff.overtime": "Сверхурочные (ч)",
  "analytics.staff.advance": "Аванс",
  "analytics.staff.fined": "Штраф",
  "analytics.staff.no_data": "Нет данных о сотрудниках",
  "analytics.staff.top": "🏆 Топ",

  "analytics.booking.title": "Статистика бронирования",
  "analytics.booking.summary.total": "Всего бронирований",
  "analytics.booking.summary.pending": "Ожидает",
  "analytics.booking.summary.confirmed": "Подтверждено",
  "analytics.booking.summary.completed": "Завершено",
  "analytics.booking.summary.cancelled": "Отменено",
  "analytics.booking.summary.guests": "Всего гостей",
  "analytics.booking.source.phone": "Телефон",
  "analytics.booking.source.walk_in": "Визит",
  "analytics.booking.source.website": "Вебсайт",
  "analytics.booking.source.app": "Приложение",
  "analytics.booking.source.facebook": "Facebook",
  "analytics.booking.source.zalo": "Zalo",
  "analytics.booking.table.stt": "#",
  "analytics.booking.table.date": "Дата",
  "analytics.booking.table.time": "Время",
  "analytics.booking.table.customer": "Клиент",
  "analytics.booking.table.phone": "Телефон",
  "analytics.booking.table.party_size": "Гостей",
  "analytics.booking.table.status": "Статус",
  "analytics.booking.table.source": "Источник",
  "analytics.booking.table.no_data": "Нет данных о бронировании",

  "analytics.customer.name": "Клиент",
  "analytics.customer.phone": "Телефон",
  "analytics.customer.order_count": "Заказы",
  "analytics.customer.products_purchased": "Куплено товаров",
  "analytics.customer.total_spent": "Всего потрачено",
  "analytics.customer.point": "Баллы",
  "analytics.customer.debt": "Долг",
  "analytics.customer.created_at": "Дата создания",
  "analytics.customer.no_data": "Нет доступных данных",

  "chat.permission_denied": "У вас нет прав для использования этой функции!",
  "chat.internal_msg": "Общие сообщения",
  "chat.search_placeholder": "Поиск",
  "chat.max_files_error": "Максимум 3 файла",
  "chat.no_file_guest_error": "Отправка файлов гостям не поддерживается",
  "chat.file_size_error": "Максимальный размер 100 МБ / файл",

  "chat.facebook.messenger": "Messenger",
  "chat.facebook.syncing": "Синхронизация сообщений из Facebook...",
  "chat.facebook.synced_success": "Синхронизировано {count} диалогов",
  "chat.facebook.sync_failed": "Ошибка синхронизации",
  "chat.facebook.sync_error": "Ошибка синхронизации сообщений",
  "chat.facebook.all_pages": "Все страницы",
  "chat.facebook.customer": "Клиент",
  "chat.facebook.no_messages": "Пока нет сообщений",
  "chat.facebook.outside_24h": "Более 24ч - Выберите тег для отправки:",
  "chat.facebook.select_tag": "-- Выберите тег --",
  "chat.facebook.tag.human_agent": "Поддержка клиентов (7 дней)",
  "chat.facebook.tag.post_purchase": "Обновление заказа",
  "chat.facebook.tag.account_update": "Обновление аккаунта",
  "chat.facebook.tag.event_update": "Обновление события",
  "chat.facebook.send_file_error": "Не удалось отправить сообщение",
  "chat.facebook.sync_btn": "Синхронизировать",
  "chat.facebook.processing": "Обработка...",
  "chat.facebook.search_customer": "Поиск клиентов...",
  "chat.facebook.send_error": "Не удалось отправить файл",
  "chat.facebook.token_expired_title": "⚠️ Токен Facebook истёк! Сообщения не могут быть отправлены/получены.",
  "chat.facebook.token_reconnect_btn": "Переподключить Facebook",
  "fb.comment.no-posts": "Посты не найдены",
  "fb.comment.no-posts-hint": "Нажмите \"Синхронизировать\", чтобы загрузить со страницы",
  "fb.comment.loading-comments": "Загрузка комментариев...",
  "fb.comment.no-comments": "Комментарии не найдены",
  "fb.comment.select-post": "Выберите пост для просмотра комментариев",
  "fb.comment.post-detail": "Детали поста",
  "fb.comment.view-on-fb": "Смотреть в Facebook",
  "fb.comment.like": "Нравится",
  "fb.comment.reply": "Ответить",
  "fb.comment.hide": "Скрыть",
  "fb.comment.unhide": "Показать",
  "fb.comment.hidden": "Скрыто",
  "fb.comment.reply-placeholder": "Введите ответ...",
  "fb.comment.edit": "Изменить",
  "fb.comment.delete": "Удалить",
  "fb.comment.filter-all": "Все",
  "fb.comment.filter-unread": "Непрочитанные",
  "fb.comment.filter-unreplied": "Без ответа",
  "fb.comment.status-replied": "Отвечено",
  "fb.comment.loading-posts": "Загрузка постов...",
  "fb.comment.no-pages-desc": "К VMASS еще không подключены Fanpage. Используйте токен доступа Fanpage, чтобы начать управление комментариями.",

  "topnav.search.placeholder.default": "Поиск...",
  "topnav.search.placeholder.dashboard": "Поиск товаров...",
  "topnav.search.placeholder.product": "Поиск товаров...",
  "topnav.search.placeholder.stock": "Поиск материалов...",
  "topnav.search.placeholder.customer": "Поиск клиентов...",
  "topnav.search.placeholder.order": "Поиск заказов...",
  "topnav.search.placeholder.staff": "Поиск персонала...",
  "topnav.search.placeholder.promotion": "Поиск акций...",
  "topnav.search.placeholder.provider": "Поиск поставщиков...",
  "topnav.search.placeholder.income": "Поиск доходов...",
  "topnav.search.placeholder.outcome": "Поиск расходов...",
  "topnav.search.placeholder.cash-flow": "Поиск доходов и расходов...",
  "topnav.search.placeholder.treasury": "Поиск активов...",
  "topnav.search.placeholder.warehouse_export": "Поиск накладных на экспорт...",
  "topnav.search.placeholder.warehouse_import": "Поиск накладных на импорт...",
  "topnav.search.placeholder.warehouse_transfer":
    "Поиск накладных на перемещение...",
  "topnav.search.placeholder.todo": "Поиск задач...",

  "topnav.menu.account": "Аккаунт",
  "topnav.menu.cashier": "Кассир",
  "topnav.menu.waiter": "Официант",
  "topnav.menu.kitchen": "Кухня / Бармен",
  "topnav.menu.settings": "Настройки",
  "topnav.menu.logout": "Выйти",

  "topnav.noti.todo.message": "Проверьте 'Задачи' сейчас",
  "topnav.noti.todo.title": "Напоминание",
  "topnav.noti.order.message": "Новый товар заказан. Проверьте сейчас!",
  "topnav.noti.stock_down.message": "Уровень материала низок!",
  "topnav.noti.stock_down.title": "Предложение докупить",

  "page.heading.excel": "Excel",
  "page.heading.add_from_image": "Добавить товары из изображения",
  "page.heading.create_quantitative": "Создать количественный учет",
  "page.heading.add_bulk": "Добавить товары массово",
  "page.heading.add_quantitative_one": "Создать количественный учет",
  "page.heading.best_seller": "Рекомендуемые",
  "page.heading.un_best_seller": "Не рекомендуемые",
  "page.heading.mark_best_seller": "Пометить как рекомендуемые",
  "page.heading.soft_hide_mixed": "Скрыть/Показать товары",
  "page.heading.soft_hide_show": "Показать товары",
  "page.heading.soft_hide_hide": "Скрыть товары",
  "page.heading.print_sticker": "Печать стикеров",
  "page.heading.import_excel_title": "Импорт данных из Excel",
  "page.heading.import_result": "Результаты импорта",
  "page.heading.import_btn": "Импорт",
  "page.heading.error.limit":
    "Ваш текущий план достиг лимита товаров. Пожалуйста, обновитесь, чтобы добавить больше!",
  "page.heading.error.limit_title": "Лимит плана",

  "product.confirm.delete": "Вы уверены, что хотите удалить эти товары?",
  "product.error.invalid-data": "Неверные данные",
  "product.error.variant-required": "Варианты требуют цены и количества",

  "product.multi.name": "Название товара",
  "product.multi.barcode": "Штрих-код",
  "product.multi.sku": "SKU",
  "product.multi.unit": "Ед. изм.",
  "product.multi.category": "Категория",
  "product.multi.hot": "Хит",
  "product.multi.price": "Цена",
  "product.multi.price_sale": "Цена продажи",
  "product.multi.active_sale": "Распродажа вкл.",
  "product.multi.recipe": "Рецепт",
  "product.multi.variant": "Вариант",
  "product.multi.image": "Изображение",
  "product.multi.soft_hide": "Скрыть",

  "product.variant.default": "Атрибут по умолчанию",
  "product.variant.coming_soon": "Скоро с {date}",
  "product.variant.starts_from": "Начинается с {date}",
  "product.variant.name": "Название варианта",
  "product.variant.sku": "SKU",
  "product.variant.price": "Цена",
  "product.variant.stock": "Запас",
  "product.variant.promo_time": "Время акции",
  "product.variants": "Варианты",

  "customer.export.stt": "№",
  "customer.export.name": "Имя клиента",
  "customer.export.phone": "Телефон",
  "customer.export.email": "Email",
  "customer.export.address": "Адрес",
  "customer.export.used": "Кол-во использований",
  "customer.export.point": "Баллы",
  "customer.export.armorial": "Значок",
  "customer.export.tags": "Теги",
  "customer.export.debt": "Долг",
  "customer.export.total_spent": "Всего потрачено",
  "customer.export.created_at": "Первое использование",
  "customer.export.updated_at": "Обновлено",
  "customer.export.filename": "Список клиентов",

  "stock.export.stt": "№",
  "stock.export.id": "ID",
  "stock.export.name": "Название материала",
  "stock.export.sku": "SKU",
  "stock.export.unit": "Ед. изм.",
  "stock.export.price_new": "Цена импорта",
  "stock.export.inventory": "Инвентарь",
  "stock.export.total": "Общая сумма",
  "stock.export.created_at": "Создано",
  "stock.export.updated_at": "Обновлено",
  "stock.export.filename": "Список материалов",

  "income.export.stt": "№",
  "income.export.name": "Название дохода",
  "income.export.value": "Значение",
  "income.export.address": "Адрес",
  "income.export.note": "Примечание",
  "income.export.created_at": "Создано",
  "income.export.statistic": "Статистика",
  "income.statistic.exclude": "Исключено",
  "income.statistic.include": "Включено",
  "income.export.creator": "Создатель",
  "income.export.filename": "Список доходов",

  "outcome.export.stt": "№",
  "outcome.export.name": "Название расхода",
  "outcome.export.value": "Значение",
  "outcome.export.address": "Адрес",
  "outcome.export.note": "Примечание",
  "outcome.export.created_at": "Создано",
  "outcome.export.statistic": "Статистика",
  "outcome.statistic.exclude": "Исключено",
  "outcome.statistic.include": "Включено",
  "outcome.export.creator": "Создатель",
  "outcome.export.filename": "Список расходов",

  "todo.export.filename": "Список задач",
  "page.heading.excel.tooltip": "Скачать данные в Excel файл",
  "analytics.export.name": "Название",
  "analytics.export.quantity": "Количество",
  "analytics.export.total_price": "Общая сумма",
  "analytics.export.product": "Товар",
  "analytics.export.revenue": "Выручка",
  "analytics.export.method": "Метод",
  "analytics.export.order_count": "Количество заказов",
  "analytics.export.supplier": "Поставщик",
  "analytics.export.customer": "Клиент",
  "analytics.export.phone": "Телефон",
  "analytics.export.spent": "Потрачено",
  "analytics.export.created_at": "Дата создания",
  "analytics.export.material": "Материал",
  "analytics.export.unit": "Ед. изм.",
  "analytics.export.table": "Стол",
  "analytics.export.discount": "Скидка",
  "analytics.export.stock": "Запас",
  "analytics.export.min_stock": "Мин. запас",
  "analytics.export.date": "Дата",
  "analytics.export.time": "Время",
  "analytics.export.party_size": "Размер группы",
  "analytics.export.status": "Статус",
  "analytics.export.source": "Источник",
  "analytics.export.sheet.sold_products": "Проданные товары",
  "analytics.export.sheet.top_spenders": "Топ покупателей",
  "analytics.export.sheet.imported_materials": "Импортированные материалы",
  "analytics.export.sheet.used_materials": "Использованные материалы",
  "analytics.export.sheet.booking": "Бронирование",
  "analytics.export.success": "Экспорт в Excel успешен!",

  /* AI Configuration */
  "settings.ai.default_persona": "Вы дружелюбный агент поддержки клиентов.",

  /* Upgrade */
  "upgrade.price.currency": "{price} VND",
  "upgrade.feature.billing": "Расчет и оплата",
  "upgrade.feature.print_invoice": "Печать счетов",
  "upgrade.feature.accounts": "Аккаунты персонала",
  "upgrade.feature.sales": "Управление продажами",
  "upgrade.feature.products": "Товары и инвентарь",
  "upgrade.value.products.free": "30 Товаров",
  "upgrade.value.products.basic": "Безлимит",
  "upgrade.value.unlimited": "Безлимит",
  "upgrade.time.1m": "1 Месяц",
  "upgrade.features": "Функции",
  "make-product.select-or-create": "Выберите или создайте новый",
  "make-product.unit": "Ед. изм.",
  "make-product.no-recipe": "У этого товара пока нет рецепта!",
  "make-product.cost-price": "Себестоимость",
  "make-product.cost-ratio": "Соотношение Себестоимость / Цена",
  "general.add": "Добавить",

  "stock.header.material_name": "Название материала",
  "stock.header.unit": "Ед. изм.",
  "stock.header.total_import": "Всего импорт",
  "stock.header.new_quantity": "Новое количество",
  "stock.header.inventory": "Инвентарь",
  "stock.header.below_20": "Ниже 20%",
  "stock.header.below_10": "Ниже 10%",
  "stock.header.true": "Да",
  "stock.header.false": "Нет",

  "income.header.name": "Название дохода",
  "income.header.payer": "Плательщик",
  "income.header.address": "Адрес",
  "income.header.amount": "Сумма",
  "income.header.description": "Описание",
  "income.header.status": "Статус",
  "income.header.statistic": "Статистика",
  "income.header.creator": "Создатель",
  "income.header.created_at": "Создано",

  "outcome.header.name": "Название расхода",
  "outcome.header.receiver": "Получатель",
  "outcome.header.amount": "Сумма",
  "outcome.header.description": "Описание",
  "outcome.header.address": "Адрес",
  "outcome.header.status": "Статус",
  "outcome.header.statistic": "Статистика",
  "outcome.header.creator": "Создатель",
  "outcome.header.created_at": "Создано",

  "customer.header.name": "Имя клиента",
  "customer.header.phone": "Телефон",
  "customer.header.email": "Email",
  "customer.header.address": "Адрес",
  "customer.header.points": "Баллы",
  "customer.header.used_count": "Кол-во использований",
  "customer.header.total_spent": "Всего потрачено",
  "customer.header.rank": "Ранг",
  "customer.header.debt": "Долг",
  "customer.header.created_at": "Первое использование",
  "customer.header.updated_at": "Обновлено",

  "provider.header.name": "Имя поставщика",
  "provider.header.phone": "Телефон",
  "provider.header.email": "Email",
  "provider.header.address": "Адрес",
  "provider.header.total_import": "Всего импорт",
  "provider.header.paid": "Оплачено",
  "provider.header.remaining": "Остаток",

  "warehouse.transfer.header.item": "Перемещенный товар",
  "warehouse.transfer.header.quantity": "Перемещенное количество",
  "warehouse.transfer.header.price": "Цена перемещения",
  "warehouse.transfer.header.description": "Описание",
  "warehouse.transfer.header.status": "Статус",
  "warehouse.transfer.header.sender": "Отправитель",
  "warehouse.transfer.header.phone": "Телефон",
  "warehouse.transfer.header.carrier": "Перевозчик",
  "warehouse.transfer.header.carrier_phone": "Телефон перевозчика",
  "warehouse.transfer.header.destination": "На склад",
  "warehouse.transfer.header.transport": "Транспортировка",
  "warehouse.transfer.header.shipping_cost": "Стоимость доставки",
  "warehouse.transfer.header.creator": "Создатель",
  "warehouse.transfer.header.created_at": "Создано",

  "warehouse.import.header.item": "Импортированный товар",
  "warehouse.import.header.unit": "Ед. изм.",
  "warehouse.import.header.quantity": "Количество импорта",
  "warehouse.import.header.price": "Цена импорта",
  "warehouse.import.header.status": "Статус",
  "warehouse.import.header.importer": "Импортер",
  "warehouse.import.header.phone": "Телефон",
  "warehouse.import.header.address": "Адрес",
  "warehouse.import.header.created_at": "Создано",

  "warehouse.export.header.item": "Экспортированный товар",
  "warehouse.export.header.quantity": "Количество экспорта",
  "warehouse.export.header.price": "Цена экспорта",
  "warehouse.export.header.status": "Статус",
  "warehouse.export.header.description": "Описание",
  "warehouse.export.header.creator": "Создатель",
  "warehouse.export.header.created_at": "Создано",

  "treasury.header.name": "Название актива",
  "treasury.header.value": "Значение",
  "treasury.header.note": "Примечание",
  "treasury.header.statistic": "Статистика",
  "treasury.header.creator": "Создатель",
  "treasury.header.created_at": "Создано",

  "modal.stock.stt": "№",
  "modal.stock.sku": "SKU",
  "modal.stock.barcode": "Штрих-код",
  "modal.stock.supplier": "Поставщик",
  "modal.stock.remaining": "Остаток",
  "modal.stock.expired": "Срок годности",

  "table.import.sku": "SKU",
  "table.import.barcode": "Штрих-код",
  "table.import.price_sale": "Цена продажи",
  "table.import.price_promotion": "Акционная цена",
  "table.import.apply_promotion": "Применить акцию",
  "table.import.image": "Изображение",
  "table.import.image_sub": "Доп. изображение",
  "table.import.recommend": "Рекомендованное",
  "table.import.hidden": "Скрыто",
  "table.import.description": "Описание",
  "table.import.size": "Размер",
  "table.import.topping": "Топпинг",
  "table.import.ice": "Кол-во льда",
  "table.import.sugar": "Уровень сахара",
  "table.import.color": "Цвет",
  "table.import.material": "Материал",
  "table.import.result": "Результат импорта",
  "table.import.reason": "Причина ошибки",

  "modal.product.stt": "#",
  "modal.product.barcode_enter": "Штрих-код (Ввод)",
  "modal.product.unit": "Количественный",
  "modal.product.combo": "Комбо/Произв.",
  "modal.product.variant": "Вариант",
  "modal.product.supplier": "Поставщик",
  "modal.product.paid": "Оплачено",
  "modal.product.remaining": "Остаток",
  "modal.product.image": "Изображение",
  "modal.product.hot": "Хит",
  "modal.product.delete": "Удалить",
  "modal.auto-generate": "Авто-генерация",
  "modal.stock.confirm-import": "Подтвердить импорт",
  "modal.add-row": "Добавить строку",
  "tooltip.not-for-combo": "Неприменимо для Комбо товаров",
  "tooltip.unit-hint":
    "Введите наименьшую единицу этого товара, например, используйте Упаковка вместо Ящик",
  "tooltip.enable-combo":
    "Включить Количественный режим: Позволяет выбирать несколько ингредиентов (Комбо/SX). Себестоимость и количество импорта будут рассчитаны на основе рецепта, а не прямого ввода.",
  "label.create-new": "Создать новый",
  "label.select-or-create": "Выберите или создайте...",
  "label.enter-product-name": "Введите название товара...",
  "label.enter-barcode": "Введите штрих-код...",
  "label.select-create-provider": "Выберите/Создайте поставщика...",
  "menu.product.recommended": "Рекомендуемые товары",
  "menu.product.discount": "Скидка",
  "menu.product.recipe": "Рецепт",
  "menu.stock.inventory": "Инвентарь",
  "menu.stock.less-than-50": "Менее 50%",
  "menu.stock.less-than-20": "Менее 20%",
  "menu.stock.less-than-10": "Менее 10%",
  "menu.stock.cost-price": "Себестоимость",
  "menu.stock.cost-price-done": "Себестоимость введена",
  "menu.stock.cost-price-not-yet": "Себестоимость отсутствует",
  "menu.stock.import-time": "Время импорта",
  "menu.stock.recent-5-days": "Последние 5 дней",
  "menu.stock.recent-10-days": "Последние 10 дней",
  "todo.tasks": "Задачи",
  "todo.today": "Сегодня",
  "todo.this-week": "Эта неделя",
  "todo.this-month": "Этот месяц",
  "todo.upcoming": "Предстоящие",
  "todo.next-1-hour": "Следующий 1 час",
  "todo.next-3-hours": "Следующие 3 часа",
  "todo.next-6-hours": "Следующие 6 часов",
  "todo.past": "Прошедшие",
  "todo.past-7-days": "Прошедшие 7 дней",
  "todo.past-30-days": "Прошедшие 30 дней",
  "todo.past-6-months": "Прошедшие 6 месяцев",
  "chat.broadcast-all-stores": "Отправить всем магазинам",
  "menu.customer.debt": "Долг",
  "menu.customer.no-debt": "Нет долга",
  "menu.customer.have-debt": "Есть долг",
  "menu.customer.badge": "Значок",
  "menu.customer.no-badge": "Нет значка",
  "menu.customer.bronze": "Бронза",
  "menu.customer.gold": "Золото",
  "menu.customer.platinum": "Платина",
  "menu.customer.tags": "Теги",
  "menu.provider.transaction": "Транзакция",
  "menu.provider.paid-all": "Оплачено все",
  "menu.provider.debt": "Долг",
  "menu.provider.no-transaction": "Нет транзакций",
  "menu.provider.products": "Товары",
  "menu.staff.work-status": "Статус работы",
  "menu.staff.working": "Работает",
  "menu.staff.quit": "Уволен",
  "menu.staff.position": "Должность",
  "price.under-1m": "Менее 1 миллиона",
  "price.1m-to-10m": "1 миллион - 10 миллионов",
  "price.over-10m": "Более 10 миллионов",
  "menu.finance.include-statistics": "Включить в статистику",
  "menu.finance.price-range": "Диапазон цен",
  "menu.finance.creator": "Создатель",
  "menu.stock.status": "Статус",
  "status.draft": "Черновик",
  "status.in-progress": "В прогрессе",
  "status.completed": "Завершено",
  "menu.stock.time": "Время",
  "general.this-month": "Этот месяц",
  "general.last-month": "Прошлый месяц",
  "menu.audit.result": "Результат",
  "menu.audit.has-discrepancy": "Есть расхождения",
  "status.pending": "Ожидает",
  "status.approved": "Одобрено",
  "status.rejected": "Отклонено",
  "menu.disposal.type": "Тип списания",
  "disposal.expired": "Просрочено",
  "disposal.damaged": "Повреждено",
  "menu.stock.statistics": "Статистика",
  "menu.stock.total-tickets": "Всего заявок",
  "menu.stock.total-value": "Общая стоимость",
  "status.processing": "Обработка",
  "menu.warehouse.status": "Статус",
  "menu.warehouse.quantity-range": "Количество",
  "menu.warehouse.unit": "Ед. изм.",
  "quantity.under-10": "Менее 10",
  "quantity.10-to-50": "10 - 50",
  "quantity.over-50": "Более 50",

  "table.import.success": "Импорт успешен",
  "table.import.failed": "Не удалось",
  "table.import.error_reason": "Причина ошибки",

  "modal.alert.min-one-material": "Пожалуйста, введите хотя бы один материал.",
  "modal.alert.check-required": "Пожалуйста, проверьте обязательные поля:\n\n",
  "modal.alert.missing-unit": 'Строка {index} - "{name}": Отсутствует ед. изм.',
  "modal.alert.price-must-positive":
    'Строка {index} - "{name}": Цена должна быть > 0',
  "modal.alert.quantity-must-positive":
    'Строка {index} - "{name}": Качество должно быть > 0',
  "modal.alert.barcode-duplicate-list":
    "Дубликат штрих-кода в списке. Пожалуйста, проверьте снова.",
  "modal.alert.barcode-duplicate-db":
    'Штрих-код "{barcode}" уже существует для материала "{name}". Пожалуйста, используйте другой код.',

  "unit.placeholder.cafe": "Чашка, стакан, тарелка...",
  "unit.placeholder.fashion": "Штука, пара, комплект...",
  "unit.placeholder.cosmetics": "Бутылка, тюбик, банка...",
  "unit.placeholder.retail": "Штука, упаковка, коробка, кг...",
  "unit.placeholder.default": "Штука, коробка, упаковка...",

  "product.price.cost": "Себестоимость",
  "product.promotion-price": "Акционная цена",

  "general.all": "Все",
  "general.yes": "Да",
  "general.no": "Нет",

  "modal.stock.stt": "№",
  "modal.stock.sku": "SKU",
  "modal.stock.barcode": "Штрих-код",
  "modal.stock.supplier": "Поставщик",
  "modal.stock.remaining": "Остаток",
  "modal.stock.expired": "Срок годности",
  "modal.stock.confirm-import": "Подтвердить импорт",
  "modal.add-row": "Добавить строку",
  "modal.auto-generate": "Авто-генерация",

  "tooltip.unit-hint": "Введите ед. изм. (например, кг, коробка...)",
  "tooltip.not-for-combo": "Неприменимо для Комбо товаров",
  "tooltip.enable-combo": "Включить Комбо (Количественный)",

  "label.select-or-create": "Выберите или создайте...",
  "label.create-new": "Создать новый",
  "label.select-create-provider": "Выберите или создайте поставщика...",
  "label.enter-barcode": "Введите штрих-код",
  "label.enter-product-name": "Введите название товара",

  "modal.product.combo": "Комбо",
  "modal.product.paid": "Оплачено",
  "page.heading.export-filename": "Список товаров",
  "product.alert.create-variant-missing-unit":
    "Пожалуйста, введите Ед. изм. перед созданием вариантов.",
  "product.alert.sync-stock-confirm":
    "Количество импорта в основной форме ({mainFormQuantity}) отличается от общего количества вариантов ({totalVariantQuantity}).\n\nВы хотите обновить количество в основной форме до {totalVariantQuantity}?",
  "product.validation.missing-name": "Название товара",
  "product.validation.missing-category": "Категория",
  "product.validation.missing-price": "Цена",
  "product.validation.missing-unit": "Ед. изм.",
  "product.validation.missing-import-quantity": "Количество импорта",
  "product.validation.missing-cost-price": "Себестоимость",
  "product.validation.barcode-duplicate-list":
    'Штрих-код "{barcode}" дублируется в этом списке',
  "product.validation.barcode-duplicate-system":
    'Штрих-код "{barcode}" уже существует в системе',
  "product.alert.validation-check-info":
    "Пожалуйста, проверьте информацию снова:\n",
  "label.create-new-value": 'Создать "{value}"',
  "product.template.default": "Product_Import_Template.xlsx",
  "product.template.cafe": "Cafe_Product_Template.xlsx",
  "product.template.restaurant": "Restaurant_Product_Template.xlsx",
  "product.template.fashion": "Fashion_Product_Template.xlsx",
  "product.template.retail": "Retail_Product_Template.xlsx",
  "product.template.cosmetics": "Cosmetics_Product_Template.xlsx",

  VD: "Напр.",
  "analytics.export.stt": "№",
  "analytics.export.total": "Итого",
  "analytics.update": "Обновить анализ",
  "product.btn-add": "Добавить товар",
  "product.tab.add-multiple": "Добавить несколько",
  "product.tab.add-one": "Добавить один",
  "settings.invoice.process-3-old": "Процесс 3 (Старый)",
  "settings.invoice.process-4-old": "Процесс 4 (Старый)",

  /* Missing Keys Added (Translated) */
  "todo.detail": "Подробности",
  "todo.cancel": "Отмена",
  "todo.submit": "Отправить",
  "todo.status": "Статус",
  "todo.all-tasks": "Все задачи",
  "todo.pending-tasks": "Ожидающие задачи",
  "todo.completed-tasks": "Завершенные задачи",
  "todo.categories": "Категории",
  "todo.labels": "Метки",
  "menu.charts": "Графики",
  "chat.all_messages": "Все сообщения",
  "menu.chat": "Чат",
  "menu.survey": "Опрос",
  "input.to": "Кому",
  "input.email": "Введите email",
  "product.name": "Название товара",
  "modal.alert.warning": "Внимание",
  "general.done": "Готово",
  "general.not-yet": "Еще нет",
  "product.add.quantity": "Добавить количество",
  "user-staff.date_start": "Дата начала",
  "user-staff.date_end": "Дата окончания",
  "general.other": "Другое",
  "stock.inventory": "Инвентарь",
  "stock.total-import": "Всего импортировано",

  "settings.email.placeholder.gmail-email": "Введите Gmail",
  "settings.email.placeholder.smtp-email": "Введите SMTP Email",
  "profile.edit": "Редактировать профиль",
  "menu.blank-page": "Пустая страница",
  "action.success": "Успех",
  "promotion-discount-add": "Добавить код скидки",
  "settings.ai.save-btn": "Сохранить конфигурацию AI",
  "settings.partner.env.test-label": "Тестовая среда",
  "invoice.tab.einvoice": "Электронный счет",
  "einvoice.list.title": "Список электронных счетов",
  "einvoice.status.draft": "Черновик",
  "einvoice.status.issued": "Выпущен",
  "einvoice.status.signed": "Подписан",
  "einvoice.status.sent": "Отправлен",
  "einvoice.status.cancelled": "Отменен",
  "einvoice.action.view-pdf": "Просмотреть PDF",
  "einvoice.action.download-pdf": "Скачать PDF",
  "einvoice.action.send-email": "Отправить Email",
  "einvoice.action.cancel": "Отменить счет",
  "einvoice.action.check-status": "Проверить статус",
  "einvoice.correction.adjust": "Корректировать",
  "einvoice.correction.replace": "Заменить",
  "einvoice.correction.edit-draft": "Редактировать черновик SePay",
  "einvoice.correction.modal-adjust-title": "Корректировочный счет SePay",
  "einvoice.correction.modal-replace-title": "Счет на замену SePay",
  "einvoice.correction.submit": "Отправить в SePay",
  "einvoice.mapping.preview": "Предпросмотр синхронизации VMASS",
  "einvoice.mapping.applied": "Применено",
  "einvoice.mapping.pending": "Ожидает применения",
  "einvoice.mapping.conflict": "Конфликт; создайте новый документ",
  "einvoice.mapping.failed": "Техническая ошибка; будет повтор",
  "einvoice.mapping.inventory": "Запасы по счету",
  "einvoice.mapping.inventory-applied": "Ингредиенты: восстановлено {restored}, списано {deducted}; варианты: восстановлено {variantsRestored}, списано {variantsDeducted}",
  "einvoice.correction.save-draft": "Сохранить черновик в SePay",
  "einvoice.correction.issue-now": "Выпустить сейчас",
  "einvoice.action.issue-official": "Официальный выпуск",
  "einvoice.action.reissue": "Перевыпустить",
  "einvoice.cancel.reason": "Причина отмены",
  "einvoice.email.placeholder": "Введите email получателя",
  "einvoice.alert.cancel-confirm": "Вы уверены, что хотите отменить этот счет?",
  "einvoice.alert.email-success": "Email успешно отправлен!",
  "einvoice.action.edit": "Редактировать счет",
  "einvoice.edit.title": "Редактировать детали счета",
  "einvoice.edit.customer-name": "Название компании / Имя покупателя",
  "einvoice.edit.email": "Email для получения счета",
  "einvoice.edit.payment-method": "Способ оплаты",
  "einvoice.edit.note": "Примечания",
  "einvoice.edit.placeholder.customer-name": "Название компании или полное имя клиента",
  "einvoice.edit.placeholder.tax-id": "ИНН предприятия",
  "einvoice.edit.placeholder.address": "Юридический адрес предприятия",
  "einvoice.edit.placeholder.email": "email@company.com",
  "einvoice.edit.placeholder.phone": "Номер телефона для получения счета",
  "einvoice.edit.placeholder.note": "Примечания к счету",
  "button.save-changes": "Сохранить изменения",
  "einvoice.notification.status-updated": "Статус счета обновлен",
  "einvoice.notification.email-required": "Пожалуйста, введите адрес электронной почты",
  "einvoice.notification.cancel-reason-required": "Пожалуйста, укажите причину отмены",
  "einvoice.notification.cancel-success": "Счет успешно отменен",
  "einvoice.notification.issue-official-success": "Официальный счет успешно выставлен",
  "einvoice.notification.customer-name-required": "Пожалуйста, введите название компании/имя покупателя",
  "einvoice.notification.update-success": "Информация о счете успешно обновлена",
  "einvoice.notification.missing-contact-info": "В счете отсутствуют Email и телефон. Пожалуйста, выберите «Редактировать счет», чтобы добавить их перед перевыпуском.",

  /* Table Headers - E-Invoice */
  "table.invoice-no": "№ счета",
  "table.customer": "Клиент",
  "table.date": "Дата",
  "table.total": "Итого",
  "table.status": "Статус",
  "table.action": "Действие",
  "table.no-data": "Нет данных",
  "button.refresh": "Обновить",
  "button.cancel": "Отмена",
  "einvoice.checkbox.issue": "Выставить электронный счёт",
  "einvoice.success.issued": "Электронный счёт успешно выставлен",
  "einvoice.error.issue-failed": "Ошибка выставления электронного счёта",
  "table.phone": "Телефон",
  "table.address": "Адрес",
  "table.email": "Email",
  "table.discount": "Скидка",
  "table.payment_method": "Метод оплаты",
  "table.note": "Примечание",
  "table.tax": "ИНН",
  "settings.einvoice.sepay-client-id": "ID Клиента",
  "settings.einvoice.sepay-client-secret": "Секрет Клиента",
  "settings.einvoice.sepay-template-code": "Код Шаблона Счета",
  "settings.einvoice.automation": "Настройка Автоматизации",
  "settings.einvoice.auto-issue":
    "Всегда отмечать галочку 'Выставить счет' (По умолчанию: Откл)",
  "settings.einvoice.auto-draft":
    "Всегда создавать черновик счета, если не выбрано (По умолчанию: Вкл)",
  "settings.email.placeholder.gmail-email": "Введите Gmail",
  "settings.email.placeholder.smtp-email": "Введите SMTP Email",
  "settings.einvoice.title": "Электронный счет",
  "settings.einvoice.save-success": "Конфигурация успешно сохранена",
  "settings.einvoice.save-error": "Ошибка сохранения конфигурации",
  "settings.einvoice.test-success": "Подключение успешно",
  "settings.einvoice.test-fail": "Ошибка подключения",
  "settings.email.save-success": "Конфигурация почты успешно сохранена",
  "settings.email.save-error": "Ошибка сохранения конфигурации почты",
  "settings.email.test-success": "Тестовое письмо успешно отправлено",
  "settings.email.test-error": "Ошибка отправки тестового письма",
  /* Shopee */
  "menu.ecommerce": "Электронная торговля",
  "menu.shopee": "Shopee",
  "menu.tiktok-shop": "TikTok Shop",
  "menu.lazada": "Lazada",
  "menu.tiki": "Tiki",
  "ecommerce.coming-soon": "Скоро",
  "ecommerce.coming-soon-desc": "Эта функция находится в разработке. Скоро мы поддержим эту платформу!",
  "shopee.tab.connection": "Подключение",
  "shopee.tab.orders": "Заказы",
  "shopee.tab.products": "Товары",
  "shopee.tab.inventory": "Склад",
  "shopee.connection.title": "Подключение магазина Shopee",
  "shopee.connection.desc": "Подключите магазин Shopee для синхронизации заказов, товаров и склада.",
  "shopee.connect.btn": "Подключить магазин",
  "shopee.connect.error": "Ошибка подключения Shopee",
  "shopee.disconnect.btn": "Отключить",
  "shopee.disconnect.confirm": "Вы уверены, что хотите отключить этот магазин?",
  "shopee.disconnect.success": "Магазин отключен",
  "shopee.disconnect.error": "Ошибка отключения",
  "shopee.oauth.success": "Магазин Shopee успешно подключен.",
  "shopee.oauth.error.missing-params": "Shopee не вернул все необходимые данные авторизации.",
  "shopee.oauth.error.invalid-state": "Сеанс подключения Shopee недействителен или истёк. Повторите попытку.",
  "shopee.oauth.error.not-configured": "Учетные данные Shopee Partner не настроены.",
  "shopee.oauth.error.shop-already-connected": "Этот магазин Shopee подключен к другой учетной записи VMASS.",
  "shopee.oauth.error.callback-failed": "Не удалось завершить подключение Shopee. Повторите попытку.",
  "shopee.oauth.error.upgrade-required": "Обновите тариф, чтобы использовать интеграцию Shopee.",
  "shopee.oauth.error.generic": "Shopee отклонил запрос на подключение. Повторите попытку.",
  "shopee.no-shop": "Нет подключенных магазинов Shopee.",
  "shopee.select-shop": "Выбрать магазин",
  "shopee.table.name": "Название",
  "shopee.table.id": "ID",
  "shopee.table.region": "Регион",
  "shopee.table.token-expires": "Статус токена",
  "shopee.table.connected": "Дата",
  "shopee.token.expired": "Истек",
  "shopee.token.active": "Активен",
  "shopee.orders.filter.all": "Все статусы",
  "shopee.orders.sync-btn": "Синхронизировать из Shopee",
  "shopee.orders.bulk-sync": "Синхронизировать все в VMASS",
  "shopee.orders.sync.error": "Ошибка синхронизации заказов",
  "shopee.orders.sync-to-bill": "Синхронизировать в VMASS",
  "shopee.orders.sync-bill.error": "Ошибка синхронизации заказа",
  "shopee.orders.load.error": "Ошибка загрузки заказов",
  "shopee.orders.empty": "Нет заказов.",
  "shopee.orders.col.sn": "Заказ №",
  "shopee.orders.col.status": "Статус",
  "shopee.orders.col.buyer": "Покупатель",
  "shopee.orders.col.amount": "Сумма",
  "shopee.orders.col.date": "Дата",
  "shopee.orders.col.synced": "Синхронизирован",
  "shopee.synced": "Синхронизирован",
  "shopee.not-synced": "Не синхронизирован",
  "shopee.products.mapped": "Связь товаров",
  "shopee.products.view-shopee": "Просмотр в Shopee",
  "shopee.products.import-btn": "Импорт из Shopee",
  "shopee.products.load.error": "Ошибка загрузки товаров",
  "shopee.products.import.error": "Ошибка импорта",
  "shopee.products.empty": "Нет связанных товаров.",
  "shopee.products.col.name": "Название",
  "shopee.products.col.sku": "SKU",
  "shopee.products.col.price": "Цена",
  "shopee.products.col.stock": "Склад",
  "shopee.products.col.vmass": "VMASS",
  "shopee.products.linked": "Связан",
  "shopee.products.not-linked": "Не связан",
  "shopee.products.map-btn": "Связать",
  "shopee.products.map.success": "Товар связан",
  "shopee.products.map.error": "Ошибка связывания",
  "shopee.products.map-modal.title": "Связать товар Shopee с VMASS",
  "shopee.products.map-modal.select": "Выберите товар VMASS",
  "shopee.products.map-modal.placeholder": "Выбрать товар",
  "shopee.products.map-modal.save": "Сохранить",
  "shopee.cancel": "Отмена",
  "shopee.inventory.title": "Синхронизация склада",
  "shopee.inventory.desc": "Отправить остатки VMASS в Shopee.",
  "shopee.inventory.sync-btn": "Синхронизировать склад",
  "shopee.inventory.sync.error": "Ошибка синхронизации склада",
  "shopee.inventory.no-linked": "Нет связанных товаров.",
  "shopee.inventory.col.shopee-stock": "Склад Shopee",
  "shopee.inventory.col.vmass-product": "Товар VMASS",
  "shopee.inventory.col.sync-enabled": "Синхронизация",
  "shopee.inventory.col.last-sync": "Последняя синхр.",
  "shopee.logistics.ship-btn": "Отправить",
  "shopee.logistics.track-btn": "Отследить",
  "shopee.logistics.ship.error": "Ошибка оформления отправки",
  "shopee.logistics.track.error": "Ошибка загрузки отслеживания",
  "shopee.logistics.modal.title": "Логистика",
  "shopee.logistics.phone": "Телефон",
  "shopee.logistics.address": "Адрес",
  "shopee.logistics.carrier": "Перевозчик",
  "shopee.logistics.tracking-no": "Трек-номер",
  "shopee.logistics.arrange": "Оформить отправку",
  "shopee.logistics.pickup-address": "Адрес забора",
  "shopee.logistics.confirm-ship": "Подтвердить отправку",
  "shopee.logistics.timeline": "Хронология отслеживания",
  "shopee.logistics.no-tracking": "Информация об отслеживании пока недоступна.",
  "shopee.tab.returns": "Возвраты",
  "shopee.tab.analytics": "Аналитика",
  "shopee.tab.settings": "Настройки",
  "shopee.tab.monitor": "Мониторинг",
  "shopee.returns.title": "Возвраты и Возмещения",
  "shopee.returns.refresh": "Обновить",
  "shopee.returns.empty": "Нет запросов на возврат/возмещение.",
  "shopee.returns.col.sn": "№ Возврата",
  "shopee.returns.col.order": "№ Заказа",
  "shopee.returns.col.reason": "Причина",
  "shopee.returns.col.status": "Статус",
  "shopee.returns.col.amount": "Сумма возврата",
  "shopee.returns.col.date": "Дата",
  "shopee.returns.col.buyer": "Покупатель",
  "shopee.returns.accept": "Принять",
  "shopee.returns.dispute": "Оспорить",
  "shopee.returns.load.error": "Ошибка загрузки возвратов",
  "shopee.returns.detail.error": "Ошибка загрузки деталей",
  "shopee.returns.detail.title": "Детали возврата",
  "shopee.returns.confirm.prompt": "Вы уверены, что хотите принять этот возврат?",
  "shopee.returns.confirm.error": "Ошибка подтверждения возврата",
  "shopee.returns.dispute.title": "Оспорить возврат",
  "shopee.returns.dispute.email": "Контактный email",
  "shopee.returns.dispute.reason": "Причина оспаривания",
  "shopee.returns.dispute.submit": "Отправить",
  "shopee.returns.dispute.success": "Спор отправлен успешно",
  "shopee.returns.dispute.error": "Ошибка отправки спора",
  "shopee.returns.buyer-note": "Примечание покупателя",
  "shopee.analytics.title": "Аналитика Shopee",
  "shopee.analytics.no-data": "Нет данных аналитики.",
  "shopee.analytics.total-orders": "Всего заказов",
  "shopee.analytics.revenue": "Выручка",
  "shopee.analytics.synced": "Синхронизировано в VMASS",
  "shopee.analytics.products-linked": "Связано товаров",
  "shopee.analytics.by-status": "Заказы по статусу",
  "shopee.analytics.last-7-days": "Последние 7 дней",
  "shopee.analytics.col.date": "Дата",
  "shopee.analytics.col.orders": "Заказы",
  "shopee.analytics.col.revenue": "Выручка",
  "shopee.analytics.date-range": "Период",
  "shopee.analytics.date-hint": "Данные Shopee доступны за период не более 90 дней (3 месяца). Выберите диапазон.",
  "shopee.analytics.max-range": "Период не может превышать 90 дней (3 месяца)",
  "shopee.analytics.invalid-range": "Дата начала должна быть раньше даты окончания",
  "shopee.settings.title": "Настройки Shopee",
  "shopee.settings.auto-sync-orders": "Автосинхронизация заказов",
  "shopee.settings.auto-sync-orders.desc": "Автоматически загружать новые заказы",
  "shopee.settings.sync-interval": "Интервал синхронизации",
  "shopee.settings.sync-interval.desc": "Частота проверки новых заказов",
  "shopee.settings.auto-bill": "Автосоздание счетов",
  "shopee.settings.auto-bill.desc": "Автоматически создавать счета VMASS",
  "shopee.settings.auto-inventory": "Автосинхронизация склада",
  "shopee.settings.auto-inventory.desc": "Автоматически отправлять остатки в Shopee",
  "shopee.settings.notifications": "Уведомления",
  "shopee.settings.notify-new-order": "Новый заказ",
  "shopee.settings.notify-status": "Изменение статуса",
  "shopee.settings.notify-return": "Запрос на возврат",
  "shopee.settings.save": "Сохранить",
  "shopee.settings.save.success": "Настройки сохранены",
  "shopee.settings.save.error": "Ошибка сохранения",
  "shopee.monitor.health": "Состояние подключения",
  "shopee.monitor.no-shops": "Нет подключенных магазинов.",
  "shopee.monitor.last-sync": "Последняя синхр.",
  "shopee.monitor.expiring-soon": "Скоро истекает",
  "shopee.monitor.activity": "Журнал активности",
  "shopee.monitor.filter.all": "Вся активность",
  "shopee.monitor.no-activity": "Нет недавней активности.",
  "shopee.push.modal.title": "Публикация товара на Shopee",
  "shopee.push.step": "Шаг",
  "shopee.push.step.select": "Выберите товар VMASS",
  "shopee.push.step.category": "Выберите категорию Shopee",
  "shopee.push.step.details": "Детали товара",
  "shopee.push.step.confirm": "Проверка и публикация",
  "shopee.push.form.name": "Название товара (5-120 символов)",
  "shopee.push.form.description": "Описание (мин. 25 символов)",
  "shopee.push.form.price": "Цена",
  "shopee.push.form.weight": "Вес (кг)",
  "shopee.push.form.condition": "Состояние",
  "shopee.push.form.condition.new": "Новый",
  "shopee.push.form.condition.used": "Б/у",
  "shopee.push.form.status": "Статус публикации",
  "shopee.push.form.status.normal": "Активный (NORMAL)",
  "shopee.push.form.status.unlist": "Скрытый (UNLIST)",
  "shopee.push.form.logistics": "Каналы доставки",
  "shopee.push.form.attributes": "Атрибуты категории",
  "shopee.push.form.category": "Категория Shopee",
  "shopee.push.form.dimension": "Размеры упаковки",
  "shopee.push.btn.next": "Далее",
  "shopee.push.btn.back": "Назад",
  "shopee.push.btn.push": "Опубликовать на Shopee",
  "shopee.push.btn.push-short": "На Shopee",
  "shopee.push.btn.select": "Выбрать",
  "shopee.push.btn.cancel": "Отмена",
  "shopee.push.validate.name": "Название должно быть от 5 до 120 символов",
  "shopee.push.validate.description": "Описание должно быть не менее 25 символов",
  "shopee.push.validate.price": "Цена должна быть больше 0",
  "shopee.push.validate.weight": "Вес должен быть от 0.01 до 50 кг",
  "shopee.push.validate.category": "Выберите категорию",
  "shopee.push.validate.logistics": "Выберите хотя бы один канал доставки",

  "suggestion.title": "Рекомендации",
  "suggestion.frequently-bought": "Покупают вместе",
  "suggestion.bestseller": "Бестселлер",
  "analytics.product_customers.title": "Покупатели товара",
  "analytics.product_customers.identified": "Опознанные клиенты",
  "analytics.product_customers.anonymous": "Гостевые заказы",
  "analytics.product_customers.quantity": "Количество",
  "analytics.product_customers.revenue": "Выручка",
  "analytics.product_customers.search": "Поиск",
  "analytics.product_customers.customer": "Клиент",
  "analytics.product_customers.orders": "Заказы",
  "analytics.product_customers.spent": "Потрачено",
  "analytics.product_customers.last_purchase": "Последняя покупка",
  "analytics.product_customers.empty": "Подходящих клиентов нет",
  "analytics.product_customers.customers": "клиентов",
  "analytics.summary.total_products_sold_period": "Продано товаров за период",
  "analytics.summary.total_quantity_sold_period": "Количество продаж за период",
  "analytics.summary.product_revenue_period": "Выручка по товарам",
  "analytics.summary.product_cost_period": "Себестоимость товаров",
  "analytics.summary.product_gross_profit_period": "Валовая прибыль",
  "analytics.summary.product_margin_period": "Маржа прибыли",
  "shopee.workspace.title": "Центр операций Shopee",
  "shopee.workspace.subtitle": "Заказы, каталог, запасы, доставка и расчёты по магазинам",
  "shopee.workspace.overview": "Обзор",
  "shopee.workspace.catalog": "Каталог",
  "shopee.workspace.inventory": "Запасы",
  "shopee.workspace.fulfillment": "Доставка",
  "shopee.workspace.returns": "Возвраты",
  "shopee.workspace.finance": "Финансы",
  "shopee.workspace.automation": "Автоматизация",
  "shopee.workspace.logs": "Журнал",
  "shopee.workspace.refresh": "Обновить",
  "shopee.workspace.search": "Поиск",
  "shopee.workspace.from-date": "С даты",
  "shopee.workspace.to-date": "По дату",
  "shopee.workspace.loading": "Загрузка данных Shopee…",
  "shopee.workspace.no-data": "Нет данных",
  "shopee.workspace.actions": "Действия",
  "shopee.workspace.gmv": "GMV",
  "shopee.workspace.refunds": "Возвраты средств",
  "shopee.workspace.fees": "Комиссии Shopee",
  "shopee.workspace.net-revenue": "Чистая выручка",
  "shopee.workspace.payout": "Полученная выплата",
  "shopee.workspace.issues": "Проблемы",
  "shopee.workspace.issue-center": "Центр проблем",
  "shopee.workspace.order-issues": "проблемы заказов",
  "shopee.workspace.mapping-issues": "проблемы сопоставления",
  "shopee.workspace.job-issues": "сбойные задания",
  "shopee.workspace.retry-selected-orders": "Повторить выбранные заказы",
  "shopee.workspace.auto-map-selected": "Автосопоставление точных SKU",
  "shopee.workspace.create-selected-drafts": "Создать выбранные черновики",
  "shopee.workspace.issue-reason": "Проблема",
  "shopee.workspace.item-model": "Товар / модель",
  "shopee.workspace.job": "Задание",
  "shopee.workspace.replay": "Повторить",
  "shopee.workspace.no-issues": "Проблем не найдено",
  "shopee.workspace.confirm-remediation": "Подтвердить исправление",
  "shopee.workspace.confirm-remediation-detail": "Действие обрабатывает только выбранные записи и является идемпотентным.",
  "shopee.workspace.sync": "Синхронизировать",
  "shopee.workspace.mapping": "Сопоставление",
  "shopee.workspace.sync-state": "Состояние синхронизации",
  "shopee.workspace.amount": "Сумма",
  "shopee.workspace.create-bill": "Создать счёт",
  "shopee.workspace.import-catalog": "Импорт каталога",
  "shopee.workspace.map-product": "Сопоставить товар",
  "shopee.workspace.mapping-wizard": "Сопоставить вариант Shopee с VMASS",
  "shopee.workspace.search-product": "Поиск товаров VMASS",
  "shopee.workspace.choose-product": "Выбрать товар VMASS",
  "shopee.workspace.choose-variant": "Выбрать вариант VMASS",
  "shopee.workspace.create-draft": "Создать черновик VMASS",
  "shopee.workspace.update-listing": "Обновить листинг",
  "shopee.workspace.list-listing": "Опубликовать",
  "shopee.workspace.unlist-listing": "Скрыть",
  "shopee.workspace.variant-prices": "Цены вариантов",
  "shopee.workspace.image-urls": "URL изображений",
  "shopee.workspace.image-help": "Один разрешённый URL ресурса VMASS на строку; изображения отправляются только после изменения поля.",
  "shopee.workspace.length": "Длина (см)",
  "shopee.workspace.width": "Ширина (см)",
  "shopee.workspace.height": "Высота (см)",
  "shopee.workspace.vmass-product-id": "ID товара VMASS",
  "shopee.workspace.vmass-variant-id": "ID варианта VMASS (пусто для простого товара)",
  "shopee.workspace.mapping-help": "Перед сохранением система проверяет tenant и принадлежность варианта товару.",
  "shopee.workspace.sync-stock": "Синхронизировать запас",
  "shopee.workspace.shopee-stock": "Запас Shopee",
  "shopee.workspace.state": "Статус",
  "shopee.workspace.reservation": "Резерв",
  "shopee.workspace.tracking": "Трек-номер",
  "shopee.workspace.ship": "Отправить",
  "shopee.workspace.ship-confirm": "Подтвердить отправку",
  "shopee.workspace.shipping-params-error": "Не удалось загрузить параметры доставки",
  "shopee.workspace.shipping-method": "Способ передачи",
  "shopee.workspace.pickup-address": "Адрес забора",
  "shopee.workspace.pickup-time": "Время забора",
  "shopee.workspace.confirm": "Подтвердить",
  "shopee.workspace.accept": "Принять",
  "shopee.workspace.dispute": "Оспорить",
  "shopee.workspace.return-reason": "Причина решения по возврату",
  "shopee.workspace.return-evidence": "Доказательства (ID изображений через запятую)",
  "shopee.workspace.sync-finance": "Синхронизировать расчёты",
  "shopee.workspace.create-income": "Создать приход",
  "shopee.workspace.save": "Сохранить",
  "shopee.workspace.sync-interval": "Интервал (минуты)",
  "shopee.workspace.resource": "Ресурс",
  "shopee.workspace.attempts": "Попытки",
  "shopee.workspace.created-at": "Создано",
  "shopee.workspace.retry": "Повторить",
  "shopee.workspace.setting.auto_sync_orders": "Автосинхронизация заказов",
  "shopee.workspace.setting.auto_create_bill": "Автосоздание счёта перед отправкой",
  "shopee.workspace.setting.auto_sync_inventory": "Автосинхронизация запасов",
  "shopee.workspace.setting.auto_sync_catalog": "Автосинхронизация каталога товаров",
  "shopee.workspace.catalog-sync-interval": "Интервал синхронизации каталога (минуты)",
  "shopee.workspace.catalog-sync-hint": "От 60 до 10080 минут; по умолчанию 1440 минут (ежедневно).",
  "shopee.workspace.catalog-last-sync": "Последняя успешная синхронизация каталога",
  "shopee.workspace.catalog-next-sync": "Следующая синхронизация каталога",
  "shopee.workspace.select-shop-for-automation": "Выберите конкретный магазин для настройки автоматизации.",
  "shopee.workspace.select-shop-for-listing": "Выберите конкретный магазин перед добавлением или изменением товара.",
  "shopee.workspace.listing-load-incomplete": "Не удалось загрузить часть данных товара Shopee. Проверьте доступные данные и повторите попытку.",
  "shopee.workspace.listing-no-candidates": "Нет доступных товаров VMASS для публикации на Shopee.",
  "shopee.workspace.setting.notify_new_order": "Уведомлять о новых заказах Shopee",
  "shopee.workspace.setting.notify_status_change": "Уведомлять об изменении статуса заказа",
  "shopee.workspace.setting.notify_return": "Уведомлять о возвратах",
  "shopee.workspace.inventory-safety-buffer": "Страховой запас, не публикуемый в Shopee",
  "shopee.workspace.scope-not-granted": "Магазин не предоставил необходимое разрешение Shopee:",
  "shopee.workspace.group.overview": "ОБЗОР",
  "shopee.workspace.group.catalog": "СКЛАД И ТОВАРЫ",
  "shopee.workspace.group.logistics": "ДОСТАВКА И ФИНАНСЫ",
  "shopee.workspace.group.system": "СИСТЕМА",
  "shopee.workspace.tab.overview": "Обзор",
  "shopee.workspace.tab.orders": "Заказы",
  "shopee.workspace.tab.products": "Мультиканальные товары",
  "shopee.workspace.tab.mappings": "Привязка товаров",
  "shopee.workspace.tab.inventory": "Остатки по каналам",
  "shopee.workspace.tab.pricing": "Цены по каналам",
  "shopee.workspace.tab.shipping": "Доставка и упаковка",
  "shopee.workspace.tab.returns": "Возвраты и возмещения",
  "shopee.workspace.tab.reconciliation": "Сверка и выплаты",
  "shopee.workspace.tab.issues": "Центр проблем",
  "shopee.workspace.tab.connections": "Каналы и подключения",
  "shopee.workspace.tab.connections-short": "Канал продаж",
  "shopee.workspace.tab.automation": "Автоматизация",
  "shopee.workspace.tab.logs": "Журнал задач",
  "shopee.workspace.connect-required.title": "Требуется подключение аккаунта Shopee",
  "shopee.workspace.connect-required.desc": "Ваш аккаунт ещё не подключён ни к одному магазину Shopee. Подключите магазин Shopee, чтобы просматривать отчёты, управлять заказами и товарами, а также синхронизировать остатки.",
  "shopee.workspace.connect-required.feature.orders": "Автосинхронизация заказов",
  "shopee.workspace.connect-required.feature.mapping": "Привязка SKU и управление запасами",
  "shopee.workspace.connect-required.feature.shipping": "Обновление статусов доставки",
  "shopee.workspace.connect-required.feature.finance": "Сверка выручки и выплаты",
  "shopee.workspace.connect-required.connecting": "Подключение...",
  "shopee.workspace.connect-required.cta": "🚀 Подключить магазин Shopee сейчас",
  "shopee.workspace.sidebar.shops-header": "Магазины",
  "shopee.workspace.sidebar.add-shop-title": "Подключить новый магазин Shopee",
  "shopee.workspace.sidebar.refresh-title": "Обновить данные",
  "shopee.workspace.sidebar.all-shops": "📊 Все магазины ({count})",
  "shopee.workspace.sidebar.shop-fallback": "Магазин {shopId}",
  "shopee.workspace.sidebar.connected-count": "{count} подключённых каналов",
  "shopee.workspace.sidebar.not-connected": "Не подключено",
  "shopee.workspace.common.sending-request": "Отправка запроса...",
  "shopee.workspace.common.sync": "Синхронизировать",
  "shopee.workspace.common.edit": "Изменить",
  "shopee.workspace.common.per-page": "{size} / стр.",
  "shopee.workspace.common.product-name": "Название товара",
  "shopee.workspace.common.customer": "Клиент",
  "shopee.workspace.common.previous": "Назад",
  "shopee.workspace.common.next": "Далее",
  "shopee.workspace.common.loading": "Загрузка...",
  "shopee.workspace.common.page": "Страница",
  "shopee.workspace.common.of": "из",
  "shopee.workspace.common.rows": "строк",
  "shopee.workspace.common.all-statuses": "Все статусы",
  "shopee.workspace.common.all-channels": "Все каналы",
  "shopee.workspace.common.filter": "Фильтры",
  "shopee.workspace.common.tab-all-count": "Все ({count})",
  "shopee.workspace.common.view-all": "Показать все",
  "shopee.workspace.common.total": "Всего",
  "shopee.workspace.common.note": "Примечание",
  "shopee.workspace.common.optional": "необязательно",
  "shopee.workspace.common.note-placeholder": "Введите примечание...",
  "shopee.workspace.common.last-7-days": "Последние 7 дней",
  "shopee.workspace.common.last-30-days": "Последние 30 дней",
  "shopee.workspace.catalog.channel-all": "Все",
  "shopee.workspace.catalog.not-synced-yet": "Не синхронизировано",
  "shopee.workspace.catalog.minutes-ago": "{count} мин. назад",
  "shopee.workspace.catalog.hours-ago": "{count} ч. назад",
  "shopee.workspace.catalog.channel-unlisted": "Не опубликовано",
  "shopee.workspace.catalog.publish-now": "Опубликовать сейчас",
  "shopee.workspace.catalog.sync-error-short": "Ошибка синхронизации",
  "shopee.workspace.catalog.out-of-stock": "Нет в наличии",
  "shopee.workspace.catalog.listed": "Опубликовано",
  "shopee.workspace.catalog.view-error": "Открыть ошибку",
  "shopee.workspace.catalog.mapping-saved": "Привязка товара обновлена",
  "shopee.workspace.catalog.mapping-cleared": "Привязка товара Shopee удалена из VMASS",
  "shopee.workspace.catalog.inventory-sync-queued": "Синхронизация остатков запланирована",
  "shopee.workspace.catalog.import-queued": "Импорт каталога запланирован",
  "shopee.workspace.catalog.kpi-total-listings": "Всего листингов",
  "shopee.workspace.catalog.kpi-total-listings-note": "{count} строк привязки",
  "shopee.workspace.catalog.kpi-mapped": "Привязано",
  "shopee.workspace.catalog.kpi-page-percent": "{percent}% на странице",
  "shopee.workspace.catalog.kpi-unmapped": "Без привязки",
  "shopee.workspace.catalog.note-needs-action": "Требует обработки",
  "shopee.workspace.catalog.kpi-sync-errors": "Ошибки синхронизации",
  "shopee.workspace.catalog.note-priority": "Приоритетная обработка",
  "shopee.workspace.catalog.kpi-out-of-stock": "Нет в наличии",
  "shopee.workspace.catalog.note-at-shopee": "На канале Shopee",
  "shopee.workspace.catalog.kpi-price-pending": "Ожидает обновления цены",
  "shopee.workspace.catalog.note-sync-price": "Требуется синхронизация цен",
  "shopee.workspace.catalog.filter-aria": "Фильтры товаров",
  "shopee.workspace.catalog.search-placeholder": "Поиск товаров, SKU, штрихкодов...",
  "shopee.workspace.catalog.channel-aria": "Канал продаж",
  "shopee.workspace.catalog.mapping-state-aria": "Статус привязки",
  "shopee.workspace.catalog.sync-state-aria": "Статус синхронизации",
  "shopee.workspace.catalog.mapping-all": "Все привязки",
  "shopee.workspace.catalog.mapping-mapped": "Привязано",
  "shopee.workspace.catalog.mapping-unmapped": "Без привязки",
  "shopee.workspace.catalog.sync-state-all": "Состояние синхронизации",
  "shopee.workspace.catalog.sync-state-error": "С ошибками",
  "shopee.workspace.catalog.add-product": "Добавить товар",
  "shopee.workspace.catalog.select-all-aria": "Выбрать все товары",
  "shopee.workspace.catalog.col-product": "Товар",
  "shopee.workspace.catalog.col-sku-vmass": "SKU VMASS",
  "shopee.workspace.catalog.col-price": "Цена продажи",
  "shopee.workspace.catalog.col-stock": "Остаток",
  "shopee.workspace.catalog.col-sync-state": "Статус синхронизации",
  "shopee.workspace.catalog.col-last-update": "Обновлено",
  "shopee.workspace.catalog.select-row-aria": "Выбрать {name}",
  "shopee.workspace.catalog.no-vmass-mapping": "Нет привязки к VMASS",
  "shopee.workspace.catalog.no-vmass-sku": "Нет SKU VMASS",
  "shopee.workspace.catalog.open-detail-aria": "Открыть подробности",
  "shopee.workspace.catalog.pagination-summary": "Показано {from} - {to} из {total} строк привязки",
  "shopee.workspace.catalog.detail-sku-label": "SKU VMASS:",
  "shopee.workspace.catalog.detail-item-label": "Товар Shopee:",
  "shopee.workspace.catalog.close-detail-aria": "Закрыть подробности",
  "shopee.workspace.catalog.nav-stock": "Остатки",
  "shopee.workspace.catalog.nav-history": "История",
  "shopee.workspace.catalog.unmapped-badge": "Без привязки",
  "shopee.workspace.catalog.sku-shopee": "SKU Shopee",
  "shopee.workspace.catalog.update-mapping": "Обновить привязку",
  "shopee.workspace.catalog.map-product-btn": "Привязать товар",
  "shopee.workspace.catalog.no-channel-info": "Информация о товаре пока отсутствует",
  "shopee.workspace.catalog.publish-to": "Опубликовать на {channel}",
  "shopee.workspace.catalog.sync-shopee-catalog": "Синхронизировать каталог Shopee",
  "shopee.workspace.catalog.unmap": "Отвязать",
  "shopee.workspace.catalog.sku-name-placeholder": "SKU / название товара",
  "shopee.workspace.catalog.draft-created": "Создан черновик товара VMASS с нулевым остатком",
  "shopee.workspace.catalog.listing-show-queued": "Запрос на показ листинга поставлен в очередь",
  "shopee.workspace.catalog.listing-hide-queued": "Запрос на скрытие листинга поставлен в очередь",
  "shopee.workspace.fulfillment.ship-queued": "Запрос на отправку поставлен в очередь",
  "shopee.workspace.returns.status.requested": "Новая заявка",
  "shopee.workspace.returns.status.in-inspection": "Проверяется",
  "shopee.workspace.returns.status.waiting-refund": "Ожидает возмещения",
  "shopee.workspace.returns.status.processing": "В обработке",
  "shopee.workspace.returns.status.completed": "Завершено",
  "shopee.workspace.returns.status.rejected": "Отклонено",
  "shopee.workspace.returns.status.restocked": "Принято на склад",
  "shopee.workspace.returns.status.waiting-confirm": "Ожидает подтверждения",
  "shopee.workspace.returns.inspection-confirmed": "Проверка возврата подтверждена, остатки обновлены",
  "shopee.workspace.returns.dispute-queued": "Запрос на спор поставлен в очередь",
  "shopee.workspace.returns.customer-fallback": "Клиент",
  "shopee.workspace.returns.reason-other": "Другое",
  "shopee.workspace.returns.reason-detail-fallback": "Заявка на возврат",
  "shopee.workspace.returns.item-fallback": "Товар",
  "shopee.workspace.returns.subtitle": "Управляйте всеми заявками на возврат, возмещения и обмены",
  "shopee.workspace.returns.export-excel": "Экспорт в Excel",
  "shopee.workspace.returns.report": "Отчёт",
  "shopee.workspace.returns.create-request": "Создать заявку на возврат",
  "shopee.workspace.returns.kpi-requested-note": "Новые и ожидающие подтверждения",
  "shopee.workspace.returns.kpi-processing-note": "Проверка и обработка",
  "shopee.workspace.returns.kpi-waiting-refund-note": "Ожидают возмещения",
  "shopee.workspace.returns.kpi-completed-note": "Полностью обработаны",
  "shopee.workspace.returns.kpi-rejected-note": "Отклонённые заявки",
  "shopee.workspace.returns.total-refund-today": "Всего возмещено (сегодня)",
  "shopee.workspace.returns.return-value-today": "Стоимость возвратов (сегодня)",
  "shopee.workspace.returns.pipeline.customer-request": "Запрос от покупателя",
  "shopee.workspace.returns.pipeline.inspect": "Проверка товара",
  "shopee.workspace.returns.pipeline.approve": "Одобрение возврата",
  "shopee.workspace.returns.pipeline.restock-dispose": "Приёмка / Списание",
  "shopee.workspace.returns.pipeline.refund": "Возмещение",
  "shopee.workspace.returns.search-placeholder": "Поиск по коду возврата, заказу, имени, телефону...",
  "shopee.workspace.returns.all-reasons": "Все причины",
  "shopee.workspace.returns.all-warehouses": "Все склады",
  "shopee.workspace.returns.no-data": "Заявок на возврат нет",
  "shopee.workspace.returns.detail-title": "Детали возврата",
  "shopee.workspace.returns.original-order": "Исходный заказ",
  "shopee.workspace.returns.customer-media": "Фото/видео клиента",
  "shopee.workspace.returns.no-media": "Клиент не приложил фото",
  "shopee.workspace.returns.returned-products": "Возвращённые товары",
  "shopee.workspace.returns.qty-label": "Кол-во",
  "shopee.workspace.returns.inspection-title": "Проверка возвращённого товара",
  "shopee.workspace.returns.check.intact": "Товар целый",
  "shopee.workspace.returns.check.packaging": "Упаковка и ярлыки",
  "shopee.workspace.returns.check.accessories": "Комплектация полная",
  "shopee.workspace.returns.check.correct-product": "Верный товар",
  "shopee.workspace.returns.check.defect": "Брак / Повреждение",
  "shopee.workspace.returns.processing-title": "Обработка возврата",
  "shopee.workspace.returns.action.restock": "Принять на склад",
  "shopee.workspace.returns.action.exchange": "Обмен",
  "shopee.workspace.returns.action.discard": "Списать",
  "shopee.workspace.returns.restock-warehouse": "Склад приёмки",
  "shopee.workspace.returns.confirm-continue": "Подтвердить и продолжить",
  "shopee.workspace.returns.popular-reasons": "Популярные причины возврата",
  "shopee.workspace.returns.no-reason-data": "Данных о причинах пока нет",
  "shopee.workspace.returns.top-returned": "Топ возвращаемых товаров",
  "shopee.workspace.returns.times-suffix": "раз",
  "shopee.workspace.returns.no-returned-products": "Возвращённых товаров пока нет",
  "shopee.workspace.returns.refund-trend": "Динамика возмещений",
  "shopee.workspace.returns.performance": "Эффективность обработки",
  "shopee.workspace.returns.avg-processing-time": "Среднее время обработки",
  "shopee.workspace.returns.on-time-rate": "Доля завершённых в срок",
  "shopee.workspace.returns.sample-processing-time": "1,8 дня",
  "shopee.workspace.returns.sample-processing-delta": "-0,3 дня",
  "shopee.workspace.returns.dispute-modal-title": "Открыть спор в Shopee",
  "shopee.workspace.returns.inspection-modal-title": "Акт проверки возврата",
  "shopee.workspace.returns.condition-placeholder": "Опишите фактическое состояние полученного товара...",
  "shopee.workspace.returns.stock-decision": "Решение по складу",
  "shopee.workspace.returns.stock.resellable": "1. Целый -> Вернуть в товарный склад",
  "shopee.workspace.returns.stock.defective": "2. Повреждён / Грязный -> На склад брака",
  "shopee.workspace.returns.stock.discard": "3. Сильные повреждения / Списать -> Не принимать на склад",
  "shopee.workspace.returns.stock.shortage": "4. Недостача / Подмена -> Оформить акт недостачи",
  "shopee.workspace.returns.evidence-placeholder": "Ссылки на фото/видео доказательства проверки (URL 1, URL 2)...",
  "shopee.workspace.returns.col.sn": "Код возврата",
  "shopee.workspace.returns.col.order": "Исходный заказ",
  "shopee.workspace.returns.col.channel": "Канал",
  "shopee.workspace.returns.col.reason": "Причина возврата",
  "shopee.workspace.returns.col.refund-value": "Сумма возмещения",
  "shopee.workspace.returns.col.warehouse": "Склад",
  "shopee.workspace.returns.col.status": "Статус",
  "shopee.workspace.returns.col.created-at": "Дата создания",
  "shopee.workspace.returns.action.inspect": "Проверить и принять на склад",
  "shopee.workspace.returns.action.dispute": "Создать спор в Shopee",
  "shopee.workspace.returns.view-detail-title": "Посмотреть детали",
  "shopee.workspace.automation.settings-saved": "Настройки автоматизации сохранены",
  "shopee.workspace.logs.replayed": "Задача перезапущена",
  "shopee.workspace.common.detail": "Подробнее",
  "shopee.workspace.common.page-count": "/ {total} стр.",
  "shopee.workspace.common.no-data": "Данных пока нет",
  "shopee.workspace.common.close": "Закрыть",
  "shopee.workspace.orders.status.all": "Все",
  "shopee.workspace.orders.status.unpaid": "Не оплачен",
  "shopee.workspace.orders.status.ready-to-ship": "Ожидает обработки",
  "shopee.workspace.orders.status.processed": "Обработан",
  "shopee.workspace.orders.status.shipped": "В доставке",
  "shopee.workspace.orders.status.to-confirm-receive": "Ожидает подтверждения получения",
  "shopee.workspace.orders.status.completed": "Доставлен",
  "shopee.workspace.orders.status.in-cancel": "Отменяется",
  "shopee.workspace.orders.status.cancelled": "Отменён",
  "shopee.workspace.orders.status-unknown": "Неизвестно",
  "shopee.workspace.orders.metric.total": "Всего заказов",
  "shopee.workspace.orders.metric.total-indicator": "{count} на странице",
  "shopee.workspace.orders.metric.pending": "Ожидают обработки",
  "shopee.workspace.orders.metric.pending-indicator": "{percent}% страницы",
  "shopee.workspace.orders.metric.deadline": "Сроки отправки",
  "shopee.workspace.orders.metric.deadline-overdue": "{count} просрочено",
  "shopee.workspace.orders.metric.deadline-window": "{risk}/{total} со сроком",
  "shopee.workspace.orders.metric.deadline-none": "Нет заказов, ожидающих отправки",
  "shopee.workspace.orders.metric.gmv": "GMV заказов",
  "shopee.workspace.orders.metric.gmv-indicator": "{paid}/{eligible} заказов с суммой",
  "shopee.workspace.orders.metric.delivered": "Доставлено",
  "shopee.workspace.orders.tabs-region-aria": "Панель статусов заказов, прокрутите по горизонтали",
  "shopee.workspace.orders.count-tooltip": "Заказы на текущей странице",
  "shopee.workspace.orders.select-all-aria": "Выбрать все заказы",
  "shopee.workspace.orders.select-row-aria": "Выбрать заказ {sn}",
  "shopee.workspace.orders.col.sn": "Код заказа",
  "shopee.workspace.orders.col.channel": "Канал",
  "shopee.workspace.orders.col.items": "Товары",
  "shopee.workspace.orders.col.amount": "Сумма",
  "shopee.workspace.orders.col.tracking": "Трек-номер",
  "shopee.workspace.orders.col.time": "Время",
  "shopee.workspace.orders.phone-hidden": "Информация скрыта",
  "shopee.workspace.orders.items-count": "{count} шт.",
  "shopee.workspace.orders.items-total-x": "Всего x{count}",
  "shopee.workspace.orders.paid-time": "Оплачен в {time}",
  "shopee.workspace.orders.paid-time-missing": "Shopee не вернул время оплаты",
  "shopee.workspace.orders.sync-queued": "Синхронизация заказов запланирована",
  "shopee.workspace.orders.sync-button": "Синхронизировать заказы",
  "shopee.workspace.orders.selection-banner": "Выбрано заказов: {count}.",
  "shopee.workspace.orders.export-selected": "Экспортировать выбранные",
  "shopee.workspace.orders.clear-selection": "Снять выделение",
  "shopee.workspace.orders.empty": "Подходящих заказов нет.",
  "shopee.workspace.orders.showing-summary": "Показано {shown} / {total} заказов",
  "shopee.workspace.orders.filter-title": "Фильтры поиска",
  "shopee.workspace.orders.clear-filters": "Сбросить фильтры",
  "shopee.workspace.orders.filter-status-label": "Статус заказа",
  "shopee.workspace.orders.filter-search-label": "Поисковый запрос",
  "shopee.workspace.orders.search-placeholder": "Код заказа или трек-номер...",
  "shopee.workspace.orders.apply-filters": "Применить фильтры",
  "shopee.workspace.orders.chart-title": "Распределение статусов на странице",
  "shopee.workspace.orders.detail-title": "Детали заказа Shopee #{orderSn}",
  "shopee.workspace.orders.detail-loading": "Загрузка деталей заказа...",
  "shopee.workspace.orders.detail-load-error": "Не удалось загрузить дополнительные детали заказа.",
  "shopee.workspace.orders.phone-label": "Телефон:",
  "shopee.workspace.orders.tracking-label": "Трек-номер:",
  "shopee.workspace.orders.total-shopee": "Сумма Shopee",
  "shopee.workspace.orders.created-at": "Время создания заказа",
  "shopee.workspace.orders.ship-deadline": "Срок отправки Shopee",
  "shopee.workspace.orders.items-title": "Список товаров ({count})",
  "shopee.workspace.orders.price-per-item": "{price} / шт.",
  "shopee.workspace.orders.create-bill": "Создать счёт VMASS",
  "shopee.workspace.orders.bill-created": "Счёт создан из заказа Shopee",
  "shopee.workspace.orders.csv.order-code": "Код заказа",
  "shopee.workspace.orders.csv.phone": "Телефон",
  "shopee.workspace.orders.csv.products": "Товары",
  "shopee.workspace.orders.csv.amount": "Сумма",
  "shopee.workspace.overview.webhook.configured": "Настроен",
  "shopee.workspace.overview.webhook.processing": "Обрабатывается",
  "shopee.workspace.overview.webhook.degraded": "Требует проверки",
  "shopee.workspace.overview.webhook.not-configured": "Не настроен",
  "shopee.workspace.overview.webhook.unknown": "Неизвестно",
  "shopee.workspace.overview.kpi.new-orders": "Новые заказы",
  "shopee.workspace.overview.kpi.new-trend": "Новые",
  "shopee.workspace.overview.kpi.new-comparison": "Новые заказы за сегодня",
  "shopee.workspace.overview.kpi.pending": "Ожидают / Упаковка",
  "shopee.workspace.overview.kpi.pending-trend": "Требуют обработки",
  "shopee.workspace.overview.kpi.pending-comparison": "Готовы к передаче",
  "shopee.workspace.overview.kpi.expiring": "Истекает срок передачи",
  "shopee.workspace.overview.kpi.expiring-priority": "Приоритет",
  "shopee.workspace.overview.kpi.expiring-safe": "В норме",
  "shopee.workspace.overview.kpi.expiring-comparison": "Обработать в ближайшее время",
  "shopee.workspace.overview.kpi.gmv": "Выручка за сегодня (GMV)",
  "shopee.workspace.overview.kpi.gmv-trend": "Суммарный GMV",
  "shopee.workspace.overview.kpi.gmv-comparison": "Общая выручка",
  "shopee.workspace.overview.kpi.ontime": "Доставка в срок",
  "shopee.workspace.overview.kpi.ontime-trend": "В рамках стандарта",
  "shopee.workspace.overview.kpi.ontime-comparison": "Показатель эффективности",
  "shopee.workspace.overview.issue.orders": "Заказы к обработке",
  "shopee.workspace.overview.issue.orders-desc": "Заказы, требующие обработки для соблюдения сроков доставки.",
  "shopee.workspace.overview.issue.mappings": "Привязки к обработке",
  "shopee.workspace.overview.issue.mappings-desc": "SKU без привязки или с неверной привязкой.",
  "shopee.workspace.overview.issue.jobs": "Задачи с ошибками",
  "shopee.workspace.overview.issue.jobs-desc": "Задачи синхронизации с ошибками требуют проверки.",
  "shopee.workspace.overview.issue.products": "Товары без информации",
  "shopee.workspace.overview.issue.products-desc": "Товары с неполной информацией в части каналов.",
  "shopee.workspace.overview.issue.reconciliation": "Расхождения сверки",
  "shopee.workspace.overview.issue.reconciliation-desc": "Заказы с расхождениями, требующими сверки.",
  "shopee.workspace.overview.shop-fallback": "Shopee - Магазин {shopId}",
  "shopee.workspace.overview.shop-label": "Магазин {shopId}",
  "shopee.workspace.overview.activity.sync-default": "Синхронизация",
  "shopee.workspace.overview.activity.just-now": "Только что",
  "shopee.workspace.overview.activity.success": "Успешно",
  "shopee.workspace.overview.activity.attempts": "{count} запусков",
  "shopee.workspace.overview.banner-title": "Обзор состояния и эффективности канала Shopee",
  "shopee.workspace.overview.banner-healthy": "Система работает нормально",
  "shopee.workspace.overview.banner-attention": "Требует внимания",
  "shopee.workspace.overview.banner-shops-updated": "{count} магазинов подключено | Обновлено: {time}",
  "shopee.workspace.overview.period.today": "Сегодня",
  "shopee.workspace.overview.period.week": "7 дней",
  "shopee.workspace.overview.period.month": "30 дней",
  "shopee.workspace.overview.reload": "Обновить данные",
  "shopee.workspace.overview.mapping-title": "Прогресс привязки SKU",
  "shopee.workspace.overview.mapping-tooltip": "Синхронизация фактических остатков между Shopee и VMASS",
  "shopee.workspace.overview.mapping-percent": "{percent}% привязано",
  "shopee.workspace.overview.mapping-progress": "Привязано {mapped} / {total} SKU товаров",
  "shopee.workspace.overview.mapping-note": "Автосинхронизация реальных остатков и защита от перепродажи при новых заказах.",
  "shopee.workspace.overview.mapping-action": "Привязать SKU сейчас",
  "shopee.workspace.overview.health-title": "Работоспособность синхронизации и подключения Shopee",
  "shopee.workspace.overview.last-sync": "Последняя синхронизация:",
  "shopee.workspace.overview.sparkline-label": "Статус подключения в реальном времени",
  "shopee.workspace.overview.oauth-label": "OAuth-токен:",
  "shopee.workspace.overview.oauth-valid": "Действителен",
  "shopee.workspace.overview.oauth-invalid": "Истёк",
  "shopee.workspace.overview.api-label": "Работоспособность API:",
  "shopee.workspace.overview.api-good": "Хорошо (норма)",
  "shopee.workspace.overview.api-bad": "Требует проверки",
  "shopee.workspace.overview.issues-title": "Центр проблем",
  "shopee.workspace.overview.manage-connections": "Управление подключениями",
  "shopee.workspace.overview.channels-title": "Каналы продаж",
  "shopee.workspace.overview.channel-active": "Активен",
  "shopee.workspace.overview.channel-error": "Ошибка подключения",
  "shopee.workspace.overview.new-orders-colon": "Новые заказы:",
  "shopee.workspace.overview.no-shops": "Подключённых магазинов пока нет",
  "shopee.workspace.overview.connect-more": "Подключить ещё канал продаж",
  "shopee.workspace.overview.view-logs": "Открыть журнал",
  "shopee.workspace.overview.activity-title": "Недавняя активность синхронизации",
  "shopee.workspace.overview.no-activity": "Недавних записей активности пока нет",
  "shopee.workspace.overview.top-products": "Топ продаваемых товаров",
  "shopee.workspace.overview.top-products-note": "по количеству заказов",
  "shopee.workspace.overview.top-period": "Статистика за 7 дней",
  "shopee.workspace.overview.product-unknown": "Товар не определён",
  "shopee.workspace.overview.sold-count": "{count} заказов",
  "shopee.workspace.overview.no-products": "Данных о товарах пока нет",
  "shopee.workspace.overview.revenue-title": "Выручка по каналам",
  "shopee.workspace.overview.revenue-period": "Выручка за 7 дней",
  "shopee.workspace.overview.revenue-total-aria": "Общая выручка {amount}",
  "shopee.workspace.overview.total-revenue": "Общая выручка",
  "shopee.workspace.error.no-response": "Запрос к Shopee не получил ответа. Проверьте Redis и Shopee worker, затем повторите попытку.",
  "shopee.workspace.error.load-failed": "Не удалось загрузить данные Shopee",
  "shopee.workspace.notice.job-completed": "Задача Shopee завершена",
  "shopee.workspace.notice.job-ended-status": "Задача Shopee завершилась со статусом {status}",
  "shopee.workspace.notice.job-status-updated": "Задача {status}",
  "shopee.workspace.notice.job-status-default": "обновлена",
  "shopee.workspace.notice.new-order": "Получен новый заказ от Shopee",
  "shopee.workspace.notice.action-queued": "Задача поставлена в очередь",
  "shopee.workspace.notice.action-success": "Успешно обновлено",
  "shopee.workspace.common.back": "Назад",
  "shopee.workspace.common.next-step": "Далее",
  "shopee.workspace.connections.title": "Каналы продаж и подключённые магазины",
  "shopee.workspace.connections.subtitle": "Управление OAuth-авторизацией, политиками синхронизации и подключениями магазинов Shopee",
  "shopee.workspace.connections.add-shop-wizard": "Добавить новый магазин Shopee (мастер из 6 шагов)",
  "shopee.workspace.connections.status-active": "АКТИВЕН",
  "shopee.workspace.connections.region-id": "Регион: {region} | ID магазина: {shopId}",
  "shopee.workspace.connections.scopes-label": "Авторизованные разрешения:",
  "shopee.workspace.connections.scope.orders": "Заказы",
  "shopee.workspace.connections.scope.catalog": "Каталог",
  "shopee.workspace.connections.scope.stock": "Остатки",
  "shopee.workspace.connections.scope.finance": "Финансы",
  "shopee.workspace.connections.scope.return": "Возвраты",
  "shopee.workspace.connections.last-sync-colon": "Последняя синхронизация:",
  "shopee.workspace.connections.reauth-title": "Переавторизовать",
  "shopee.workspace.connections.reauth": "Повторить OAuth",
  "shopee.workspace.connections.disconnect-title": "Отключить",
  "shopee.workspace.connections.disconnected-notice": "Магазин {shop} отключён",
  "shopee.workspace.connections.disconnect-btn": "Отключить",
  "shopee.workspace.connections.empty": "Подключённых магазинов Shopee пока нет.",
  "shopee.workspace.connections.connect-new": "+ Подключить новый магазин Shopee",
  "shopee.workspace.connections.wizard.title": "Мастер подключения и активации магазина Shopee (шаг {step}/6)",
  "shopee.workspace.connections.wizard.step1-title": "Шаг 1: Подключение и авторизация OAuth в Shopee",
  "shopee.workspace.connections.wizard.step1-desc": "Вы будете перенаправлены на официальный шлюз авторизации Shopee Partner Platform для входа в магазин.",
  "shopee.workspace.connections.wizard.step1-permissions": "Доступ включает:",
  "shopee.workspace.connections.wizard.step1-permissions-detail": "Чтение/запись заказов, синхронизацию каталога, обновление остатков и историю расчётов.",
  "shopee.workspace.connections.wizard.open-oauth": "Перейти на страницу входа и авторизации Shopee",
  "shopee.workspace.connections.wizard.step2-title": "Шаг 2: Выбор первичного импорта данных",
  "shopee.workspace.connections.wizard.step2-desc": "Выберите типы данных для импорта из Shopee в VMASS:",
  "shopee.workspace.connections.wizard.step2-products": "Все товары и варианты из Shopee",
  "shopee.workspace.connections.wizard.step2-orders": "Заказы за последние 30 дней",
  "shopee.workspace.connections.wizard.step2-logistics": "Адрес забора и логистические партнёры",
  "shopee.workspace.connections.wizard.step3-title": "Шаг 3: Определение источника правды (Source of Truth)",
  "shopee.workspace.connections.wizard.step3-desc": "Источник правды определяет, какая система управляет эталонным количеством остатков:",
  "shopee.workspace.connections.wizard.step3-vmass-strong": "VMASS как источник правды (рекомендуется):",
  "shopee.workspace.connections.wizard.step3-vmass-desc": "Остатки VMASS автоматически отправляются в Shopee после обработки заказов.",
  "shopee.workspace.connections.wizard.step3-shopee-strong": "Shopee как первоначальный источник:",
  "shopee.workspace.connections.wizard.step3-shopee-desc": "Текущие остатки Shopee используются как база для первой синхронизации.",
  "shopee.workspace.connections.wizard.step4-title": "Шаг 4: Проверка привязки SKU",
  "shopee.workspace.connections.wizard.step4-info": "85% SKU Shopeе полностью совпадают со SKU склада VMASS. Эти SKU будут привязаны автоматически.",
  "shopee.workspace.connections.wizard.step4-note": "Непривязанные SKU можно управлять на вкладке «Привязка товаров» после активации.",
  "shopee.workspace.connections.wizard.step5-title": "Шаг 5: Настройка политики остатков и цен",
  "shopee.workspace.connections.wizard.allocation-label": "Режим распределения остатков",
  "shopee.workspace.connections.wizard.option-shared": "SHARED (общий доступ ко всем продаваемым остаткам)",
  "shopee.workspace.connections.wizard.option-allocated": "ALLOCATED (выделенная квота)",
  "shopee.workspace.connections.wizard.option-percentage": "PERCENTAGE (распределение по процентам)",
  "shopee.workspace.connections.wizard.safety-buffer-label": "Страховой запас (Safety Buffer)",
  "shopee.workspace.connections.wizard.safety-buffer-hint": "Предотвращает перепродажу при продажах на нескольких каналах.",
  "shopee.workspace.connections.wizard.step6-title": "Шаг 6: Проверка и активация магазина",
  "shopee.workspace.connections.wizard.step6-ready-strong": "Готово к активации!",
  "shopee.workspace.connections.wizard.step6-ready-detail": "Все настройки корректны, критических конфликтов нет.",
  "shopee.workspace.connections.wizard.check-oauth": "✔ Авторизовано через Shopee Partner API v2",
  "shopee.workspace.connections.wizard.check-sot": "✔ Источник правды: {value}",
  "shopee.workspace.connections.wizard.check-stock-mode": "✔ Режим остатков: {mode} (страховой запас: {buffer})",
  "shopee.workspace.connections.wizard.opening-shopee": "Открываем портал Shopee...",
  "shopee.workspace.connections.wizard.connect-now": "Подключить OAuth Shopee сейчас",
  "shopee.workspace.connections.wizard.activate-done": "Новый магазин Shopee успешно активирован",
  "shopee.workspace.connections.wizard.activate-now": "Активировать магазин сейчас",
  "shopee.workspace.inventory.status.unknown": "Недостаточно данных",
  "shopee.workspace.inventory.status.unmapped": "Без привязки к VMASS",
  "shopee.workspace.inventory.status.error": "Ошибка синхронизации",
  "shopee.workspace.inventory.status.out-of-stock": "Нет в наличии на Shopee",
  "shopee.workspace.inventory.status.variance": "Расхождение",
  "shopee.workspace.inventory.status.synced": "Синхронизировано",
  "shopee.workspace.inventory.no-name": "Shopee не предоставляет название товара",
  "shopee.workspace.inventory.sub.on-page": "На текущей странице",
  "shopee.workspace.inventory.sub.by-filter": "По текущему фильтру",
  "shopee.workspace.inventory.sub.from-loaded-mappings": "По загруженным данным привязки",
  "shopee.workspace.inventory.kpi.total": "Всего привязок Shopee",
  "shopee.workspace.inventory.kpi.synced-sub": "Из {count} загруженных строк",
  "shopee.workspace.inventory.kpi.variance": "Расхождение остатков",
  "shopee.workspace.inventory.kpi.errors-sub": "{count} ошибок синхронизации",
  "shopee.workspace.inventory.kpi.last-sync": "Последнее обновление",
  "shopee.workspace.inventory.col.vmass-stock": "Остаток VMASS",
  "shopee.workspace.inventory.col.total": "Всего",
  "shopee.workspace.inventory.col.diff-formula": "Shopee - VMASS",
  "shopee.workspace.inventory.col.condition": "Состояние",
  "shopee.workspace.inventory.col.updated": "Обновлено",
  "shopee.workspace.inventory.col.last": "Последний раз",
  "shopee.workspace.inventory.img-placeholder-aria": "Нет изображения товара",
  "shopee.workspace.inventory.title": "Остатки Shopee",
  "shopee.workspace.inventory.subtitle": "Сравнение продаваемых остатков VMASS с синхронизированным каталогом Shopee.",
  "shopee.workspace.inventory.manage-mapping": "Управлять привязкой товаров",
  "shopee.workspace.inventory.search-placeholder": "Поиск товаров или SKU Shopee...",
  "shopee.workspace.inventory.filter.all": "Все состояния",
  "shopee.workspace.inventory.shop-colon": "Магазин:",
  "shopee.workspace.inventory.no-shop-selected": "Магазин не выбран",
  "shopee.workspace.inventory.loading": "Загрузка данных Shopee...",
  "shopee.workspace.inventory.empty": "Привязок Shopee, соответствующих фильтру, нет.",
  "shopee.workspace.inventory.pagination-summary": "Показано {from} - {to} из {total} привязок Shopee",
  "shopee.workspace.inventory.side.overview-title": "Обзор остатков",
  "shopee.workspace.inventory.legend.filtered": "Привязок по фильтру",
  "shopee.workspace.inventory.legend.synced-page": "Синхронизировано на странице",
  "shopee.workspace.inventory.legend.variance-page": "С расхождениями на странице",
  "shopee.workspace.inventory.side.top-variance": "Топ расхождений остатков",
  "shopee.workspace.inventory.side.no-variance": "В загруженных данных расхождений остатков нет.",
  "shopee.workspace.inventory.side.alerts-title": "Оповещения об остатках",
  "shopee.workspace.inventory.alert.out-of-stock": "{count} товаров нет в наличии на Shopee",
  "shopee.workspace.inventory.alert.variance": "{count} товаров с расхождением остатков",
  "shopee.workspace.inventory.alert.variance-desc": "Shopee отличается от VMASS",
  "shopee.workspace.inventory.alert.unmapped": "{count} товаров без привязки к VMASS",
  "shopee.workspace.inventory.alert.unmapped-desc": "Привяжите товары перед сравнением",
  "shopee.workspace.pricing.kpi.total": "Всего SKU",
  "shopee.workspace.pricing.kpi.synced": "Цены синхронизированы",
  "shopee.workspace.pricing.kpi.variance": "Расхождение цен",
  "shopee.workspace.pricing.kpi.pending": "Не обновлено",
  "shopee.workspace.pricing.kpi.pending-sub": "Нет цены Shopee или VMASS",
  "shopee.workspace.pricing.kpi.errors": "Ошибки цен",
  "shopee.workspace.pricing.subtitle": "Управляйте ценами товаров и синхронизируйте их между VMASS и каналами продаж",
  "shopee.workspace.pricing.search-placeholder": "Поиск по названию, SKU, штрихкоду...",
  "shopee.workspace.pricing.category.all": "Все категории",
  "shopee.workspace.pricing.category.fashion": "Одежда",
  "shopee.workspace.pricing.category.electronics": "Электроника",
  "shopee.workspace.pricing.category.food": "Продукты",
  "shopee.workspace.pricing.warehouse.main": "Основной склад",
  "shopee.workspace.pricing.warehouse.hanoi": "Склад Ханой",
  "shopee.workspace.pricing.warehouse.hcm": "Склад Хошимин",
  "shopee.workspace.pricing.pagination-summary": "Показано {from} - {to} из {total} товаров Shopee",
  "shopee.workspace.pricing.col.vmass-price": "Цена VMASS",
  "shopee.workspace.pricing.col.price-small": "Цена продажи",
  "shopee.workspace.pricing.col.diff-range": "Макс. - Мин.",
  "shopee.workspace.pricing.action.adjust-price": "Изменить цену",
  "shopee.workspace.pricing.action.sync-price-list": "Синхронизировать прайс-лист",
  "shopee.workspace.pricing.action.cancel-rule": "Отменить правило цены",
  "shopee.workspace.pricing.action.sync-price": "Синхронизировать цены",
  "shopee.workspace.pricing.action.batch-update": "Массовое обновление",
  "shopee.workspace.pricing.action.price-rules": "Правила цен",
  "shopee.workspace.pricing.alert.higher": "{count} товаров дороже",
  "shopee.workspace.pricing.alert.lower": "{count} товаров дешевле",
  "shopee.workspace.pricing.alert.unavailable": "{count} товаров без данных о цене",
  "shopee.workspace.pricing.alert.threshold-desc": "против VMASS > 10%",
  "shopee.workspace.pricing.sub.on-page-short": "На странице",
  "shopee.workspace.pricing.side.variance-title": "Обзор расхождений цен",
  "shopee.workspace.pricing.side.top-variance": "Топ расхождений цен",
  "shopee.workspace.pricing.side.no-variance": "В загруженных данных Shopeе расхождений цен нет.",
  "shopee.workspace.pricing.side.alerts-title": "Оповещения о ценах",
  "shopee.workspace.pricing.rule.title": "Конструктор правил цен по каналам",
  "shopee.workspace.pricing.rule.policy-mode": "Режим политики",
  "shopee.workspace.pricing.rule.option-direct": "Использовать цену VMASS напрямую",
  "shopee.workspace.pricing.rule.option-percent": "Процентная наценка",
  "shopee.workspace.pricing.rule.option-fixed": "Фиксированная наценка",
  "shopee.workspace.pricing.rule.option-cost-plus": "Себестоимость + расходы + маржа",
  "shopee.workspace.pricing.rule.markup-percent-label": "Наценка (%)",
  "shopee.workspace.pricing.rule.markup-amount-label": "Фиксированная надбавка (VND)",
  "shopee.workspace.pricing.rule.fee-label": "Ожидаемая комиссия канала (%)",
  "shopee.workspace.pricing.rule.packaging-label": "Стоимость упаковки (VND)",
  "shopee.workspace.pricing.rule.rounding-label": "Правило округления",
  "shopee.workspace.pricing.rule.rounding-none": "Без округления",
  "shopee.workspace.pricing.rule.rounding-thousand": "До тысяч (.000)",
  "shopee.workspace.pricing.rule.rounding-nine-thousand": "Окончание 9.000 (.9.000)",
  "shopee.workspace.pricing.rule.formula-strong": "Применяемая формула:",
  "shopee.workspace.pricing.rule.formula-text": "Цена канала = [Цена VMASS + фиксированный сбор] / (1 - % комиссии канала) -> округление.",
  "shopee.workspace.pricing.rule.preview-no-base": "В загруженных данных Shopeе нет цены VMASS для предпросмотра.",
  "shopee.workspace.pricing.rule.preview-from": "Предпросмотр от цены VMASS {base}: {result}",
  "shopee.workspace.pricing.rule.save-preview": "Сохранить правило и предпросмотр",
  "shopee.workspace.pricing.approve.title": "Подтверждение утверждения и отправки массового прайс-листа в Shopee",
  "shopee.workspace.pricing.approve.warning-strong": "Предупреждение безопасности:",
  "shopee.workspace.pricing.approve.warning-detail": "Это действие применит новое правило цен и синхронизирует прайс-лист с Shopee.",
  "shopee.workspace.pricing.approve.items-total": "Всего позиций",
  "shopee.workspace.pricing.approve.rule-applied": "Применённое правило",
  "shopee.workspace.pricing.approve.fee-deducted": "Комиссия канала к удержанию",
  "shopee.workspace.pricing.approve.queued": "Запущена задача массового обновления прайс-листа для Shopee",
  "shopee.workspace.pricing.approve.confirm": "Утвердить и обновить цены",
  "shopee.workspace.mapping.model-simple": "Простой товар",
  "shopee.workspace.mapping.draft-created-from-listing": "Товар VMASS создан из листинга Shopee",
  "shopee.workspace.mapping.no-provider-data": "Shopee не предоставляет данных",
  "shopee.workspace.mapping.tooltip-full": "SKU {sku} · Цена {price} · Остаток {stock}",
  "shopee.workspace.mapping.tooltip-price-stock": "Цена {price} · Остаток {stock}",
  "shopee.workspace.mapping.stock-colon": "Остаток:",
  "shopee.workspace.mapping.price-label": "Цена",
  "shopee.workspace.mapping.col.vmass-product": "Товар в VMASS",
  "shopee.workspace.mapping.col.mapping": "Привязка",
  "shopee.workspace.mapping.pick-product-aria": "Выбрать товар VMASS для привязки",
  "shopee.workspace.mapping.no-mapping-permission": "У вас нет прав на привязку товаров",
  "shopee.workspace.common.pick-product": "Выбрать товар",
  "shopee.workspace.common.retry": "Повторить",
  "shopee.workspace.common.yes": "Да",
  "shopee.workspace.common.no": "Нет",
  "shopee.workspace.mapping.state-conflict": "Конфликт",
  "shopee.workspace.mapping.auto-map-launched": "Запущена автопривязка {count} привязок Shopee",
  "shopee.workspace.mapping.inventory-sync-queued": "Синхронизация остатков товара Shopeе запланирована",
  "shopee.workspace.mapping.no-shop-selected": "Магазин Shopee не выбран. Подключите или выберите магазин, чтобы загрузить реальные данные привязки.",
  "shopee.workspace.mapping.kpi.total-sub": "{count} строк привязки из API",
  "shopee.workspace.mapping.kpi.rate-page": "{percent}% на текущей странице",
  "shopee.workspace.mapping.kpi.rate": "Доля привязок",
  "shopee.workspace.mapping.search-placeholder": "Поиск по SKU, штрихкоду, названию...",
  "shopee.workspace.mapping.title": "Привязки Shopee",
  "shopee.workspace.mapping.data-scope-banner": "Данные магазина {shop}; показатели статусов рассчитаны по текущей странице.",
  "shopee.workspace.mapping.shop-unselected": "не выбран",
  "shopee.workspace.mapping.loading": "Загрузка данных привязки из Shopee...",
  "shopee.workspace.mapping.empty": "Shopee не вернул привязки, соответствующие магазину и текущему фильтру.",
  "shopee.workspace.mapping.detail-title": "Детали привязки",
  "shopee.workspace.mapping.tab-info": "Инфо",
  "shopee.workspace.mapping.tab-history": "История",
  "shopee.workspace.mapping.status.disabled": "Синхронизация отключена",
  "shopee.workspace.mapping.status.error": "Ошибка синхронизации",
  "shopee.workspace.mapping.status.healthy": "В норме",
  "shopee.workspace.mapping.status.mapping-required": "Без привязки",
  "shopee.workspace.mapping.status.out-of-stock": "Нет в наличии",
  "shopee.workspace.mapping.section-vmass": "Данные VMASS",
  "shopee.workspace.mapping.section-shopee": "Данные Shopee",
  "shopee.workspace.mapping.available-stock": "Доступный остаток",
  "shopee.workspace.mapping.shopee-name-colon": "Название на Shopee:",
  "shopee.workspace.mapping.not-linked": "Не привязано к каналу Shopee",
  "shopee.workspace.mapping.sync-enabled-colon": "Синхронизация разрешена:",
  "shopee.workspace.mapping.auto-map-this": "Автопривязать этот SKU",
  "shopee.workspace.mapping.change": "Изменить привязку",
  "shopee.workspace.mapping.remove": "Убрать привязку",
  "shopee.workspace.mapping.history-created": "Привязка создана:",
  "shopee.workspace.mapping.history-updated": "Привязка обновлена:",
  "shopee.workspace.mapping.history-last-sync": "Последняя синхронизация с Shopee:",
  "shopee.workspace.mapping.sync-stock-to-shopee": "Синхронизировать остатки в Shopee",
  "shopee.workspace.mapping.modal-title": "Выберите товар VMASS для привязки",
  "shopee.workspace.mapping.candidate-search-placeholder": "Поиск по названию, SKU или штрихкоду VMASS",
  "shopee.workspace.mapping.candidates-loading": "Загрузка товаров VMASS...",
  "shopee.workspace.mapping.choose-product": "Выбрать товар VMASS",
  "shopee.workspace.mapping.nameless-product": "Товар без названия",
  "shopee.workspace.mapping.choose-variant": "Выбрать вариант VMASS",
  "shopee.workspace.mapping.no-variants-note": "У этого товара VMASS нет вариантов; привязка использует остаток базового товара.",
  "shopee.workspace.mapping.no-candidates": "Подходящих товаров VMASS по поиску нет.",
  "shopee.workspace.mapping.create-product": "Создать новый товар",
  "shopee.workspace.mapping.save": "Сохранить привязку",
  "shopee.workspace.mapping.auto-map-selected": "Автопривязать выбранные ({count})",
  "einvoice.filter.issuance-status": "Статус выпуска",
  "einvoice.filter.invoice-status": "Статус счета",
  "einvoice.filter.all": "Все",
  "einvoice.issuance-status.pending": "В обработке",
  "einvoice.issuance-status.success": "Успешно",
  "einvoice.issuance-status.failed": "Ошибка",
  "einvoice.invoice-status.draft": "Черновик",
  "einvoice.invoice-status.issued": "Выписан",
  "template.badge": "Демо-данные",
  "template.convert": "Преобразовать в реальные данные",
  "product.btn-update": "Обновить товар",
  "template.profile.title": "Обучающие демо-данные",
  "template.profile.description": "Демо-товары и ингредиенты помогают изучить систему. Вы можете скрыть или включить их снова при необходимости.",
  "template.profile.dismiss": "Скрыть демо-данные",
  "template.profile.show": "Показать демо-данные",
  "template.profile.confirm": "Демо-данные и созданные из них заказы будут скрыты, а использованные демо-запасы восстановлены. Продолжить?",
  "template.profile.show-confirm": "Вы уверены, что хотите снова отобразить демонстрационные данные?",
  "template.profile.success": "Демо-данные успешно скрыты",
  "template.profile.show-success": "Демо-данные успешно отображены!",
  "shopee.workspace.shipping.customer-fallback": "Клиент {number}",
  "shopee.workspace.shipping.product-fallback": "Товар Shopee",
  "shopee.workspace.shipping.service-standard": "Стандартная доставка",
  "shopee.workspace.shipping.status.ready-pickup": "Ожидает забора",
  "shopee.workspace.shipping.status.processing": "В обработке",
  "shopee.workspace.shipping.checklist.inspect": "Проверка товаров",
  "shopee.workspace.shipping.checklist.protect": "Защитная упаковка",
  "shopee.workspace.shipping.col.order-sub": "Код заказа | Канал",
  "shopee.workspace.shipping.col.phone-sub": "Телефон",
  "shopee.workspace.shipping.col.amount": "Стоимость товаров",
  "shopee.workspace.shipping.col.progress-sub": "Прогресс",
  "shopee.workspace.shipping.print-slip-title": "Печать квитанции",
  "shopee.workspace.shipping.alert.print-slip": "ПечатьDelivery-квитанции по заказу {sn}",
  "shopee.workspace.shipping.alert.update-status": "Обновить статус заказа {sn}",
  "shopee.workspace.shipping.action.update-status": "Обновить статус",
  "shopee.workspace.shipping.alert.cancel-order": "Отменить заказ {sn}",
  "shopee.workspace.shipping.action.cancel-order": "Отменить заказ",
  "shopee.workspace.shipping.subtitle": "Управляйте обработкой, упаковкой и доставкой заказов по всем каналам.",
  "shopee.workspace.shipping.create-shipping-order": "Создать заказ на доставку",
  "shopee.workspace.shipping.alert.print-labels-bulk": "Массовая печать этикеток",
  "shopee.workspace.shipping.action.print-bulk": "Массовая печать",
  "shopee.workspace.shipping.alert.export-excel": "Экспорт списка в Excel",
  "shopee.workspace.shipping.alert.syncing-orders": "Синхронизация новых заказов с площадок...",
  "shopee.workspace.shipping.kpi.overdue": "{count} просроченных заказов",
  "shopee.workspace.shipping.kpi.packing": "Упаковывается",
  "shopee.workspace.shipping.kpi.packing-sub": "1 выполняется",
  "shopee.workspace.shipping.kpi.pickup-today": "Забор сегодня",
  "shopee.workspace.shipping.kpi.handover": "Передано перевозчику",
  "shopee.workspace.shipping.kpi.shipping": "Доставляется",
  "shopee.workspace.shipping.kpi.shipping-sub": "В пути",
  "shopee.workspace.shipping.step.delivered": "Завершено",
  "shopee.workspace.shipping.step.picking": "Комплектация",
  "shopee.workspace.shipping.action.print-label": "Печать трек-этикетки",
  "shopee.workspace.shipping.search-placeholder": "Поиск по коду, имени, телефону...",
  "shopee.workspace.shipping.filter.all-carriers": "Все перевозчики",
  "shopee.workspace.common.yesterday": "Вчера",
  "shopee.workspace.common.this-month": "Этот месяц",
  "shopee.workspace.shipping.pagination-summary": "Показано 1 - {count} из {total} заказов",
  "shopee.workspace.shipping.perf.performance-today": "Производительность за сегодня",
  "shopee.workspace.shipping.perf.updated-at": "Обновлено в 10:30",
  "shopee.workspace.shipping.perf.processed": "Обработано",
  "shopee.workspace.shipping.perf.orders-value": "{count} заказов",
  "shopee.workspace.shipping.perf.on-time": "В срок",
  "shopee.workspace.shipping.perf.overdue": "Просрочено",
  "shopee.workspace.shipping.perf.success-rate": "Доля успешных доставок",
  "shopee.workspace.shipping.perf.returns": "Возвраты",
  "shopee.workspace.shipping.perf.top-carriers": "Топ перевозчиков",
  "shopee.workspace.shipping.alert.close-detail": "Закрыть панель деталей",
  "shopee.workspace.shipping.section-customer": "Информация о клиенте",
  "shopee.workspace.shipping.title.call": "Позвонить",
  "shopee.workspace.shipping.alert.call": "Позвонить: {phone}",
  "shopee.workspace.shipping.title.address": "Посмотреть адрес",
  "shopee.workspace.shipping.section-products": "Товары ({count})",
  "shopee.workspace.shipping.section-shipping-info": "Информация о доставке",
  "shopee.workspace.shipping.col.carrier": "Перевозчик",
  "shopee.workspace.shipping.title.copy-code": "Копировать код",
  "shopee.workspace.shipping.alert.copied": "Скопировано: {code}",
  "shopee.workspace.shipping.col.service": "Сервис",
  "shopee.workspace.shipping.col.shipping-fee": "Стоимость доставки",
  "shopee.workspace.shipping.col.cod": "Наложенный платёж (COD)",
  "shopee.workspace.shipping.col.total-collect": "Итого к получению",
  "shopee.workspace.shipping.checklist-title": "Чек-лист упаковки",
  "shopee.workspace.shipping.alert.print-label": "Печать этикетки для {sn}",
  "shopee.workspace.shipping.action.print-slip": "Печать накладной",
  "shopee.workspace.shipping.alert.print-slip-order": "Печать накладной для {sn}",
  "shopee.workspace.shipping.action.packed-done": "Упаковано",
  "shopee.workspace.shipping.notice.packed-handover": "Упаковка завершена; статус изменён на «Ожидает передачи»",
  "shopee.workspace.shipping.alert.packed-done": "Упаковка заказа {sn} завершена",
  "shopee.workspace.shipping.action.complete-handover": "Завершить и передать в ожидание передачи",
  "shopee.workspace.shipping.action.report-shortage": "Сообщить о недостаче",
  "shopee.workspace.shipping.action.delay-packing": "Отложить упаковку",
  "shopee.workspace.shipping.scan.title": "Станция упаковки - Сканируйте код заказа",
  "shopee.workspace.shipping.scan.desc": "Отсканируйте штрихкод или введите трек-/номер заказа Shopee для сверки и мгновенной печати этикеток:",
  "shopee.workspace.shipping.scan.label": "Код заказа / Трек-код",
  "shopee.workspace.shipping.scan.placeholder": "Например: SP24072201 или GHN1234567890...",
  "shopee.workspace.shipping.alert.not-found": "Заказ с кодом не найден: {code}",
  "shopee.workspace.shipping.scan.now": "Сканировать",
  "shopee.workspace.finance.channel-pos": "POS - Магазин",
  "shopee.workspace.finance.status.paid": "Оплачено",
  "shopee.workspace.finance.status.pending-payment": "Ожидает оплаты",
  "shopee.workspace.finance.status.discrepancy": "Расхождение",
  "shopee.workspace.finance.status.dispute": "Спор",
  "shopee.workspace.finance.bank-encrypted": "Зашифрованный счёт",
  "shopee.workspace.finance.payout.transferred": "Переведено",
  "shopee.workspace.finance.payout.processing": "В обработке",
  "shopee.workspace.finance.sync-queued": "Синхронизация сверки запланирована",
  "shopee.workspace.finance.subtitle": "Отслеживайте, сверяйте и управляйте платежами со всех каналов продаж",
  "shopee.workspace.finance.forecast": "Прогноз поступлений",
  "shopee.workspace.finance.export-report": "Экспорт отчёта",
  "shopee.workspace.finance.action.sync": "Синхронизировать сверку",
  "shopee.workspace.finance.kpi.revenue": "Выручка",
  "shopee.workspace.finance.kpi.vs-prev-period": "к предыдущему периоду",
  "shopee.workspace.finance.kpi.pending-reconciliation": "Ожидает сверки",
  "shopee.workspace.finance.kpi.holding": "Удерживается",
  "shopee.workspace.finance.kpi.refund": "Возмещения",
  "shopee.workspace.finance.kpi.fees": "Комиссии и удержания",
  "shopee.workspace.finance.cashflow-title": "Денежный поток",
  "shopee.workspace.finance.net-received": "Получено нетто",
  "shopee.workspace.finance.forecast.tomorrow": "Завтра",
  "shopee.workspace.finance.forecast.next-3-days": "Следующие 3 дня",
  "shopee.workspace.finance.forecast.next-week": "Следующая неделя",
  "shopee.workspace.finance.forecast.view-detail": "Подробнее о прогнозе →",
  "shopee.workspace.finance.filter.all-banks": "Все банковские счета",
  "shopee.workspace.finance.col.sn": "Код сверки",
  "shopee.workspace.finance.col.period": "Период сверки",
  "shopee.workspace.finance.col.order-count": "Заказы",
  "shopee.workspace.finance.col.payout-date": "Дата выплаты",
  "shopee.workspace.finance.action.export-excel-file": "Экспорт в Excel",
  "shopee.workspace.finance.detail-title": "Детали сверки",
  "shopee.workspace.finance.meta.period": "Период сверки:",
  "shopee.workspace.finance.meta.payout-date": "Дата выплаты:",
  "shopee.workspace.finance.meta.bank-account": "Счёт получателя:",
  "shopee.workspace.finance.meta.transaction-code": "Код транзакции:",
  "shopee.workspace.finance.meta.status": "Статус:",
  "shopee.workspace.finance.tab-orders": "Детали заказов ({count})",
  "shopee.workspace.finance.bd.gross-revenue": "Общая выручка",
  "shopee.workspace.finance.bd.platform-deduction": "Удержания площадки ^",
  "shopee.workspace.finance.bd.voucher": "Купоны площадки",
  "shopee.workspace.finance.bd.shipping-buyer": "Доставка (оплачивает покупатель)",
  "shopee.workspace.finance.bd.seller-discount": "Скидки площадки",
  "shopee.workspace.finance.bd.payment-fee": "Комиссия за оплату",
  "shopee.workspace.finance.bd.service-fee": "Сервисный сбор",
  "shopee.workspace.finance.bd.tax": "Налоги",
  "shopee.workspace.finance.bd.refunds": "Возмещения / Возвраты ^",
  "shopee.workspace.finance.bd.refund-fee": "Комиссия за возврат",
  "shopee.workspace.finance.bd.other-deductions": "Прочие удержания",
  "shopee.workspace.finance.action.view-documents": "Посмотреть документы сверки",
  "shopee.workspace.finance.action.download-statement": "Скачать ведомость сверки",
  "shopee.workspace.finance.discrepancy.alert": "Требует проверки расхождение:",
  "shopee.workspace.finance.discrepancy.desc": "{count} заказов имеют расхождения между VMASS и площадкой.",
  "shopee.workspace.finance.widget.success-rate": "Доля успешных сверок",
  "shopee.workspace.finance.legend.success": "Успешно:",
  "shopee.workspace.finance.legend.failed": "Неудачно:",
  "shopee.workspace.finance.widget.top-revenue-channels": "Каналы с наибольшей выручкой",
  "shopee.workspace.finance.channel-others": "Другие",
  "shopee.workspace.finance.widget.popular-refund-reasons": "Частые причины возмещений",
  "shopee.workspace.finance.reason.wrong-color": "Неверный цвет/оттенок:",
  "shopee.workspace.finance.reason.wrong-size": "Не подошёл размер:",
  "shopee.workspace.finance.reason.defect": "Брак товара:",
  "shopee.workspace.finance.reason.not-liked": "Не понравилось:",
  "shopee.workspace.finance.insight.unpaid-orders": "У вас {count} заказов Shopee, доставленных более 10 дней назад без выплаты.",
  "shopee.workspace.finance.insight.transfer-tomorrow": "Shopee переведёт около 42 миллионов завтра ({date}).",
  "shopee.workspace.finance.insight.fee-increase": "Стоимость доставки TikTok Shop выросла на {percent} по сравнению с прошлым месяцем.",
  "shopee.workspace.finance.insight.view-more": "Ещё аналитика →",
  "shopee.workspace.issues.channel-other": "Другой канал",
  "shopee.workspace.common.order-hash": "Заказ",
  "shopee.workspace.common.product-hash": "Товар",
  "shopee.workspace.tab.shipping-short": "Доставка",
  "shopee.workspace.issues.subtitle": "Отслеживайте и устраняйте проблемы подключения, синхронизации и системы",
  "shopee.workspace.issues.severity.critical": "Критический",
  "shopee.workspace.issues.severity.high": "Высокий",
  "shopee.workspace.issues.severity.medium": "Средний",
  "shopee.workspace.issues.severity.low": "Низкий",
  "shopee.workspace.issues.status.unresolved": "Не обработано",
  "shopee.workspace.issues.status.in-progress": "В процессе",
  "shopee.workspace.issues.status.waiting": "Ожидает",
  "shopee.workspace.issues.status.resolved": "Решено",
  "shopee.workspace.issues.status.ignored": "Игнорируется",
  "shopee.workspace.issues.type.order-sync": "Синхронизация заказов",
  "shopee.workspace.issues.type.product-sync": "Синхронизация товаров",
  "shopee.workspace.issues.type.system-task": "Системная задача",
  "shopee.workspace.issues.type.system": "Система",
  "shopee.workspace.issues.type.stock-sync": "Синхронизация остатков",
  "shopee.workspace.issues.type.api-connection": "Подключение API",
  "shopee.workspace.issues.type.payment": "Оплата",
  "shopee.workspace.issues.filter.all-types": "Все типы",
  "shopee.workspace.issues.filter.all-severities": "Все уровни",
  "shopee.workspace.issues.error.order-sync": "Ошибка синхронизации заказов",
  "shopee.workspace.issues.error.check-order-status": "Проверьте статус заказа",
  "shopee.workspace.issues.error.sku-mapping": "Ошибка привязки SKU",
  "shopee.workspace.issues.error.sku-unmapped": "SKU не привязан к VMASS или ошибка синхронизации остатков",
  "shopee.workspace.issues.error.job-ended-status": "Задача завершилась со статусом {status}",
  "shopee.workspace.issues.error.retried-times": "Повторных попыток: {count}",
  "shopee.workspace.issues.action.process-label": "Обработать проблему {id}",
  "shopee.workspace.issues.action.process-now": "Обработать сейчас",
  "shopee.workspace.issues.action.ignore-label": "Игнорировать проблему {id}",
  "shopee.workspace.issues.action.ignore": "Игнорировать",
  "shopee.workspace.issues.action.mark-resolved": "Отметить как решённое",
  "shopee.workspace.issues.empty": "Подходящих данных о проблемах не найдено",
  "shopee.workspace.issues.pagination-of": "из {total} проблем",
  "shopee.workspace.issues.total-errors": "Всего проблем",
  "shopee.workspace.issues.chart.by-channel": "Проблемы по каналам",
  "shopee.workspace.issues.chart.by-type": "Проблемы по типам",
  "shopee.workspace.issues.chart.by-severity": "Проблемы по важности",
  "shopee.workspace.issues.chart.timeline": "Динамика проблем",
  "shopee.workspace.issues.chart.top-errors": "Топ проблем",
  "shopee.workspace.issues.times-count": "{count} раз",
  "shopee.workspace.issues.top.order-list": "Не удалось получить список заказов",
  "shopee.workspace.issues.top.invalid-data": "Недопустимые данные",
  "shopee.workspace.issues.top.negative-stock": "Отрицательный остаток",
  "shopee.workspace.issues.top.payment-not-found": "Платёжная транзакция не найдена",
  "shopee.workspace.issues.activity.processed": "обработал проблему TikTok Shop - Синхронизация товаров",
  "shopee.workspace.issues.activity.resolved": "решил проблему",
  "shopee.workspace.issues.drawer.title": "Детали проблемы",
  "shopee.workspace.issues.drawer.info-title": "Информация о проблеме",
  "shopee.workspace.issues.drawer.error-code": "Код ошибки",
  "shopee.workspace.issues.drawer.request": "Запрос",
  "shopee.workspace.issues.drawer.request-detail": "Детали запроса",
  "shopee.workspace.issues.drawer.response-detail": "Детали ответа",
  "shopee.workspace.issues.drawer.impact-title": "Влияние",
  "shopee.workspace.issues.drawer.impact-orders": "Затронутые заказы",
  "shopee.workspace.issues.drawer.impact-products": "Затронутые товары",
  "shopee.workspace.issues.drawer.impact-revenue": "Затронутая выручка",
  "shopee.workspace.issues.drawer.suggestions-title": "Рекомендации",
  "shopee.workspace.issues.suggest.check-api": "Проверьте подключение к API Shopee",
  "shopee.workspace.issues.suggest.check-status": "Проверьте статус системы Shopee",
  "shopee.workspace.issues.suggest.retry-sync": "Повторите синхронизацию через несколько минут",
  "shopee.workspace.issues.suggest.contact-support": "Обратитесь в поддержку, если проблема сохраняется",
  "shopee.workspace.issues.drawer.note-title": "Внутренняя заметка",
  "shopee.workspace.issues.confirm.title": "Подтверждение обработки проблемы",
  "shopee.workspace.issues.confirm.desc": "Вы уверены, что хотите выполнить это действие?",
  "shopee.workspace.issues.confirm.items": "{label} ({count} элем.)",
  "shopee.workspace.issues.confirm.ok": "Подтвердить",
  "shopee.workspace.issues.confirm.queued": "Задача исправления поставлена в очередь",
  "shopee.workspace.issues.kpi.all": "Все проблемы",
  "shopee.workspace.issues.kpi.all-sub": "Всего обнаруженных проблем",
  "shopee.workspace.issues.kpi.unresolved-sub": "Требует немедленной проверки",
  "shopee.workspace.issues.kpi.in-progress": "Проблемы в работе",
  "shopee.workspace.issues.kpi.in-progress-sub": "Сейчас обрабатываются",
  "shopee.workspace.issues.kpi.resolved": "Решённые проблемы",
  "shopee.workspace.issues.kpi.resolved-sub": "Успешно исправлено",
  "shopee.workspace.issues.kpi.critical": "Критические проблемы",
  "shopee.workspace.issues.kpi.critical-sub": "Высокий и критический уровень",
  "shopee.workspace.issues.action.configure-alerts": "Настроить оповещения",
  "shopee.workspace.issues.action.system-logs": "Системные журналы",
  "shopee.workspace.issues.col.channel-source": "Канал / Источник",
  "shopee.workspace.issues.col.type": "Тип проблемы",
  "shopee.workspace.issues.col.severity": "Важность",
  "shopee.workspace.issues.col.object": "Объект",
  "shopee.workspace.issues.col.message": "Сообщение об ошибке",
  "shopee.workspace.listing.description-template": "{name} - Качественный товар",
  "shopee.workspace.listing.err.no-shop": "Магазин Shopee не выбран",
  "shopee.workspace.listing.err.no-product": "Товар VMASS не выбран",
  "shopee.workspace.listing.err.name-length": "Название товара должно быть от 5 до 120 символов",
  "shopee.workspace.listing.err.desc-length": "Описание должно содержать минимум 25 символов",
  "shopee.workspace.listing.err.price": "Цена должна быть больше 0",
  "shopee.workspace.listing.err.variant-price": "Цена каждого варианта должна быть больше 0",
  "shopee.workspace.listing.err.weight": "Вес должен быть от 0,01 до 50 кг",
  "shopee.workspace.listing.err.no-category": "Категория Shopee не выбрана",
  "shopee.workspace.listing.err.brand-load-failed": "Не удалось загрузить бренды Shopee",
  "shopee.workspace.listing.err.no-brand": "Бренд Shopee не выбран",
  "shopee.workspace.listing.err.no-logistics": "Канал доставки не выбран",
  "shopee.workspace.listing.err.missing-attribute": "Отсутствует атрибут: {attribute}",
  "shopee.workspace.listing.err.dimensions": "Все три размера должны быть заполнены и больше 0",
  "shopee.workspace.listing.update-queued": "Запрос на обновление листинга поставлен в очередь",
  "shopee.workspace.listing.publish-queued": "Товар поставлен в очередь на публикацию в Shopee",
  "shopee.workspace.listing.label.shop": "Магазин Shopee *",
  "shopee.workspace.listing.no-shops": "Нет доступных магазинов Shopee",
  "shopee.workspace.listing.primary-mark": "Основной",
  "shopee.workspace.listing.shop-hint": "Данные категорий, брендов и доставки загрузятся для выбранного магазина.",
  "shopee.workspace.listing.label.brand": "Бренд Shopee",
};

export default ruRu;
